(() => {
  // ===========================================================================
  // Vorwaermen fuer die Geschenk-App (506/EasyGift)
  // ===========================================================================
  // Warum das hier steht: Beim Klick auf "In den Warenkorb" fragt die Geschenk-App
  // eine Zeile je Palettenfarbe bei aca.506.io ab und haelt unsere eigene Anfrage
  // so lange auf. Gemessen sind das rund 2,2 Sekunden, die der Kunde wartet, bevor
  // Shopify die Bestellung ueberhaupt zu sehen bekommt.
  //
  // Ihr eigener Zwischenspeicher funktioniert einwandfrei und haelt 24 Stunden.
  // Nachgewiesen mit einem A/B am Live-Shop: mit gefuelltem Speicher null Abfragen
  // und die Anfrage geht nach 469 ms raus, mit geleertem 13 Abfragen und 2.653 ms.
  // Er wird nur zu spaet gefuellt, naemlich erst durch den Klick selbst. Waehrend
  // der Kunde eine Minute lang seine Palette baut, passiert dagegen nichts.
  // Genau diese Zeit nutzen wir.
  //
  // Es wird ausschliesslich in ihren eigenen Speicher geschrieben, im exakt
  // gleichen Format, das die App selbst erzeugt, inklusive ihrer eigenen
  // Preisumrechnung. Bei der kleinsten Abweichung wird nichts geschrieben und der
  // Klick ist nur wieder so langsam wie zuvor. Das Geschenkprogramm darf unter
  // keinen Umstaenden falsch rechnen, deshalb im Zweifel lieber langsam.
  const nbEgSchluessel = 'EASYGIFT_VARIANTS_INFO';
  const nbEgVersucht = new Set();
  let nbEgTimer = null;
  let nbEgLaeuft = false;
  let nbEgAus = false;

  function nbEgBereit() {
    return !nbEgAus
      && typeof localStorage !== 'undefined'
      && !!window.EasyGift
      && !!document.getElementById('easygift-rules')
      && !!(window.Shopify && Shopify.shop && Shopify.currency && Shopify.currency.active);
  }

  // Zeichengenau die Umrechnung der App (eg/script.js, Funktion jr mit
  // assumeDecimal). Aus "6.50" wird 650. Nicht selbst ausdenken: die
  // Geschenkschwellen haengen daran.
  function nbEgPreisWieApp(betrag) {
    const text = Number(betrag).toFixed(2).toString();
    const zahl = parseFloat(text.replace('.', ''));
    return (zahl % 1) ? zahl * 100 : zahl;
  }

  function nbEgRegeln() {
    try {
      const el = document.getElementById('easygift-rules');
      const roh = el.content || el.textContent || el.innerHTML;
      const geparst = JSON.parse(roh);
      return Array.isArray(geparst) ? geparst : Object.values(geparst);
    } catch (e) { return null; }
  }

  // Einmal ermitteln und merken. Das Dokument ist rund 1,3 MB gross, ein
  // Durchsuchen je Aufruf waere unnoetige Arbeit auf schwachen Geraeten.
  let nbEgLebensdauerGemerkt = null;
  function nbEgLebensdauerMin() {
    if (nbEgLebensdauerGemerkt !== null) return nbEgLebensdauerGemerkt;
    try {
      const treffer = document.documentElement.innerHTML
        .match(/customVariantsInfoLifetimeMins"?\s*:\s*(\d+)/);
      nbEgLebensdauerGemerkt = treffer ? parseInt(treffer[1], 10) : 1440;
    } catch (e) { nbEgLebensdauerGemerkt = 1440; }
    return nbEgLebensdauerGemerkt;
  }

  // Genau die Annahmepruefungen der App nachbilden. Ein Eintrag, den sie beim
  // Lesen verwerfen wuerde, darf nicht als "schon vorhanden" durchgehen, sonst
  // haelt der Waermer unbrauchbare Eintraege fuer erledigt und holt nichts nach.
  function nbEgEintragBrauchbar(eintrag) {
    if (!eintrag || !eintrag.value) return false;
    const zeit = new Date(eintrag.timestamp).getTime();
    if (isNaN(zeit) || zeit <= Date.now() - nbEgLebensdauerMin() * 60000) return false;
    const wert = eintrag.value;
    // Die App verwirft, wenn die aktive Waehrung nicht enthalten ist. Genau das
    // passiert nach einem Marktwechsel innerhalb derselben Sitzung.
    try {
      const waehrung = Shopify.currency.active;
      if (!wert.presentmentPrices || !Array.isArray(wert.presentmentPrices.edges)) return false;
      if (!wert.presentmentPrices.edges.some((e) => e && e.node && e.node.price
        && e.node.price.currencyCode === waehrung)) return false;
    } catch (e) { return false; }
    // Gibt es eine Regel auf Sammlungsbasis, verlangt die App vollstaendige Sammlungen.
    const regeln = nbEgRegeln();
    if (regeln && regeln.some((r) => r && r.trigger && r.trigger.type === 'collection')) {
      if (eintrag.collectionsComplete !== true) return false;
      const flach = Array.isArray(wert.collections);
      const verschachtelt = !!(wert.collections && Array.isArray(wert.collections.edges));
      if (!flach && !verschachtelt) return false;
    }
    return true;
  }

  function nbEgSpeicherLesen() {
    try {
      const roh = localStorage.getItem(nbEgSchluessel);
      const liste = roh ? JSON.parse(roh) : [];
      return Array.isArray(liste) ? liste : [];
    } catch (e) { return []; }
  }

  // Liegt schon ein Eintrag der App selbst vor, dient er als Vorlage: passt unser
  // Format nicht mehr zu ihrer laufenden Fassung, schalten wir uns fuer die
  // Sitzung ab, statt womoeglich Unsinn zu hinterlassen.
  function nbEgFormatGeprueft(liste) {
    const vorlage = liste.find((e) => e && e.value && e.timestamp);
    if (!vorlage) return true;
    const v = vorlage.value;
    // Bewusst nur das pruefen, was ihre Lesefunktion wirklich verlangt. Zu streng
    // waere hier schaedlich: Die App vergleicht die Kennung ueber String(), es ist
    // ihr also gleich, ob eine Zahl oder Zeichenkette dasteht. Und der Preis darf
    // gar kein Kriterium sein, denn Eintraege ohne passende Waehrung raeumt sie
    // selbst weg. Sonst schaltet sich der Waermer ausgerechnet bei wiederkehrenden
    // Kunden ab, deren Speicher die App schon einmal beschrieben hat.
    const kennung = typeof v.id === 'string' || typeof v.id === 'number';
    const passt = kennung && !!v.presentmentPrices && !!v.product;
    if (!passt) {
      nbEgAus = true;
      console.warn('[BYOP] Vorwaermen abgeschaltet: das Format der Geschenk-App passt nicht mehr zur erwarteten Form.');
    }
    return passt;
  }

  // Genau die Pruefungen nachbilden, die ihre Lesefunktion anstellt. Was sie
  // ohnehin verwerfen wuerde, schreiben wir gar nicht erst.
  function nbEgEintragBauen(antwort) {
    if (!antwort || typeof antwort !== 'object') return null;
    if (antwort.id === undefined || antwort.id === null) return null;
    if (!antwort.presentmentPrices || !Array.isArray(antwort.presentmentPrices.edges)) return null;
    if (!antwort.product) return null;

    const waehrung = Shopify.currency.active;
    const passenderPreis = antwort.presentmentPrices.edges
      .find((e) => e && e.node && e.node.price && e.node.price.currencyCode === waehrung);
    // Ohne die aktive Waehrung wirft die App den Eintrag beim Lesen weg.
    if (!passenderPreis) return null;

    const wert = Object.assign({}, antwort);
    wert.id = String(antwort.id);
    wert.price = nbEgPreisWieApp(passenderPreis.node.price.amount);

    const eintrag = { value: wert, timestamp: new Date().toISOString() };
    // Nur setzen, wenn die Sammlungen wirklich vollstaendig mitgeliefert wurden.
    // Sonst koennte eine Regel auf Sammlungsbasis falsch rechnen.
    // Beide Formen abdecken, die ihre Pruefung akzeptiert: entweder collections
    // als flache Liste, oder die verschachtelte edges-Form an beiden Stellen.
    // Liefe der Endpunkt eines Tages nur die edges-Form aus, wuerde sonst jeder
    // unserer Eintraege beim Lesen verworfen und der Waermer liefe ins Leere.
    const flach = Array.isArray(antwort.collections);
    const verschachtelt = !!(antwort.collections && Array.isArray(antwort.collections.edges)
      && antwort.product && antwort.product.collections
      && Array.isArray(antwort.product.collections.edges));
    if (flach || verschachtelt) eintrag.collectionsComplete = true;
    return eintrag;
  }

  function nbEgSpeichern(neueEintraege) {
    if (!neueEintraege.length) return;
    try {
      const alt = nbEgSpeicherLesen();
      if (!nbEgFormatGeprueft(alt)) return;
      const grenze = Date.now() - nbEgLebensdauerMin() * 60000;
      const neueIds = new Set(neueEintraege.map((e) => e.value.id));
      const behalten = alt.filter((e) => {
        if (!e || !e.value) return false;
        if (neueIds.has(String(e.value.id))) return false;
        const zeit = new Date(e.timestamp).getTime();
        return !isNaN(zeit) && zeit > grenze;
      });
      localStorage.setItem(nbEgSchluessel, JSON.stringify(behalten.concat(neueEintraege)));
    } catch (e) {
      // Speicher voll oder gesperrt: dann eben nicht.
      nbEgAus = true;
      console.warn('[BYOP] Vorwaermen abgeschaltet, Speicher nicht beschreibbar:', e && e.name);
    }
  }

  function nbEgOffeneIds(konfiguration) {
    const gebraucht = [];
    try {
      if (konfiguration._palette && konfiguration._palette.shopifyInfos) {
        gebraucht.push(String(konfiguration._palette.shopifyInfos.variantId));
      }
      (konfiguration._pans || []).forEach((platziert) => {
        const pan = platziert && platziert._pan;
        if (!pan || !pan.shopifyInfos || !pan.shopifyInfos.variantId) return;
        // Vorbestellbare Farben bewusst auslassen. Bei ihnen haengt der Preis am
        // Verkaufsplan, den die App ueber sellingPlanId mitschickt und den wir hier
        // nicht kennen. Ein Eintrag ohne diesen Bezug koennte den Warenkorbwert
        // falsch bewerten, und daran haengt die Geschenkschwelle. Lieber langsam
        // als ein Geschenk, das jemandem nicht zusteht. Derzeit hat der Shop
        // ohnehin keine vorbestellbaren Farben, das kostet also nichts.
        if (pan.isPreorder === true) return;
        gebraucht.push(String(pan.shopifyInfos.variantId));
      });
    } catch (e) { return []; }

    const brauchbar = new Set(
      nbEgSpeicherLesen()
        .filter(nbEgEintragBrauchbar)
        .map((e) => String(e.value.id))
    );
    return [...new Set(gebraucht)]
      .filter((id) => id && id !== 'undefined' && !brauchbar.has(id) && !nbEgVersucht.has(id));
  }

  async function nbEgHolen(ids) {
    const regeln = nbEgRegeln();
    if (!regeln) return [];
    // Die Zusatzfelder nicht fest eintragen, sondern aus dem Regelwerk ableiten.
    // Faellt eine Regel weg, passt sich der Waermer an.
    const brauchtSammlungen = regeln.some((r) => r && r.trigger && r.trigger.type === 'collection');
    const brauchtTags = regeln.some((r) => r && r.trigger && r.trigger.type === 'productTags');

    const gebaut = [];
    // Bewusst niedrig: der Waermer soll im Hintergrund mitlaufen, nicht die
    // Verbindungen belegen, die der Designer selbst braucht.
    const gleichzeitig = 4;
    for (let start = 0; start < ids.length; start += gleichzeitig) {
      const teil = ids.slice(start, start + gleichzeitig);
      const antworten = await Promise.all(teil.map(async (id) => {
        // Zeitlimit: auf einer haengenden Mobilverbindung soll der Waermer nicht
        // die ganze Sitzung lang blockiert bleiben. 86 Prozent der Kunden sind mobil.
        const abbruch = new AbortController();
        const wecker = setTimeout(() => abbruch.abort(), 6000);
        try {
          let url = 'https://aca.506.io/public/productInfo'
            + '?shop=' + encodeURIComponent(Shopify.shop)
            + '&variantId=' + encodeURIComponent(id)
            + '&currency=' + encodeURIComponent(Shopify.currency.active);
          if (brauchtSammlungen) url += '&collections=true';
          if (brauchtTags) url += '&productTags=true';
          const antwort = await fetch(url, { signal: abbruch.signal })
            .then((r) => (r.ok ? r.json() : null));
          const eintrag = nbEgEintragBauen(antwort);
          // Nur was wirklich geklappt hat, gilt als erledigt. Sonst waere eine
          // einmalige Stoerung gleichbedeutend damit, dass diese Farbe fuer den
          // Rest der Sitzung nie wieder vorgewaermt wird.
          if (eintrag) nbEgVersucht.add(String(id));
          return eintrag;
        } catch (e) { return null; }
        finally { clearTimeout(wecker); }
      }));
      antworten.forEach((e) => { if (e) gebaut.push(e); });
    }
    return gebaut;
  }

  // Erst loslegen, wenn die Seite fertig geladen ist. Sonst konkurrieren die
  // Abfragen mit dem Seitenaufbau um die begrenzten Verbindungen je Server und
  // machen genau das langsamer, worauf es ankommt: wie schnell der Designer
  // bedienbar ist. Das war in einer Messung deutlich zu sehen.
  function nbEgWennRuhig(arbeit) {
    const starte = () => {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(arbeit, { timeout: 3000 });
      } else {
        setTimeout(arbeit, 800);
      }
    };
    if (document.readyState === 'complete') starte();
    else window.addEventListener('load', starte, { once: true });
  }

  // Relaunch (03.09.): Paletten-Render fuer den Warenkorb vorwaermen, waehrend

  // der Kunde noch baut. Der Render-Server braucht fuer ein neues Motiv rund

  // 10 s und liefert es danach aus seinem Cache. Bisher wurde erst beim Klick

  // auf "In den Warenkorb" angefragt, im Drawer war das Bild deshalb oft noch

  // nicht da (Justin, 03.09.). Gedrosselt: bei voller Palette 1,2 s nach der

  // letzten Aenderung, sonst erst nach 6 s Ruhe und ab halb voller Palette;

  // jedes Motiv nur einmal, hoechstens 12 Motive je Sitzung. Das Hinzufuegen

  // selbst bleibt unveraendert (dort wird die URL weiterhin angefragt, dann

  // aber meist schon aus dem Cache).

  var nbRenderTimer = null;

  var nbRenderGesehen = new Set();

  function nbRenderVorwaermen(model) {

    try {

      const base = window.inlineData && window.inlineData.PaletteDesigner && window.inlineData.PaletteDesigner.imageUri;

      if (!base) return;

      clearTimeout(nbRenderTimer);

      const voll = !!model.isComplete;

      nbRenderTimer = setTimeout(() => {

        try {

          const pal = model.palette;

          const plaetze = pal && pal.hasSlots ? pal.rows * pal.columns : 0;

          const naepfe = model.pans ? model.pans.length : 0;

          if (!plaetze || naepfe < Math.ceil(plaetze / 2) || nbRenderGesehen.size >= 12) return;

          const str = stringifyPalette(model.serialize());

          if (nbRenderGesehen.has(str)) return;

          nbRenderGesehen.add(str);

          new Image().src = base + "?pd=" + encodeURIComponent(str);

        } catch (e) { /* Vorwaermen ist Komfort */ }

      }, voll ? 1200 : 6000);

    } catch (e) { /* darf den Designer nie stoeren */ }

  }


  function nbEgVorwaermen(konfiguration) {
    if (!nbEgBereit() || nbEgLaeuft) return;
    clearTimeout(nbEgTimer);
    // Entprellt: waehrend der Kunde schnell mehrere Farben setzt, soll nicht bei
    // jedem Klick eine Runde losgehen.
    nbEgTimer = setTimeout(() => {
      nbEgWennRuhig(async () => {
        if (nbEgLaeuft || !nbEgBereit()) return;
        // Erst ab der zweiten Farbe anfangen: wer nur kurz hereinschaut, soll
        // keine Abfragen ausloesen.
        if ((konfiguration._pans || []).length < 2) return;
        const offen = nbEgOffeneIds(konfiguration);
        if (!offen.length) return;
        nbEgLaeuft = true;
        try {
          const eintraege = await nbEgHolen(offen);
          nbEgSpeichern(eintraege);
        } catch (e) {
          // Nie den Designer stoeren.
        } finally {
          nbEgLaeuft = false;
        }
      });
    }, 1200);
  }

  // palette-designer/helpers/mvvm.js
  var PropertyChangedNotifier = class {
    constructor() {
      this._propertyChangedHandlers = [];
    }
    _notifyPropertyChanged(property) {
      this._propertyChangedHandlers.forEach((handler) => handler(property));
    }
    onPropertyChanged(handler) {
      this._propertyChangedHandlers.push(handler);
    }
    offPropertyChanged(handler) {
      this._propertyChangedHandlers.splice(this._propertyChangedHandlers.indexOf(handler), 1);
    }
  };
  var ViewModel = class extends PropertyChangedNotifier {
    constructor() {
      super();
    }
  };
  var Model = class extends PropertyChangedNotifier {
    constructor() {
      super();
    }
  };
  var View = class {
    constructor(viewModel) {
      this._viewModel = viewModel;
      this._viewModel.onPropertyChanged((property) => this.handlePropertyChanged(property));
    }
    get viewModel() {
      return this._viewModel;
    }
    set viewModel(value) {
      this._viewModel = value;
      this.handleViewModelChanged();
    }
  };

  // utility/localization.js
  function T(string, args = null) {
    if (args !== null) {
      for (let key of Object.keys(args)) {
        string = string.replace("{" + key + "}", args[key]);
      }
    }
    return string;
  }

  // utility/broker.js
  var Broker = class _Broker {
    static get default() {
      if (!_Broker._default) {
        _Broker._default = new _Broker();
      }
      return _Broker._default;
    }
    constructor() {
      this._subscribers = {};
      this._catchAllSubscribers = [];
    }
    subscribe(message, callback) {
      if (!this._subscribers[message]) {
        this._subscribers[message] = [];
      }
      this._subscribers[message].push(callback);
    }
    subscribeAll(callback) {
      this._catchAllSubscribers.push(callback);
    }
    unsubscribeAll(callback) {
      this._catchAllSubscribers = this._catchAllSubscribers.filter((subscriber) => subscriber !== callback);
    }
    unsubscribe(message, callback) {
      this._subscribers[message] = this._subscribers[message].filter((subscriber) => subscriber !== callback);
    }
    publish(message, payload) {
      if (this._subscribers[message]) {
        this._subscribers[message].forEach((callback) => callback(payload));
      }
      this._catchAllSubscribers.forEach((callback) => callback(message, payload));
    }
  };

  // utility/api-client.js
  var ApiError = class {
    constructor(error) {
      this._error = error;
    }
    get message() {
      if (this._error.message && this._error.message.toString().length > 0) {
        let message = this._error.message.toString();
        if (this._error.uuid) {
          message += " [error: " + this._error.uuid + "]";
        }
        return message;
      } else if (this._error.uuid) {
        return T("Error {code}. Please contact customer service if the problem persists.", {
          code: this._error.uuid
        });
      } else {
        return T("An error has occured. Please contact customer service if the problem persists.");
      }
    }
    get key() {
      return this._error.key || null;
    }
  };
  //ToDo
  var ApiClient = class {
    static makeRequest(service, method, payload, dispatcher = "dispatcher") {

      // Add user ID to payload if available
      const requestPayload = payload || {};
      if (window.inlineData && window.inlineData.User && window.inlineData.User.id) {
        requestPayload.userId = window.inlineData.User.id;
      }

      return fetch(`https://lethalcosmetics-shopify-app-byop.kombinat-berlin.de/${service}/${method}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(requestPayload)
        })
        .then(async (res) => {
          // HTTP-Fehler -> ApiError wie früher
          if (!res.ok) {
            const text = await res.text().catch(() => '');
            throw new ApiError({ status: res.status, body: text });
          }
          return res.json();
        })
        .then((data) => {
          // exakt wie im alten Code prüfen
          if (data === null || typeof data !== 'object') {
            throw new ApiError({});
          } else if (!data.success) {
            throw new ApiError(data);
          } else {
            Broker.default.publish('ApiRequestCompleted');
            return data.response;
          }
          Broker.default.publish('ApiRequestCompleted');
          return data.response;
        })
        .catch((e) => {
          // gleiches Fehlerverhalten wie vorher
          throw new ApiError(e);
        });
    }
  };

  // palette-designer/helpers/stringify.js
  var BASE62 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var BASE_MAP = new Uint8Array([
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    255,
    255,
    255,
    255,
    255,
    255,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255
  ]);
  function base62Encode(source) {
    if (source.length === 0) {
      return "";
    }
    let zeroes = 0;
    let length = 0;
    let pbegin = 0;
    let pend = source.length;
    while (pbegin !== pend && source[pbegin] === 0) {
      pbegin++;
      zeroes++;
    }
    let size = (pend - pbegin) * 1.3435902316563355 + 1 >>> 0;
    let b58 = new Uint8Array(size);
    while (pbegin !== pend) {
      let carry = source[pbegin];
      let i = 0;
      for (let it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++) {
        carry += 256 * b58[it1] >>> 0;
        b58[it1] = carry % 62 >>> 0;
        carry = carry / 62 >>> 0;
      }
      if (carry !== 0) {
        throw new Error("Non-zero carry");
      }
      length = i;
      pbegin++;
    }
    let it2 = size - length;
    while (it2 !== size && b58[it2] === 0) {
      it2++;
    }
    let str = BASE62.charAt(0).repeat(zeroes);
    for (; it2 < size; ++it2) {
      str += BASE62.charAt(b58[it2]);
    }
    return str;
  }
  function base62Decode(source) {
    if (typeof source !== "string") {
      throw new TypeError("Expected String");
    }
    if (source.length === 0) {
      return new Uint8Array(0);
    }
    let psz = 0;
    if (source[psz] === " ") {
      return;
    }
    let zeroes = 0;
    let length = 0;
    while (source[psz] === BASE62.charAt(0)) {
      zeroes++;
      psz++;
    }
    let size = (source.length - psz) * 0.7442745387983595 + 1 >>> 0;
    let b256 = new Uint8Array(size);
    while (source[psz]) {
      let carry = BASE_MAP[source.charCodeAt(psz)];
      if (carry === 255) {
        return;
      }
      let i = 0;
      for (let it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++) {
        carry += 62 * b256[it3] >>> 0;
        b256[it3] = carry % 256 >>> 0;
        carry = carry / 256 >>> 0;
      }
      if (carry !== 0) {
        throw new Error("Non-zero carry");
      }
      length = i;
      psz++;
    }
    if (source[psz] === " ") {
      return;
    }
    let it4 = size - length;
    while (it4 !== size && b256[it4] === 0) {
      it4++;
    }
    let vch = new Uint8Array(zeroes + (size - it4));
    vch.fill(0, 0, zeroes);
    let j = zeroes;
    while (it4 !== size) {
      vch[j++] = b256[it4++];
    }
    return vch;
  }
  function encodeNumber(value) {
    let bytes = [];
    if (value === 0) {
      return [0];
    }
    while (value > 0) {
      let byte = value & 127;
      value >>= 7;
      if (value > 0) {
        byte |= 128;
      }
      bytes.push(byte);
    }
    return bytes;
  }
  var PaletteFlags = {
    Index: 1,
    GridCoords: 2,
    Rotation: 4
  };
  function stringifyPalette(palette) {
    const hasRotation = palette.pans.some((item) => item.rotation > 0);
    const hasGridCoords = palette.pans.some((item) => item.gridOffsetX > 0 || item.gridOffsetY > 0);
    const hasIndex = palette.pans.some((item) => item.slotIndex > 0);
    let flags = 0;
    if (hasIndex) {
      flags |= PaletteFlags.Index;
    }
    if (hasRotation) {
      flags |= PaletteFlags.Rotation;
    }
    if (hasGridCoords) {
      flags |= PaletteFlags.GridCoords;
    }
    const values = [flags, palette.palette].concat(palette.pans.map((pan) => {
      const data = [pan.id];
      if (hasIndex) {
        data.push(pan.slotIndex);
      }
      if (hasGridCoords) {
        data.push(pan.gridOffsetX);
        data.push(pan.gridOffsetY);
      }
      if (hasRotation) {
        data.push(pan.rotation);
      }
      return data;
    }));
    const bytes = values.flat().flatMap((value) => encodeNumber(value));
    return base62Encode(bytes);
  }
  function parsePaletteString(serialized) {
    const decoded = base62Decode(serialized);
    const bytes = new Uint8Array(decoded);
    let current = 0;
    let shift = 0;
    let parts = [];
    for (let i = 0; i < bytes.length; i++) {
      let byte = bytes[i];
      current |= (byte & 127) << shift;
      shift += 7;
      if ((byte & 128) < 1) {
        parts.push(current);
        current = 0;
        shift = 0;
      }
    }
    const pans = [];
    const hasIndex = (parts[0] & PaletteFlags.Index) > 0;
    const hasGridCoords = (parts[0] & PaletteFlags.GridCoords) > 0;
    const hasRotation = (parts[0] & PaletteFlags.Rotation) > 0;
    let index = 2;
    while (index < parts.length) {
      const pan = {
        id: parts[index++],
        slotIndex: 0,
        gridOffsetX: 0,
        gridOffsetY: 0,
        rotation: 0
      };
      if (hasIndex) {
        pan.slotIndex = parts[index++];
      }
      if (hasGridCoords) {
        pan.gridOffsetX = parts[index++];
        pan.gridOffsetY = parts[index++];
      }
      if (hasRotation) {
        pan.rotation = parts[index++];
      }
      pans.push(pan);
    }
    return {
      palette: parts[1],
      pans
    };
  }
  var legacySourceAlphabet = "shn0123456789,og";
  var legacyDestAlphabets = [
    "abcdefghijklmnop",
    "0123456789ABCDEF",
    "EFGHIJKLMNOPQRST"
  ];
  var legacyExpandPaletteId = {
    h: "Hive",
    s: "Synergy",
    o: "Orbital",
    n: "None",
    g: "Gridlock"
  };
  function parseLegacyPaletteString(serialized, productsModel) {
    let parsed = "";
    for (let i = 0; i < serialized.length; i++) {
      const alphabet = legacyDestAlphabets[i % legacyDestAlphabets.length];
      const current = serialized.charAt(i);
      const position = alphabet.indexOf(current);
      if (position < 0) {
        throw new Error();
      }
      parsed += legacySourceAlphabet[position];
    }
    let parts = parsed.split(/,/g);
    if (parts.length !== 13) {
      throw new Error();
    }
    if (!["h", "s", "o", "n", "g"].includes(parts[0])) {
      throw new Error();
    }
    const paletteId = parts[0];
    const paletteName = legacyExpandPaletteId[paletteId];
    const palette = productsModel.lookupByName(paletteName);
    parts = parts.slice(1);
    let slotIndex = 0;
    let gridOffsetX = 0;
    let gridOffsetY = 0;
    const pans = [];
    let absoluteIndex = 0;
    for (let part of parts) {
      let column = absoluteIndex % 4;
      let row = Math.floor(absoluteIndex / 4);
      if (!palette.hasSlots) {
        gridOffsetX = column * (26 / palette.gridWidth);
        gridOffsetY = row * (26 / palette.gridHeight);
      }
      if (part && part.length > 0) {
        pans.push({
          id: parseInt(part),
          slotIndex,
          gridOffsetX,
          gridOffsetY,
          rotation: 0
        });
      }
      if (palette.hasSlots) {
        if (column < palette.columns) {
          ++slotIndex;
        }
      }
      ++absoluteIndex;
    }
    return {
      palette: palette.id,
      pans
    };
  }

  // palette-designer/models/service-model.js
  var ServiceResponse = class {
    constructor(success, value = null, error = null) {
      this._success = success;
      this._value = value;
      this._error = error;
    }
    get success() {
      return this._success;
    }
    get value() {
      return this._value;
    }
    get error() {
      return this._error;
    }
  };
  
  var ServiceModel = class extends Model {
    async addToCart(customPalette, allowBackorder = false) {
      const result = await this._makeRequest("addToCart", {
        palette: stringifyPalette(customPalette.serialize()),
        allowBackorder
      });
      return new ServiceResponse(
        result.addedToCart,
        result.addedToCart ? {
          cart: result.cart,
          count: result.count,
          paletteId: result.paletteId
        } : null,
        result.reason || null
      );
    }
    async getAvailabilityBreakdown(customPalette) {

      let palette = [];
      let product = {
        handle: customPalette._palette._options.link.split('/').pop(),
        id: customPalette._palette._options.id,
        quantity: 1
      };
      palette.push(product);

      // Pans sammeln und Duplikate zusammenfassen
      const panMap = new Map();
      
      customPalette._pans.forEach(pan => {
        const panId = pan._pan._options.id;
        
        if (panMap.has(panId)) {
          // Pan bereits vorhanden, Quantity erhöhen
          panMap.set(panId, panMap.get(panId) + 1);
        } else {
          // Neuer Pan
          panMap.set(panId, 1);
        }
      });

      // Pans mit Quantity zum palette Array hinzufügen
      panMap.forEach((quantity, panId) => {
        const panData = customPalette._pans.find(p => p._pan._options.id === panId);
        let product = {
          handle: panData._pan._options.link.split('/').pop(),
          id: panId,
          quantity: quantity
        };
        palette.push(product);
      });

      // Market/Country Code hinzufügen
      const countryCode = window.Shopify.country;

      return await ApiClient.makeRequest("paletteDesigner", "getAvailabilityBreakdown", {
        palette: palette,
        countryCode: countryCode
      });
    }
    async savePalette(id, paletteString) {
      return await ApiClient.makeRequest("paletteDesigner", "savePalette", {
        id,
        paletteString
      });
    }
    async deleteSavedPalette(id) {
      return await ApiClient.makeRequest("paletteDesigner", "deletePalette", {
        id
      });
    }
    async listSavedPalettes() {
      return await ApiClient.makeRequest("paletteDesigner", "getPalettes", {});
    }
  };

  // palette-designer/helpers/color.js
  function rgbToHsl(r, g, b) {
    r /= 255, g /= 255, b /= 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;
    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return [h, s, l];
  }
  function rgbToLab(inR, inG, inB) {
    let r = inR / 255, g = inG / 255, b = inB / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 8856e-6 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 8856e-6 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 8856e-6 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
  }
  function deltaE(labA, labB) {
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1 + 0.045 * c1;
    let sh = 1 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
  }

  // palette-designer/models/product-model.js?r=4
  var ProductModel = class extends Model {
    constructor(options) {
      super();
      this._options = options;
    }
    get id() {
      return this._options.id;
    }
    get name() {
      return this._options.name;
    }
    get link() {
      return this._options.link;
    }
    get productLine() {
      return this._options.productLine;
    }
    get price() {
      return this._options.price;
    }
    get originalPrice() {
      return this._options.originalPrice;
    }
    get isOnSale() {
      return this._options.isOnSale;
    }
    get isOwned() {
      return this._options.isOwned;
    }
    get image() {
      return this._options.image;
    }
    get gallery() {
      return this._options.gallery;
    }
    get created() {
      return this._options.created;
    }
    get description() {
      return this._options.description;
    }
    get salesRank() {
      return this._options.salesRank;
    }
    get availability() {
      return this._options.availability;
    }
    // Vorbestellbar: Bestand wird gefuehrt, ist aufgebraucht, Verkauf trotzdem
    // erlaubt (inventory_policy "continue"). Quelle: byop-products.liquid.
    // Ausdruecklich NICHT ueber selling_plan_groups -- Begruendung steht dort.
    get isPreorder() {
      return this._options.isPreorder === true;
    }
    // Ausverkauft im Sinne von "kann so nicht gekauft werden". Vorbestellbare
    // Artikel sind ausdruecklich NICHT ausverkauft -- sie sind bestellbar, nur
    // mit spaeterem Versand.
    get isSoldOut() {
      return this._options.availability === "out_of_stock" || this._options.availability === "coming_soon";
    }
    get finish() {
      return this._options.finish;
    }
    get isNew() {
      return this._options.isNew;
    }
    get paletteDesignerDiscount() {
      return this._options.paletteDesignerDiscount;
    }
    get shopifyInfos() {
      return this._options.shopifyInfos;
    }
  };

  // palette-designer/models/pan-model.js?r=4
  var panDefaultOptions = {
    name: "",
    id: 0,
    color: {
      canonical: "black",
      rgb: [0, 0, 0],
      hsl: [0, 0, 0],
      lab: [0, 0, 0]
    },
    width: 26,
    height: 26,
    canRotate: false,
    type: "eyeshadow"
  };
  var PanModel = class extends ProductModel {
    constructor(options) {
      super(Object.assign(Object.assign({}, panDefaultOptions), options));
    }
    get name() {
      return this._options.name;
    }
    get id() {
      return this._options.id;
    }
    get type() {
      return this._options.type;
    }
    get width() {
      return this._options.width;
    }
    get height() {
      return this._options.height;
    }
    get color() {
      return this._options.color;
    }
    get canRotate() {
      return this._options.canRotate;
    }
    get finish() {
      return this._options.finish;
    }
    get shift() {
      return this._options.shift;
    }
  };

  // palette-designer/models/palette-model.js?r=4
  var defaultOptions = {
    name: "",
    id: 0,
    isDefault: false,
    specifications: {
      topLidHeight: 110,
      bottomLidHeight: 0,
      baseWidth: 110,
      baseHeight: 110,
      slotWidth: 26,
      slotHeight: 26,
      columns: 3,
      rows: 3,
      columnSpacing: 5,
      rowSpacing: 5,
      mirrorWidth: 70,
      mirrorHeight: 70,
      gridWidth: 26,
      gridHeight: 26,
      hasTopLidOverlay: false
    }
  };
  var PaletteModel = class extends ProductModel {
    constructor(options) {
      super(Object.assign(Object.assign({}, defaultOptions), options));
    }
    get type() {
      return "empty_palette";
    }
    get isDefault() {
      return this._options.isDefault;
    }
    get baseWidth() {
      return this._options.specifications.baseWidth;
    }
    get baseHeight() {
      return this._options.specifications.baseHeight;
    }
    get hasTopLid() {
      return this._options.specifications.topLidHeight && this._options.specifications.topLidHeight > 0;
    }
    get topLidHeight() {
      return this._options.specifications.topLidHeight;
    }
    get hasBottomLid() {
      return this._options.specifications.bottomLidHeight && this._options.specifications.bottomLidHeight > 0;
    }
    get bottomLidHeight() {
      return this._options.specifications.bottomLidHeight;
    }
    get slotWidth() {
      return this._options.specifications.slotWidth;
    }
    get slotHeight() {
      return this._options.specifications.slotHeight;
    }
    get columns() {
      return this._options.specifications.columns;
    }
    get rows() {
      return this._options.specifications.rows;
    }
    get columnSpacing() {
      return this._options.specifications.columnSpacing;
    }
    get rowSpacing() {
      return this._options.specifications.rowSpacing;
    }
    get hasMirror() {
      return this._options.specifications.mirrorHeight && this._options.specifications.mirrorWidth;
    }
    get mirrorWidth() {
      return this._options.specifications.mirrorWidth;
    }
    get mirrorHeight() {
      return this._options.specifications.mirrorHeight;
    }
    get gridWidth() {
      return this._options.specifications.gridWidth;
    }
    get gridHeight() {
      return this._options.specifications.gridHeight;
    }
    get hasSlots() {
      return this.gridWidth === this.slotWidth && this.gridHeight === this.slotHeight;
    }
    get hasTopLidOverlay() {
      return this._options.specifications.hasTopLidOverlay;
    }
    get eyeshadowEquivalentCapacity() {
      let area = 0;
      for (let j = 0; j < this.rows; j++) {
        for (let i = 0; i < this.columns; i++) {
          area += this.slotWidth * this.slotHeight;
        }
      }
      const eyeshadowArea = 26 * 26;
      return area / eyeshadowArea;
    }
    get finish() {
      return [];
    }
  };

  // palette-designer/models/products-model.js?r=5
  var primaryColors = {
    "red": rgbToLab(255, 0, 0),
    "orange": rgbToLab(255, 165, 0),
    "yellow": rgbToLab(255, 255, 51),
    "green": rgbToLab(0, 128, 0),
    "teal": rgbToLab(0, 128, 128),
    "blue": rgbToLab(0, 0, 255),
    "purple": rgbToLab(128, 0, 128),
    "pink": rgbToLab(255, 0, 255),
    "white": rgbToLab(255, 255, 255),
    "grey": rgbToLab(128, 128, 128),
    "black": rgbToLab(0, 0, 0),
    "brown": rgbToLab(139, 69, 19)
  };
  // Lokalisierter Text aus byop-products.liquid. Der Rueckfall greift, wenn das
  // Liquid aelter ist als das Bundle -- dann steht dort englischer Text statt
  // einer leeren Flaeche. Nicht mit T() verwechseln: T() gibt seinen Eingabetext
  // unveraendert zurueck und uebersetzt gar nichts.
  function txt(schluessel, rueckfall) {
    const texte = window.inlineData && window.inlineData.PaletteDesigner && window.inlineData.PaletteDesigner.staticText;
    const wert = texte && texte[schluessel];
    return typeof wert === "string" && wert.length > 0 ? entitaetenAufloesen(wert) : rueckfall;
  }
  // Shopifys t-Filter liefert HTML-escaped ("Don&#39;t", "&amp;"). Die Texte
  // landen hier aber ueberwiegend per .text() im DOM -- ohne Aufloesung stuende
  // dann woertlich "Don&#39;t miss out!" auf dem Bildschirm (im EN-Shop so
  // gesehen). Ein textarea dekodiert Entitaeten, ohne Markup auszufuehren.
  function entitaetenAufloesen(text) {
    if (text.indexOf("&") === -1) {
      return text;
    }
    const feld = document.createElement("textarea");
    feld.innerHTML = text;
    return feld.value;
  }
  // Kleinbild fuer Katalogkacheln und Paletten-Pans. Nimmt das erste echte Bild --
  // Videoeintraege haben kein thumbUri und wuerden als Hintergrundbild nur eine
  // leere Flaeche ergeben. Faellt auf das Originalbild zurueck, damit ein Katalog
  // ohne thumbUri (aelterer Liquid-Stand) weiter funktioniert.
  function katalogBild(images) {
    if (!images || !images.length) {
      return "";
    }
    for (const eintrag of images) {
      if (eintrag && eintrag.thumbUri) {
        return eintrag.thumbUri;
      }
    }
    for (const eintrag of images) {
      if (eintrag && eintrag.uri) {
        return eintrag.uri;
      }
    }
    return "";
  }
  // Medien fuer die Detailansicht. Eintraege ohne uri koennen entstehen, wenn ein
  // Produkt ein 3D-Modell oder ein eingebettetes Fremdvideo traegt; die wuerden
  // sonst als undefined bis in die Bild-Erzeugung durchschlagen.
  function galerieMedien(images) {
    if (!images || !images.length) {
      return [];
    }
    return images.filter((eintrag) => eintrag && eintrag.uri).map((eintrag) => ({
      uri: eintrag.uri,
      posterUri: eintrag.posterUri || ""
    }));
  }
  var ProductsModel = class extends Model {
    constructor(products, categories) {
      super();
      this._products = products;
      this._categories = categories;
      this._conformData();
    }
    _conformData() {
      this._conformedData = [];
      for (let category of this._categories) {
        category.filter = new Function("item", "return " + category.filter);
      }
      for (let item of this._products) {
        // Waehrung des Katalogs merken (byop-products.liquid liefert sie je
        // Produkt aus cart.currency.iso_code, fuer den ganzen Katalog gleich).
        // formatPrice greift darauf zurueck, wenn Shopify.currency.active
        // fehlen sollte.
        if (!nbKatalogWaehrung && item.price && item.price.currency) {
          nbKatalogWaehrung = item.price.currency;
        }
        let conformed;
        if (item.type === "empty_palette") {
          if (!item.attributes.specifications) {
            continue;
          }
          conformed = this._conformPalette(item);
        } else {
          conformed = this._conformPan(item);
        }
        if (conformed) {
          this._conformedData.push(conformed);
        }
      }
    }
    _conformPalette(item) {
      return new PaletteModel({
        id: item.id,
        name: item.name,
        availability: item.availability,
        productLine: item.productLine,
        isOnSale: item.isOnSale,
        isOwned: item.isOwned,
        price: item.price.value / 100,
        originalPrice: item.originalPrice.value / 100,
        salesRank: item.salesRank,
        created: item.created,
        description: item.description,
        isPreorder: item.isPreorder === true,
        image: katalogBild(item.images),
        gallery: galerieMedien(item.images),
        specifications: item.attributes.specifications,
        isDefault: item.attributes.isDefault,
        isNew: item.attributes.isNew,
        paletteDesignerDiscount: item.attributes.paletteDesignerDiscount,
        link: item.link,
        shopifyInfos: item.shopifyInfos || null
      });
    }
    _conformPan(item) {
      const color = (item.attributes.color || "#000000").substr(1);
      const red = parseInt(color.substr(0, 2), 16);
      const green = parseInt(color.substr(2, 2), 16);
      const blue = parseInt(color.substr(4, 2), 16);
      const hsl = rgbToHsl(red, green, blue);
      const lab = rgbToLab(red, green, blue);
      let closestColor = "";
      let minDistance = Number.MAX_VALUE;
      for (let color2 of Object.keys(primaryColors)) {
        let primaryLab = primaryColors[color2];
        let delta = deltaE(primaryLab, lab);
        if (delta < minDistance) {
          minDistance = delta;
          closestColor = color2;
        }
      }
      let image = katalogBild(item.images);
      let tone = item.attributes.tone;
      let finish = [];
      finish.push(item.attributes.finish);
      let shift = item.attributes["shift"];
      if (!item.attributes.specifications) {
        debugger;
      }
      return new PanModel({
        name: item.name,
        productLine: item.productLine,
        availability: item.availability,
        isPreorder: item.isPreorder === true,
        type: item.type,
        id: item.id,
        width: item.attributes.specifications.panWidth,
        height: item.attributes.specifications.panHeight,
        color: {
          canonical: closestColor,
          rgb: [red, green, blue],
          hsl,
          lab,
          tone
        },
        canRotate: true,
        isOnSale: item.isOnSale,
        isNew: item.attributes.isNew,
        isOwned: item.isOwned,
        price: item.price.value / 100,
        originalPrice: item.originalPrice.value / 100,
        salesRank: item.salesRank,
        created: item.created,
        description: item.description,
        finish,
        shift,
        image,
        gallery: galerieMedien(item.images),
        paletteDesignerDiscount: item.attributes.paletteDesignerDiscount,
        link: item.link,
        shopifyInfos: item.shopifyInfos || null
      });
    }
    get categories() {
      return this._categories;
    }
    productsForCategory(category) {
      return this._conformedData.filter(category.filter);
    }
    get defaultPalette() {
      let palette = this._conformedData.find(
        (item) => item instanceof PaletteModel && item.isDefault
      );

      // If no palette with isDefault, fallback to old method name check
      if (!palette) {
        palette = this._conformedData.find(
          (item) => item instanceof PaletteModel && item.name === "Lethal 12"
        );
      }
      
      if (!palette) {
        throw new Error("No default palette specified");
      }
      return palette;
    }
    lookup(id) {
      if (window.inlineData.PaletteDesigner.productMappings.hasOwnProperty(id)) {
        id = parseInt(window.inlineData.PaletteDesigner.productMappings[id]);
      }
      return this._conformedData.find((item) => item.id === id);
    }
    lookupByName(name) {
      return this._conformedData.find((item) => item.name === name);
    }
    asArray() {
      return this._conformedData;
    }
  };

  // palette-designer/helpers/broadcast.js
  var Broadcast = class _Broadcast {
    static receive(message, callback) {
      if (!_Broadcast.receivers) {
        _Broadcast.receivers = {};
      }
      if (!_Broadcast.receivers[message]) {
        _Broadcast.receivers[message] = [];
      }
      _Broadcast.receivers[message].push(callback);
    }
    static receiveAll(callback) {
      if (!_Broadcast.allReceivers) {
        _Broadcast.allReceivers = [];
      }
      _Broadcast.allReceivers.push(callback);
    }
    static ignoreAll(callback) {
      if (!_Broadcast.allReceivers) {
        return;
      }
      _Broadcast.allReceivers = _Broadcast.allReceivers.filter((receiver) => receiver !== callback);
    }
    static ignore(message, callback) {
      if (!_Broadcast.receivers) {
        return;
      }
      if (!_Broadcast.receivers[message]) {
        return;
      }
      _Broadcast.receivers[message] = _Broadcast.receivers[message].filter((receiver) => receiver != callback);
    }
    static send(message, payload) {
      if (_Broadcast.receivers && _Broadcast.receivers[message]) {
        _Broadcast.receivers[message].forEach((callback) => callback(payload));
      }
      if (_Broadcast.allReceivers) {
        _Broadcast.allReceivers.forEach((callback) => callback(message, payload));
      }
    }
  };

  // palette-designer/models/user-model.js
  var SavedPaletteModel = class extends Model {
    constructor(id, paletteString, name, modified) {
      super();
      this._id = id;
      this._name = name;
      this._paletteString = paletteString;
      this._modified = modified;
    }
    get id() {
      return this._id;
    }
    get paletteString() {
      return this._paletteString;
    }
    set paletteString(value) {
      this._paletteString = value;
    }
    get name() {
      return this._name;
    }
    set name(value) {
      this._name = value;
    }
    get modified() {
      return this._modified;
    }
    set modified(value) {
      this._modified = value;
    }
  };
  var UserModel = class extends Model {
    constructor(serviceModel) {
      super();
      this._serviceModel = serviceModel;
      this._id = window.inlineData.User.id;
      this._savedPalettes = [];
      if (this.isLoggedIn) {
        this._updateSavedPalettes();
      }
    }
    get isLoggedIn() {
      return !!this._id;
    }
    get id() {
      return this._id;
    }
    get savedPalettes() {
      return this._savedPalettes;
    }
    get lastError() {
      return this._lastError;
    }
    async _updateSavedPalettes() {
      try {
        const result = await this._serviceModel.listSavedPalettes();
        this._savedPalettes = result.palettes.map((savedPalette) => new SavedPaletteModel(
          parseInt(savedPalette.id),
          savedPalette.paletteString,
          savedPalette.name || "",
          new Date(parseInt(savedPalette.modified) * 1e3)
        ));
        this._notifyPropertyChanged("savedPalettes");
      } catch (e) {
        Broadcast.send("asyncRequestFailed", e);
      }
    }
    async refreshSavedPalettes(force = false) {
      this._updateSavedPalettes();
    }
    _sortSavedPalettes() {
      this._savedPalettes = this._savedPalettes.sort((a, b) => b.modified.getTime() - a.modified.getTime());
    }
    _saveLastPalette(palette) {
      localStorage.setItem("lastSavedPalette", JSON.stringify({
        id: palette.id,
        paletteString: stringifyPalette(palette.serialize())
      }));
    }
    async savePalette(palette) {
      if (!this.isLoggedIn) {
        this._saveLastPalette(palette);
        return;
      }
      try {
        const paletteString = stringifyPalette(palette.serialize());
        const result = await this._serviceModel.savePalette(palette.id, paletteString);
        palette.id = result.id;
        let found = false;
        for (let savedPalette of this._savedPalettes) {
          if (savedPalette.id === result.id) {
            savedPalette.paletteString = paletteString;
            savedPalette.name = result.name;
            savedPalette.modified = /* @__PURE__ */ new Date();
            found = true;
            break;
          }
        }
        if (!found) {
          this._savedPalettes.push(new SavedPaletteModel(
            result.id,
            paletteString,
            result.name,
            /* @__PURE__ */ new Date()
          ));
        }
        this._saveLastPalette(palette);
        this._sortSavedPalettes();
        this._notifyPropertyChanged("savedPalettes");
      } catch (e) {
        console.error(e);
        Broadcast.send("asyncRequestFailed", e);
      }
    }
    async deleteSavedPalette(savedPalette) {
      try {
        await this._serviceModel.deleteSavedPalette(savedPalette.id);
        this._savedPalettes.splice(this._savedPalettes.indexOf(savedPalette), 1);
        this._notifyPropertyChanged("savedPalettes");
      } catch (e) {
        console.error(e);
        Broadcast.send("asyncRequestFailed", e);
      }
    }
    get lastSavedPalette() {
      try {
        const payload = localStorage.getItem("lastSavedPalette");
        let decoded = JSON.parse(payload);
        if (!decoded || !decoded.hasOwnProperty("id") || !decoded.paletteString) {
          return null;
        }
        return new SavedPaletteModel(decoded.id || null, decoded.paletteString, "Custom palette", /* @__PURE__ */ new Date());
      } catch (e) {
        return null;
      }
    }
  };

  // palette-designer/models/placed-pan-model.js
  var PlacedPanModel = class extends Model {
    constructor(pan, slotIndex = 0, gridOffsetX = 0, gridOffsetY = 0, rotation = 0) {
      super();
      this._pan = pan;
      this._slotIndex = slotIndex;
      this._gridOffsetX = gridOffsetX;
      this._gridOffsetY = gridOffsetY;
      this._rotation = rotation;
    }
    get pan() {
      return this._pan;
    }
    get rotation() {
      return this._rotation;
    }
    get slotIndex() {
      return this._slotIndex;
    }
    get gridOffsetX() {
      return this._gridOffsetX;
    }
    get gridOffsetY() {
      return this._gridOffsetY;
    }
    get orientedWidth() {
      if (this._rotation === 0 || this._rotation === 180) {
        return this._pan.width;
      } else {
        return this._pan.height;
      }
    }
    get orientedHeight() {
      if (this._rotation === 0 || this._rotation === 180) {
        return this._pan.height;
      } else {
        return this._pan.width;
      }
    }
  };

  // views/notification.js
  var Notification = class {
    static _createElement(headline, message, className = "") {
      // Ueberschrift und Text als Text setzen, nicht in den Markup interpolieren:
      // hier landen auch Fehlertexte aus Server-Antworten (/cart/add), und kein
      // Aufrufer uebergibt absichtlich HTML.
      const element = $(`
        <div class="notification ${className}">
            <div>
                <h3></h3>
                <p></p>
            </div>
            <button class="close"></button>
        </div>
        `);
      element.find("h3").text(headline == null ? "" : String(headline));
      element.find("p").text(message == null ? "" : String(message));
      const removeCallback = () => {
        window.clearTimeout(removeTimer);
        element.removeClass("visible").one("transitionend", () => {
          element.remove();
        });
      };
      element.find("button").on("click", removeCallback);
      $("#notification-container").prepend(element);
      window.setTimeout(() => {
        element.addClass("visible");
      }, 100);
      const removeTimer = window.setTimeout(removeCallback, 5e3);
    }
    static show(headline, message) {
      this._createElement(headline, message);
    }
    static showError(headlineOrError, message = null) {
      if (typeof headlineOrError === "string") {
        this._createElement(headlineOrError, message, "error");
      } else {
        let headline = T("Operation failed");
        let message2 = T("Please contact customer service if the problem persists.");
        if (headlineOrError && headlineOrError.message && typeof headlineOrError.message === "string" && headlineOrError.message.length > 0) {
          message2 = headlineOrError.message;
        }
        this._createElement(headline, message2, "error");
      }
    }
  };

  // models/cart.js
  var Cart = class _Cart {
    static get current() {
      if (!_Cart._current) {
        _Cart._current = new _Cart();
      }
      return _Cart._current;
    }
    constructor() {
      this._cart = null;
      this._callbacks = [];
    }
    onItemAdded(callback) {
      if (!this._callbacks.includes(callback)) {
        this._callbacks.push(callback);
      }
    }
    offItemAdded(callback) {
      const index = this._callbacks.indexOf(callback);
      if (index < 1) {
        return;
      }
      this._callbacks.splice(index, 1);
    }
    get html() {
      return this._cart.html;
    }
    get count() {
      return this._cart.count;
    }

    async addItem(palette, quantity = 1, attributes = null, variation = null) {

      // Reentry-/Doppelklick-Schutz: Ein laufendes Add (fetch + Cart Transform +
      // Edit-Replace = mehrere Sekunden) darf nicht parallel erneut starten, sonst
      // entstuende eine zweite BundleId -> Palette laege doppelt im Warenkorb und
      // der bereits konsumierte Edit-Kontext koennte nichts mehr ersetzen.
      if (this._nbAddInFlight) {
        console.warn('[BYOP][NB] addItem ignoriert: vorheriges Add laeuft noch');
        return null;
      }

      // Sammle alle Produkte (Palette + Pans)
      const cartItems = [];
      const paletteString = stringifyPalette(palette.serialize());

      // Native Bundles (Cart Transform): eindeutige Bundle-Instanz-ID, Gruppe "palette".
      // Format "palette-<id>" mit genau EINEM Bindestrich; die id selbst enthaelt keinen.
      // Alle Zeilen einer Palette teilen dieselbe ID -> App merged sie zu einer Position.
      const bundleInstanceId = 'palette-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      
      // Anzeige-Infos fuer die gemergte Bundle-Zeile. Die App bewahrt NUR _BundleId,
      // _BundleTitle und _BundleParentVariantId auf der Merged Line (Whitelist) --
      // _BundleTitle wird der Zeilentitel, _BundleParentVariantId bestimmt
      // Bild/SKU/URL der Bundle-Zeile (sonst instabil "erste Cart-Zeile").
      const bundlePanCount = palette._pans.filter(function (p) {
        return p._pan && p._pan.shopifyInfos && p._pan.shopifyInfos.variantId;
      }).length;
      const bundleTitle = 'Custom Palette' + (bundlePanCount > 0 ? ' · ' + bundlePanCount + ' Shades' : '');

      // 1. Base Palette hinzufügen
      if (palette._palette && palette._palette.shopifyInfos) {
        cartItems.push({
          id: palette._palette.shopifyInfos.variantId,
          quantity: 1,
          properties: {
            '_palette_string': paletteString,
            '_BundleId': bundleInstanceId,
            '_BundleTitle': bundleTitle,
            '_BundleParentVariantId': String(palette._palette.shopifyInfos.variantId)
          }
        });
      }
      
      // 2. Alle Pans sammeln und Duplikate zusammenfassen
      const panMap = new Map();
      
      palette._pans.forEach((placedPan) => {
        const pan = placedPan._pan;
        if (pan && pan.shopifyInfos && pan.shopifyInfos.variantId) {
          const variantId = pan.shopifyInfos.variantId;
          
          if (panMap.has(variantId)) {
            // Pan bereits vorhanden, Quantity erhöhen
            panMap.set(variantId, panMap.get(variantId) + 1);
          } else {
            // Neuer Pan
            panMap.set(variantId, 1);
          }
        }
      });
      
      // 3. Alle Pans zum cartItems Array hinzufügen
      panMap.forEach((quantity, variantId) => {
        cartItems.push({
          id: variantId,
          quantity: quantity,
          properties: {
            '_palette_string': paletteString,
            '_BundleId': bundleInstanceId
          }
        });
      });

      // 4. STOQ Preorder: Selling-Plan + Preorder-Properties an passende Pan-Items haengen,
      //    damit ueber BYOP hinzugefuegte Preorder-Pans (z. B. Genesis) korrekt als Preorder
      //    geflaggt werden und Stoqs Limit greift. Nutzt nur Stoqs DOKUMENTIERTE API.
      //    Harte Guards: laeuft nur, wenn _RestockRocket voll initialisiert ist; jeder Fehler
      //    wird abgefangen, damit das Add-to-Cart NIE bricht, falls Stoq fehlt/langsam/geaendert.
      try {
        const stoq = window._RestockRocket;
        if (stoq && typeof stoq.getSellingPlan === 'function' && typeof stoq.getLineItemProperties === 'function') {
          for (const item of cartItems) {
            // Nur Pans behandeln (Basis-Palette nicht in panMap -> uebersprungen).
            if (!panMap.has(item.id)) continue;
            let sellingPlan = null;
            try {
              // WICHTIG: Stoqs getSellingPlan erwartet eine NUMBER; mit String liefert es null.
              sellingPlan = stoq.getSellingPlan(Number(item.id));
            } catch (_) {
              continue; // Variante als Nicht-Preorder behandeln, Item unveraendert lassen.
            }
            // getSellingPlan() liefert null fuer Nicht-Preorder-Varianten -> ueberspringen.
            if (!sellingPlan || !sellingPlan.shopify_selling_plan_id) continue;
            // Selling-Plan-ID anhaengen (numerisch, wie Shopify /cart/add.js erwartet).
            item.selling_plan = sellingPlan.shopify_selling_plan_id;
            // Stoq-Line-Item-Properties mergen; item.properties zuletzt -> _palette_string gewinnt.
            // Nur echte Anzeige-Properties (z. B. "Shipping") uebernehmen. Stoqs "attributes[...]"-Keys
            // sind Form-Feld-Syntax fuer versteckte Cart-Attribute (greifen nur via FormData) und wuerden
            // im JSON-Add als haessliche sichtbare Zeilen-Notiz landen -> herausfiltern.
            let stoqProps = {};
            try {
              const rawProps = stoq.getLineItemProperties(sellingPlan, Number(item.id)) || {};
              for (const k in rawProps) {
                if (!/^attributes\[/.test(k)) stoqProps[k] = rawProps[k];
              }
            } catch (_) {}
            item.properties = Object.assign({}, stoqProps, item.properties);
            // Beobachtbarkeit fuer den Test: zeigt, ob Stoq das Limit fuehrt.
            try {
              console.log('[BYOP][STOQ] variant', item.id, 'selling_plan', item.selling_plan,
                'preorderAvailable', typeof stoq.getPreorderAvailable === 'function' ? stoq.getPreorderAvailable(Number(item.id)) : 'n/a');
            } catch (_) {}
          }
        }
      } catch (stoqError) {
        // Total-Fallback: Stoq-Integration fehlgeschlagen -> cartItems unveraendert, Verhalten wie vor dem Fix.
        console.warn('[BYOP][STOQ] integration error, proceeding without preorder flags:', stoqError);
      }

      console.log('Cart Items:', cartItems);
      
      // Sammle sections die aktualisiert werden sollen (Theme Pattern)
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );
      
      // Das Drawer-HTML wird NICHT mehr im Add mitgerendert (frueher standen
      // hier sections + section_url). Shopify haengt sonst das komplette
      // Warenkorb-Drawer-HTML an die Add-Antwort, und es waechst mit jeder
      // Zeile; eine Palette hat 7 bis 13 Zeilen. Dieselbe fette Antwort lesen
      // anschliessend ALLE Fetch-Abfangschichten der Seite erneut (Stoq,
      // Hoppy Free Shipping, Shopifys Web-Pixel), bevor unser Code sie
      // ueberhaupt sieht. Stattdessen wird das Drawer-HTML weiter unten
      // EINMAL frisch geholt, parallel zu /cart.js und nach allen Aenderungen
      // am Warenkorb, dadurch ist es zugleich aktueller als vorher.
      const formData = {
        items: cartItems
      };

      // Ab hier laufen awaits -> Flag setzen (alles davor ist synchron, kein Reentry moeglich).
      this._nbAddInFlight = true;
      try {
        const response = await fetch(window.FoxTheme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          // Shopify lehnt den Add ab (typisch: 422 "sold out", wenn das Live-Inventar
          // neuer ist als der Katalog-Stand des Designers). Grund sichtbar machen --
          // vorher scheiterte der Klick voellig stumm und wirkte wie ein Hänger.
          // Shopify nennt in der Antwort das Produkt beim Namen, z. B.
          // "The product 'Synth' is already sold out." Das ist fuer den Kunden
          // deutlich brauchbarer als ein pauschaler Hinweis.
          // Erst als Text lesen, dann parsen: auf /cart/add liegen mehrere
          // Fetch-Abfangschichten uebereinander (Stoq, Hoppy Free Shipping,
          // Shopifys Web-Pixel-Manager). Hat eine davon den Body schon gelesen,
          // wirft clone() -- deshalb der zweite Versuch direkt am Original.
          let nbRohText = '';
          try { nbRohText = await response.clone().text(); }
          catch (nbCloneError) {
            try { nbRohText = await response.text(); } catch (nbTextError) { nbRohText = ''; }
          }
          let nbErrMsg = '';
          if (nbRohText) {
            try {
              const nbFehler = JSON.parse(nbRohText);
              nbErrMsg = nbFehler.description || nbFehler.message || '';
            } catch (nbParseError) { /* kein JSON, dann eben ohne Grund */ }
          }
          const nbDe = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
          if (!nbErrMsg) {
            // Bewusst KEINE Ursache erfinden. Hier stand vorher pauschal
            // "mindestens ein Shade ist ausverkauft" -- das kann stimmen, muss
            // aber nicht, und ein falsch behaupteter Grund schickt den Kunden auf
            // die falsche Suche. Ist der Grund nicht lesbar, sagen wir das auch.
            nbErrMsg = nbDe
              ? 'Der Shop hat die Palette gerade nicht angenommen. Bitte lade die Seite neu und versuche es noch einmal.'
              : 'The shop did not accept the palette just now. Please reload the page and try again.';
          }
          try {
            if (typeof Notification !== 'undefined' && Notification.showError) {
              Notification.showError(
                nbDe ? 'Nicht in den Warenkorb gelegt' : 'Could not add to cart',
                nbErrMsg || (nbDe ? 'Etwas ist schiefgelaufen. Bitte versuche es erneut.' : 'Something went wrong. Please try again.')
              );
            }
          } catch (nbNotifyError) { /* Anzeige-Detail */ }
          try { nbMessen("byop_warenkorb_fehler", { grund: "abgelehnt" }); } catch (nbMessError) { /* messen darf nie blockieren */ }
          const nbAblehnungsFehler = new Error(nbErrMsg || `HTTP error! status: ${response.status}`);
          // Markierung, damit der aeussere catch (echte Netzfehler) dieselbe
          // Ablehnung nicht ein zweites Mal als "netz" zaehlt.
          nbAblehnungsFehler.nbGemessen = true;
          throw nbAblehnungsFehler;
        }

        const result = await response.json();

        // Native Bundles: Bundle-Metadaten fuer die Drawer/Cart-Anzeige merken (nur dieses Geraet).
        // Der Merge entfernt _palette_string von der Bundle-Zeile; ueber localStorage kann das
        // Theme trotzdem die Komposition (Pan-Thumbnails) und einen "weiter bearbeiten"-Link
        // (Designer mit ?pd=<paletteString>) anzeigen. Fehler hier duerfen das Add nie brechen.
        try {
          const nbProducts = (window.inlineData && window.inlineData.PaletteDesigner && window.inlineData.PaletteDesigner.products) || [];
          const nbFind = function (vId) {
            for (let i = 0; i < nbProducts.length; i++) {
              const si = nbProducts[i] && nbProducts[i].shopifyInfos;
              if (si && si.variantId === vId) return nbProducts[i];
            }
            return null;
          };
          const nbPans = [];
          // Original-Summe (Cents) der Einzelteile fuer die Ersparnis-Anzeige im Cart;
          // nur speichern, wenn alle Preise aufloesbar und in EINER Waehrung vorliegen.
          let nbOrig = 0;
          let nbCur = '';
          let nbOrigOk = true;
          const nbAddPrice = function (prod, qty) {
            const p = prod && prod.price;
            if (!p || typeof p.value !== 'number' || !p.currency) { nbOrigOk = false; return; }
            if (nbCur && p.currency !== nbCur) { nbOrigOk = false; return; }
            nbCur = p.currency;
            nbOrig += p.value * qty;
          };
          const nbBaseProd = (palette._palette && palette._palette.shopifyInfos) ? nbFind(palette._palette.shopifyInfos.variantId) : null;
          if (nbBaseProd) { nbAddPrice(nbBaseProd, 1); } else { nbOrigOk = false; }
          panMap.forEach(function (qty, vId) {
            const prod = nbFind(vId);
            let img = '';
            if (prod && prod.images) {
              for (let j = 0; j < prod.images.length; j++) {
                // thumbUri bevorzugen: diese Vorschau sitzt als winziges Kaestchen
                // in der Warenkorb-Zeile, das Originalbild waere dort Verschwendung.
                const eintrag = prod.images[j];
                const u = (eintrag && (eintrag.thumbUri || eintrag.uri)) || '';
                if (u && !/\.(mp4|webm|mov)(\?|$)/i.test(u)) { img = u; break; }
              }
            }
            nbAddPrice(prod, qty);
            nbPans.push({ t: (prod && prod.name) || '', img: img, q: qty });
          });
          // Echtes Paletten-Render (gleicher Server-Endpoint wie "Bild herunterladen" im
          // Share-Menue): URL merken und sofort vorwaermen -- der Erst-Render dauert
          // serverseitig ~10 s, danach liefert die URL aus dem Cache (<0,5 s). So ist
          // das Bild in der Regel fertig, bevor der Kunde in den Warenkorb schaut.
          let nbRenderUrl = '';
          try {
            const nbImgBase = (window.inlineData && window.inlineData.PaletteDesigner && window.inlineData.PaletteDesigner.imageUri) || '';
            if (nbImgBase) {
              nbRenderUrl = nbImgBase + '?pd=' + encodeURIComponent(paletteString);
              new Image().src = nbRenderUrl;
            }
          } catch (nbRenderError) { /* Anzeige-Detail, darf das Add nie brechen */ }
          const nbRaw = localStorage.getItem('nbBundleMeta');
          const nbStore = nbRaw ? JSON.parse(nbRaw) : {};
          nbStore[bundleInstanceId] = { ps: paletteString, pans: nbPans, ts: Date.now(), orig: nbOrigOk ? nbOrig : null, cur: nbOrigOk ? nbCur : null, render: nbRenderUrl };
          // Aufraeumen: maximal 20 Eintraege behalten (aelteste zuerst verwerfen).
          const nbKeys = Object.keys(nbStore);
          if (nbKeys.length > 20) {
            nbKeys.sort(function (a, b) { return (nbStore[a].ts || 0) - (nbStore[b].ts || 0); });
            for (let k = 0; k < nbKeys.length - 20; k++) delete nbStore[nbKeys[k]];
          }
          localStorage.setItem('nbBundleMeta', JSON.stringify(nbStore));
        } catch (nbMetaError) {
          console.warn('[BYOP][NB] bundle meta storage failed:', nbMetaError);
        }

        // Edit-Flow ("Palette bearbeiten" im Cart): stammt dieser Add aus einem Edit-Klick,
        // wird die ALTE Bundle-Zeile ersetzt (Menge 0 via Standard-Cart-API). Kontext wird
        // vom Cart-Enhancer (cart-drawer.liquid) als sessionStorage 'nbEditBundle' gesetzt,
        // gilt 30 Minuten und wird hier konsumiert (einmalig). Fehler -> alte Palette bleibt
        // einfach liegen (heutiges Verhalten), das Add selbst bricht NIE.
        try {
          const nbEditRaw = sessionStorage.getItem('nbEditBundle');
          if (nbEditRaw) {
            sessionStorage.removeItem('nbEditBundle');
            const nbEdit = JSON.parse(nbEditRaw);
            if (nbEdit && nbEdit.id && nbEdit.id !== bundleInstanceId && (Date.now() - (nbEdit.ts || 0)) < 1800000) {
              const nbOldCart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
              const nbOldLines = (nbOldCart.items || []).filter(function (it) {
                return it.properties && it.properties._BundleId === nbEdit.id;
              });
              // Die Theme-Sections werden hier NICHT mehr angefordert. Frueher
              // musste der letzte change-Call sie frisch nachladen, weil das
              // Drawer-HTML aus der Add-Antwort die inzwischen entfernte alte
              // Palette noch enthielt und der Drawer sie faelschlich weiter
              // anzeigte. Jetzt wird der Drawer ohnehin erst nach allen
              // Aenderungen geholt, siehe unten, damit ist der Stand in jedem
              // Fall frisch und diese Sonderbehandlung entfaellt.
              // Alle alten Zeilen in EINEM Aufruf entfernen statt in einem je Zeile.
              // Grund: die Geschenk-App ersetzt window.fetch und laesst jeden
              // /cart/-POST erst durch ihre komplette Regelauswertung laufen, bevor
              // sie die echte Anfrage abschickt. Bei 13 Einzelaufrufen zahlt der
              // Kunde diese Wartezeit dreizehnmal hintereinander, bei einem
              // update.js-Aufruf einmal. Shopify unterstuetzt die Sammelform direkt.
              if (nbOldLines.length > 0) {
                const nbUpdates = {};
                for (let nbIdx = 0; nbIdx < nbOldLines.length; nbIdx++) {
                  nbUpdates[nbOldLines[nbIdx].key] = 0;
                }
                let nbSammelOk = false;
                try {
                  const nbRes = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ updates: nbUpdates })
                  });
                  nbSammelOk = nbRes.ok;
                } catch (nbSammelFehler) {
                  nbSammelOk = false;
                }
                // Rueckfall auf Einzelaufrufe, falls die Sammelform nicht durchgeht.
                // Lieber langsam als eine alte Palette, die im Warenkorb stehen bleibt.
                if (!nbSammelOk) {
                  console.warn('[BYOP][NB] update.js fehlgeschlagen, entferne einzeln');
                  for (let nbIdx = 0; nbIdx < nbOldLines.length; nbIdx++) {
                    await fetch('/cart/change.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                      body: JSON.stringify({ id: nbOldLines[nbIdx].key, quantity: 0 })
                    });
                  }
                }
              }
              // Metadaten der ersetzten Palette entsorgen
              try {
                const nbRaw2 = localStorage.getItem('nbBundleMeta');
                if (nbRaw2) {
                  const nbStore2 = JSON.parse(nbRaw2);
                  delete nbStore2[nbEdit.id];
                  localStorage.setItem('nbBundleMeta', JSON.stringify(nbStore2));
                }
              } catch (e) { /* unkritisch */ }
            }
          }
        } catch (nbEditError) {
          console.warn('[BYOP][NB] edit-replace failed, old palette kept:', nbEditError);
        }

        // Warenkorb-Daten und Drawer-HTML parallel holen: zwei unabhaengige
        // Abrufe, die zusammen nur so lange dauern wie der laengere von beiden.
        const nbSectionIds = sectionsToBundle.filter(Boolean);
        const [cartJson, nbSections] = await Promise.all([
          fetch(`${window.FoxTheme.routes.cart_url}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          }).then((nbRes) => nbRes.json()),
          nbSectionIds.length
            ? (async () => {
                // KEIN 'Accept: application/json' mitschicken. Teuer gelernt am
                // 23.08.2026: Der Designer laeuft unter /products/palette-designer,
                // und auf einer Produktseite beantwortet Shopify die Anfrage mit
                // diesem Header als PRODUKT-JSON ({"product": {...}}, 1.896 Bytes),
                // die angeforderte Section fehlt darin komplett. Ohne den Header
                // kommt die erwartete Section-Map (19.181 Bytes).
                //
                // Ein Fehlversuch wird EINMAL wiederholt: von diesem Abruf haengt
                // ab, ob der Kunde seine neue Palette im Warenkorb sieht, dafuer
                // soll ein einzelner Netz-Aussetzer nicht reichen. Zurueck kommt
                // nur ein Ergebnis, das WIRKLICH jede angeforderte Section als
                // Text enthaelt, sonst null.
                const nbUrl = `${location.pathname}?sections=${encodeURIComponent(nbSectionIds.join(','))}`;
                for (let nbVersuch = 0; nbVersuch < 2; nbVersuch++) {
                  try {
                    const nbRes = await fetch(nbUrl);
                    if (nbRes.ok) {
                      const nbJson = await nbRes.json();
                      if (nbJson && nbSectionIds.every((nbId) => typeof nbJson[nbId] === 'string' && nbJson[nbId])) {
                        return nbJson;
                      }
                    }
                  } catch (nbFehler) { /* naechster Versuch */ }
                }
                console.warn('[BYOP] Drawer-HTML nicht abrufbar, der Warenkorb wird stattdessen nachgeladen.');
                return null;
              })()
            : Promise.resolve(null)
        ]);

        // Kam das Drawer-HTML vollstaendig an? Wurde gar keine Section
        // angefordert (kein Warenkorb-Drawer auf der Seite), ist ebenfalls alles
        // in Ordnung, dann gibt es schlicht nichts zu rendern.
        const nbDrawerOk = nbSectionIds.length === 0 || !!nbSections;

        // Jede erwartete Section wird als Text gesetzt. assets/cart.js liest
        // event.cart.sections[sectionId] ungeprueft und gibt den Wert an einen
        // DOMParser; ein leerer Text fuehrt dort dazu, dass nichts ausgetauscht
        // wird, statt dass halbfertiges Markup einlaeuft.
        cartJson['sections'] = nbSectionIds.reduce((nbAcc, nbId) => {
          const nbWert = nbSections && nbSections[nbId];
          nbAcc[nbId] = typeof nbWert === 'string' ? nbWert : '';
          return nbAcc;
        }, {});
        
        // Update internal cart state
        this._cart = {
          html: null,
          count: cartJson.item_count,
          data: cartJson
        };
        
        // Trigger callbacks
        for (let callback of this._callbacks) {
          callback({
            count: cartJson.item_count,
            cartData: cartJson,
            addedItems: result.items || [result]
          });
        }
        
        // Publish cart update event (Theme Pattern)
        if (window.FoxTheme && window.FoxTheme.pubsub) {
          window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        }
        
        // Publish legacy event
        Broker.default.publish("CartChanged", {
          count: this._cart.count,
          cartData: cartJson
        });
        
        // Dispatch product added event (Theme Pattern)
        document.dispatchEvent(
          new CustomEvent('product-ajax:added', {
            detail: {
              product: result,
            },
          })
        );
        
        // Warenkorb oeffnen. Im Normalfall reicht show(), das frische HTML
        // steckt bereits im Drawer.
        //
        // Kam das Drawer-HTML NICHT an, waere show() das Schlimmste: der Kunde
        // saehe einen leeren oder veralteten Warenkorb, obwohl seine Palette
        // serverseitig drin liegt, und legt sie im Zweifel ein zweites Mal an.
        // Dann stattdessen den Auffrischpfad des Themes anstossen: er holt die
        // Section selbst nach, tauscht sie aus und oeffnet danach (siehe
        // assets/cart.js, onCartRefresh). Kostet einen zusaetzlichen Abruf,
        // aber nur im Ausfall.
        const cartDrawerElement = document.querySelector('cart-drawer');
        if (nbDrawerOk) {
          if (cartDrawerElement && cartDrawerElement.show) {
            cartDrawerElement.show();
          }
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        }

        try {
          nbMessen("byop_warenkorb", {
            groesse: nbMessGroesse(palette.palette),
            farben: palette.pans.length,
            rabatt_prozent: Math.round((palette.discountPercentage || 0) * 100),
            wert_cent: cartJson.total_price
          });
        } catch (nbMessError) { /* messen darf nie blockieren */ }
        return result;
      } catch (error) {
        console.error('Error adding products to cart:', error);
        try {
          if (!(error && error.nbGemessen)) {
            nbMessen("byop_warenkorb_fehler", { grund: "netz" });
          }
        } catch (nbMessError) { /* messen darf nie blockieren */ }
        throw error;
      } finally {
        this._nbAddInFlight = false;
      }
    }
    async removeItem(item) {
      const result = await ApiClient.makeRequest("cart", "removeItem", {
        id: item
      });
      this._cart = result;
      Broker.default.publish("CartChanged", {
        count: this._cart.count
      });
      return result;
    }
    async setItemQuantity(item, quantity) {
      const result = await ApiClient.makeRequest("cart", "setItemQuantity", {
        id: item,
        quantity
      });
      this._cart = result;
      Broker.default.publish("CartChanged", {
        count: this._cart.count
      });
      return result;
    }
  };

  // palette-designer/models/custom-palette-model.js?r=4
  var AvailabilityBreakdown = class {
    constructor(inStock, backorder, outOfStock, comingSoon) {
      this._inStock = inStock;
      this._backorder = backorder;
      this._outOfStock = outOfStock;
      this._comingSoon = comingSoon;
    }
    get inStock() {
      return this._inStock;
    }
    get backorder() {
      return this._backorder;
    }
    get outOfStock() {
      return this._outOfStock;
    }
    get comingSoon() {
      return this._comingSoon;
    }
  };
  var CustomPaletteModel = class extends Model {
    constructor(palette, productsModel, serviceModel, userModel) {
      super();
      this._palette = palette;
      this._productsModel = productsModel;
      this._serviceModel = serviceModel;
      this._userModel = userModel;
      this._pans = [];
      this._undoStack = [];
      this._redoStack = [];
      this._isSaving = false;
      this._availabilityBreakdown = null;
      this._id = null;
      // Zwischenspeicher fuer Farben, die ein Groessenwechsel nicht mitnehmen
      // konnte (Wunsch der Geschaeftsfuehrung vom 04.09.2026: "Beim Wechsel von
      // grosser auf kleine Palette geloeschte Lidschatten sind auch nach
      // Rueckwechsel weg. Zwischenspeichern gewuenscht."). Jeder Eintrag merkt
      // sich Produkt-Id, die damalige Position in Millimetern und die Drehung,
      // damit die Farbe spaeter moeglichst an ihre alte Stelle zurueckkommt.
      this._nbGeparkt = [];
      // Wie viele Plaetze beim Wiedereinsetzen frei bleiben muessen. Nur der
      // Upgrade-Weg in addPan setzt das kurz auf 1: dort wartet die gerade
      // angetippte Farbe darauf, direkt nach dem Wechsel gesetzt zu werden.
      this._nbPlaetzeFreihalten = 0;
      // Zustand fuer die Messereignisse byop_palette_voll/byop_rabattstufe in
      // _notifyConfigurationChange: beide feuern nur bei einem UEBERGANG
      // gegenueber dem jeweils letzten Stand, nicht bei jedem Update.
      this._nbWarVoll = false;
      this._nbLetzterRabatt = 0;
    }
    set palette(value) {
      this._switchPalette(value);
      this._notifyPropertyChanged("palette");
      this._save();
      this._notifyConfigurationChange();
    }
    get name() {
      const staticText = window.inlineData?.PaletteDesigner?.staticText;
      
      if (this._pans.length < 1) {
        return staticText?.emptyPalette || "Empty palette";
      }
      let hasEyeshadows = false;
      let hasHighlighters = false;
      let hasFacePowder = false;
      let hasWaterLiners = false;
      
      for (let pan of this._pans) {
        // Safety check: skip if pan or pan.pan is invalid (e.g. offline products)
        if (!pan || !pan.pan || !pan.pan.type) {
          continue;
        }
        
        switch (pan.pan.type) {
          case "eyeshadow":
            hasEyeshadows = true;
            break;
          case "highlighter":
            hasHighlighters = true;
            break;
          case "face_powder":
            hasFacePowder = true;
            break;
        }
      }
      
      if (hasEyeshadows && !hasHighlighters && !hasFacePowder && !hasWaterLiners) {
        return staticText?.customEyeshadowPalette || "Custom eyeshadow palette";
      } else if (!hasEyeshadows && hasHighlighters && !hasFacePowder && !hasWaterLiners) {
        return staticText?.customHighlighterPalette || "Custom highlighter palette";
      } else if (!hasEyeshadows && !hasHighlighters && hasFacePowder && !hasWaterLiners) {
        return staticText?.customFacePowderPalette || "Custom face powder palette";
      } else if (!hasEyeshadows && !hasHighlighters && !hasFacePowder && hasWaterLiners) {
        return staticText?.customWaterLinerPalette || "Custom water liner palette";
      } else if (!hasEyeshadows && (hasHighlighters || hasFacePowder) && !hasWaterLiners) {
        return staticText?.customFacePalette || "Custom face palette";
      } else {
        return staticText?.customPalette || "Custom palette";
      }
    }
    get palette() {
      return this._palette;
    }
    get pans() {
      return this._pans;
    }
    get id() {
      return this._id;
    }
    set id(value) {
      this._id = value;
      this._notifyPropertyChanged("id");
    }
    get isComplete() {
      if (this._palette.hasSlots) {
        return this._pans.length >= this._palette.rows * this._palette.columns;
      } else {
        const availableArea = this._palette.slotWidth * this._palette.slotHeight;
        let usedArea = 0;
        for (let pan of this._pans) {
          const panArea = pan.orientedWidth * pan.orientedHeight;
          usedArea += panArea;
        }
        return usedArea >= availableArea;
      }
    }
    get originalPrice() {
      return this._pans.reduce((previous, current) => current.pan.originalPrice + previous, 0) + this._palette.originalPrice;
    }
    _productGetPrice(product, discountPercent = 0) {
      const price = product.price;
      if (product.paletteDesignerDiscount <= 0) {
        // GEÄNDERT: Runde auch reguläre Preise auf Produktebene
        return Math.round(price * 100) / 100;
      } else {
        const discountedPrice = Math.min(product.price, product.originalPrice - product.originalPrice * (discountPercent * product.paletteDesignerDiscount));
        // GEÄNDERT: Runde jeden Produktpreis einzeln (wie Shopify es macht)
        return Math.round(discountedPrice * 100) / 100;
      }
    }
    get maxDiscountEligibility() {
      const capacity = this._palette.eyeshadowEquivalentCapacity;
      if (capacity <= 6) {
        return window.inlineData.PaletteDesigner.discounts.small;
      } else if (capacity <= 9) {
        return window.inlineData.PaletteDesigner.discounts.medium;
      } else if (capacity <= 12) {
        return window.inlineData.PaletteDesigner.discounts.large;
      } else {
        return window.inlineData.PaletteDesigner.discounts.extraLarge;
      }
    }
    // Die automatischen Rabatte im Shop ("Custom Palette 5/10/15/20%") haengen
    // an der ARTIKELZAHL aus der Kollektion BYOP Products (ab 5, 10, 13 und 21
    // Artikeln, die Palette zaehlt mit), nicht an "Palette voll". Per
    // Warenkorb-API belegt am 03.09.2026: 12er + 4 Farben = 5 %, 12er + 9
    // Farben = 10 %. Bisher rechnete der Konfigurator erst bei voller Palette
    // und zeigte davor "-0 %", obwohl der Checkout schon Rabatt gab. Bei vollen
    // Lidschatten-Paletten ergibt die Artikelzahl dieselben Stufen wie vorher
    // (4er/6er 5 %, 9er 10 %, 12er 15 %, 24er 20 %). Die Stufen lassen sich
    // ueber inlineData.PaletteDesigner.discountTiers ueberschreiben, falls
    // Lethal die Rabatte im Admin aendert.
    get nbRabattStufen() {
      try {
        const vorgabe = window.inlineData.PaletteDesigner.discountTiers;
        if (Array.isArray(vorgabe) && vorgabe.length) {
          return vorgabe;
        }
      } catch (e) { /* keine Vorgabe, Standardstufen */ }
      return [[5, 0.05], [10, 0.1], [13, 0.15], [21, 0.2]];
    }
    get nbArtikelzahl() {
      return this._pans.length + 1;
    }
    get discountPercentage() {
      const anzahl = this.nbArtikelzahl;
      let anteil = 0;
      for (const stufe of this.nbRabattStufen) {
        if (anzahl >= stufe[0] && stufe[1] > anteil) {
          anteil = stufe[1];
        }
      }
      return anteil;
    }
    // Freie Plaetze, gemessen in normalen Lidschatten. Paletten mit Platzraster
    // zaehlen Plaetze; Paletten ohne Raster (die 24er, Gesichtspaletten)
    // rechnen die freie Flaeche in 26x26-mm-Pfaennchen um. Dient nur der Frage,
    // ob eine Rabattstufe in dieser Palette noch erreichbar ist.
    get nbFreiePlaetze() {
      try {
        if (this._palette.hasSlots) {
          return Math.max(0, this._palette.rows * this._palette.columns - this._pans.length);
        }
        const flaeche = this._palette.slotWidth * this._palette.slotHeight;
        let belegt = 0;
        for (const pan of this._pans) {
          belegt += pan.orientedWidth * pan.orientedHeight;
        }
        const frei = Math.floor((flaeche - belegt) / (26 * 26));
        return Number.isFinite(frei) ? Math.max(0, frei) : 0;
      } catch (e) {
        return 0;
      }
    }
    // Naechste Stufe, die in DIESER Palette noch erreichbar ist, sonst null.
    get nbErreichbareRabattstufe() {
      const naechste = this.nbNaechsteRabattstufe;
      return naechste && naechste.fehlen <= this.nbFreiePlaetze ? naechste : null;
    }
    // Naechste Rabattstufe oberhalb der aktuellen: wie viele Artikel fehlen und
    // welcher Anteil dann gilt. null, wenn es keine hoehere Stufe gibt.
    get nbNaechsteRabattstufe() {
      const anzahl = this.nbArtikelzahl;
      const aktuell = this.discountPercentage;
      let naechste = null;
      for (const stufe of this.nbRabattStufen) {
        if (stufe[0] > anzahl && stufe[1] > aktuell && (!naechste || stufe[0] < naechste.ab)) {
          naechste = { ab: stufe[0], fehlen: stufe[0] - anzahl, anteil: stufe[1] };
        }
      }
      return naechste;
    }
    get actualDiscountPercentage() {
      const savings = this.originalPrice - this.salePrice;
      const savingsPercent = savings / this.originalPrice;
      return savingsPercent;
    }
    get discountInformation() {
      const paletteDiscount = this.discountPercentage;
      const items = [
        {
          image: this._palette.image,
          name: this._palette.name,
          originalPrice: this._palette.originalPrice,
          discountedPrice: this._productGetPrice(this._palette, paletteDiscount),
          hasDiscount: this._palette.paletteDesignerDiscount > 0
        }
      ];
      for (const pan of this._pans) {
        items.push({
          image: pan.pan.image,
          name: pan.pan.name,
          originalPrice: pan.pan.originalPrice,
          discountedPrice: this._productGetPrice(pan.pan, paletteDiscount),
          hasDiscount: pan.pan.paletteDesignerDiscount > 0
        });
      }
      for (const item of items) {
        item.discountPercent = (item.originalPrice - item.discountedPrice) / item.originalPrice;
      }
      return items;
    }
    get salePrice() {
      if (!this.isOnSale) {
        return this.originalPrice;
      }
      const paletteDiscount = this.discountPercentage;
      let sum = this._productGetPrice(this._palette, paletteDiscount);
      for (const pan of this._pans) {
        const productPrice = this._productGetPrice(pan.pan, paletteDiscount);
        sum += productPrice;
      }
      return sum;
    }
    get price() {
      if (this.isOnSale) {
        return this.salePrice;
      } else {
        return this.originalPrice;
      }
    }
    get isOnSale() {
      // Frueher "isComplete": der Rabatt haengt aber an der Artikelzahl (siehe
      // discountPercentage), also gilt er auch fuer teilgefuellte Paletten.
      if (this.discountPercentage > 0) {
        return true;
      }
      for (let pan of this._pans) {
        if (pan.pan.isOnSale) {
          return true;
        }
      }
      return false;
    }
    _canHoldEyeshadows(palette) {
      // Check if palette can hold standard eyeshadows (26x26mm)
      const eyeshadowSize = 26;
      
      // Case 1: Slot-based palette with 26x26mm slots
      if (palette.slotWidth === eyeshadowSize && palette.slotHeight === eyeshadowSize) {
        return true;
      }
      
      // Case 2: Grid-based palette where eyeshadows fit on the grid
      // Eyeshadows need a grid that divides evenly (e.g., 13mm grid: 26/13 = 2)
      if (palette.gridWidth > 0 && palette.gridHeight > 0) {
        const fitsOnGridX = eyeshadowSize % palette.gridWidth === 0;
        const fitsOnGridY = eyeshadowSize % palette.gridHeight === 0;
        const hasEnoughSpace = palette.slotWidth >= eyeshadowSize && palette.slotHeight >= eyeshadowSize;
        
        return fitsOnGridX && fitsOnGridY && hasEnoughSpace;
      }
      
      return false;
    }
    
    _getNextLargerPalette() {
      const { eyeshadowEquivalentCapacity } = this._palette;
      
      // Check if current palette can hold eyeshadows
      const currentCanHoldEyeshadows = this._canHoldEyeshadows(this._palette);
      
      if (!currentCanHoldEyeshadows) {
        // For non-eyeshadow palettes, use exact slot size matching
        const { slotWidth, slotHeight } = this._palette;
        const compatiblePalettes = this._productsModel.asArray()
          .filter(item => 
            item instanceof PaletteModel &&
            item.slotWidth === slotWidth &&
            item.slotHeight === slotHeight
          )
          .sort((a, b) => a.eyeshadowEquivalentCapacity - b.eyeshadowEquivalentCapacity);
        
        return compatiblePalettes.find(
          palette => palette.eyeshadowEquivalentCapacity > eyeshadowEquivalentCapacity
        );
      }
      
      // For eyeshadow palettes, find any larger palette that can hold eyeshadows
      const compatiblePalettes = this._productsModel.asArray()
        .filter(item => 
          item instanceof PaletteModel &&
          this._canHoldEyeshadows(item)
        )
        .sort((a, b) => a.eyeshadowEquivalentCapacity - b.eyeshadowEquivalentCapacity);
      
      return compatiblePalettes.find(
        palette => palette.eyeshadowEquivalentCapacity > eyeshadowEquivalentCapacity
      );
    }
    // Abbildung der gesetzten Pans auf eine andere Palettengroesse. War bisher
    // der Rumpf von _switchPalette; herausgezogen, damit die Groessenleiste den
    // Verlust VOR dem Wechsel exakt vorhersagen kann (nbPredictPanLoss) statt
    // die Geometrie zu duplizieren. Rein lesend, keine Seiteneffekte.
    // nbVerloren: optionale Liste, in die jede NICHT uebernommene Farbe als
    // Park-Eintrag geschrieben wird (Id, Position in Millimetern, Drehung).
    // Bleibt sie null, ist die Funktion weiterhin reine Vorhersage.
    _nbMapPansToPalette(newPalette, nbVerloren = null) {
      const oldPalette = this._palette;
      const newPans = [];
      for (let pan of this._pans) {
        let x = 0;
        let y = 0;
        if (oldPalette.hasSlots) {
          x = pan.slotIndex % oldPalette.columns;
          y = Math.floor(pan.slotIndex / oldPalette.columns);
          x *= oldPalette.slotWidth;
          y *= oldPalette.slotHeight;
        } else {
          x = pan.gridOffsetX * oldPalette.gridWidth;
          y = pan.gridOffsetY * oldPalette.gridHeight;
        }
        // Merkzettel fuer eine Farbe, die diese Palettengroesse nicht mitnimmt.
        const nbFaelltRaus = () => {
          if (!nbVerloren || !pan.pan) {
            return;
          }
          nbVerloren.push({ id: pan.pan.id, x, y, rotation: pan.rotation });
        };
        let width = pan.orientedWidth;
        let height = pan.orientedHeight;
        if (newPalette.hasSlots) {
          if (newPalette.slotWidth !== width || newPalette.slotHeight !== height) {
            nbFaelltRaus();
            continue;
          }
          const slotX = x / newPalette.slotWidth;
          const slotY = y / newPalette.slotHeight;
          if (Math.floor(slotX) !== slotX || Math.floor(slotY) !== slotY || slotX >= newPalette.columns || slotY >= newPalette.rows) {
            nbFaelltRaus();
            continue;
          }
          let computedSlotIndex = slotX + slotY * newPalette.columns;
          newPans.push(new PlacedPanModel(pan.pan, computedSlotIndex, 0, 0, pan.rotation));
        } else {
          const maxX = x + width;
          const maxY = y + height;
          if (maxX <= newPalette.slotWidth && maxY <= newPalette.slotHeight) {
            newPans.push(new PlacedPanModel(
              pan.pan,
              0,
              x / newPalette.gridWidth,
              y / newPalette.gridHeight,
              pan.rotation
            ));
          } else {
            nbFaelltRaus();
          }
        }
      }
      return newPans;
    }
    // Wie viele Farben ein Wechsel auf newPalette verwerfen wuerde.
    nbPredictPanLoss(newPalette) {
      return this._pans.length - this._nbMapPansToPalette(newPalette).length;
    }
    // Legt Farben in den Zwischenspeicher. Aelteste Eintraege fallen heraus,
    // damit viele Wechsel hintereinander die Liste nicht unbegrenzt fuellen.
    _nbParken(verloren) {
      if (!Array.isArray(verloren) || verloren.length === 0) {
        return;
      }
      for (const eintrag of verloren) {
        if (!eintrag || eintrag.id === undefined || eintrag.id === null) {
          continue;
        }
        this._nbGeparkt.push(eintrag);
      }
      const grenze = 30;
      if (this._nbGeparkt.length > grenze) {
        this._nbGeparkt = this._nbGeparkt.slice(this._nbGeparkt.length - grenze);
      }
    }
    // Setzt eine geparkte Farbe an ihrer alten Stelle ein, sofern diese Stelle
    // in der jetzigen Palette ueberhaupt existiert und frei ist. simulateAdd
    // meldet jede Ueberdeckung; ohne diese Pruefung wuerde das Wiedereinsetzen
    // eine gesetzte Farbe verdraengen.
    _nbAnAlterStelle(produkt, eintrag) {
      try {
        const palette = this._palette;
        const x = Number(eintrag.x);
        const y = Number(eintrag.y);
        if (!Number.isFinite(x) || !Number.isFinite(y) || x < 0 || y < 0) {
          return false;
        }
        const rotation = eintrag.rotation || 0;
        const gedreht = rotation === 90 || rotation === 270;
        const breite = gedreht ? produkt.height : produkt.width;
        const hoehe = gedreht ? produkt.width : produkt.height;
        let kandidat = null;
        if (palette.hasSlots) {
          if (palette.slotWidth !== breite || palette.slotHeight !== hoehe) {
            return false;
          }
          const sx = x / palette.slotWidth;
          const sy = y / palette.slotHeight;
          if (Math.floor(sx) !== sx || Math.floor(sy) !== sy || sx >= palette.columns || sy >= palette.rows) {
            return false;
          }
          kandidat = new PlacedPanModel(produkt, sx + sy * palette.columns, 0, 0, rotation);
        } else {
          if (x + breite > palette.slotWidth || y + hoehe > palette.slotHeight) {
            return false;
          }
          const gx = x / palette.gridWidth;
          const gy = y / palette.gridHeight;
          if (Math.floor(gx) !== gx || Math.floor(gy) !== gy) {
            return false;
          }
          kandidat = new PlacedPanModel(produkt, 0, gx, gy, rotation);
        }
        if (this.simulateAdd(kandidat).length > 0) {
          return false;
        }
        this._pans.push(kandidat);
        return true;
      } catch (e) {
        return false;
      }
    }
    // Erster freier Platz, ohne Undo-Punkt und ohne Benachrichtigung. Entspricht
    // addAtFirstAvailableSlot, das hier nicht taugt: es legt einen eigenen
    // Undo-Schritt an, und der Groessenwechsel soll EIN Schritt bleiben.
    _nbStillEinsetzen(produkt) {
      try {
        if (this._palette.hasSlots) {
          if (produkt.width !== this._palette.slotWidth || produkt.height !== this._palette.slotHeight) {
            return false;
          }
          const index = this._getFirstAvailableSlotIndex();
          if (index === null) {
            return false;
          }
          this._pans.push(new PlacedPanModel(produkt, index));
          return true;
        }
        let rotation = 0;
        let versatz = this._getFirstAvailableGridOffset(produkt.width, produkt.height);
        if (versatz === null) {
          versatz = this._getFirstAvailableGridOffset(produkt.width, produkt.height, true);
          rotation = 90;
        }
        if (versatz === null) {
          return false;
        }
        this._pans.push(new PlacedPanModel(produkt, 0, versatz.x, versatz.y, rotation));
        return true;
      } catch (e) {
        return false;
      }
    }
    // Holt so viele geparkte Farben zurueck, wie in die jetzige Palette passen:
    // in der Reihenfolge, in der sie herausgefallen sind, moeglichst an die alte
    // Stelle, sonst auf den naechsten freien Platz. Uebersprungen wird, was
    // schon in der Palette liegt oder inzwischen ausverkauft ist; was nicht
    // passt, bleibt geparkt. Liefert die Zahl der wieder eingesetzten Farben.
    _nbWiedereinsetzen() {
      if (!Array.isArray(this._nbGeparkt) || this._nbGeparkt.length === 0) {
        return 0;
      }
      const reserve = Math.max(0, this._nbPlaetzeFreihalten || 0);
      const bleibt = [];
      let gesetzt = 0;
      for (const eintrag of this._nbGeparkt) {
        const produkt = eintrag && this._productsModel.lookup(eintrag.id);
        // Produkt nicht mehr im Katalog oder nicht bestellbar: der Eintrag
        // bringt nichts mehr und wird nicht weiter mitgeschleppt.
        if (!produkt || produkt.isSoldOut) {
          continue;
        }
        // Liegt die Farbe inzwischen wieder in der Palette (von Hand gesetzt),
        // waere das Wiedereinsetzen eine ungewollte Dopplung.
        if (this._pans.some((p) => p.pan && p.pan.id === produkt.id)) {
          continue;
        }
        if (this.nbFreiePlaetze <= reserve) {
          bleibt.push(eintrag);
          continue;
        }
        if (this._nbAnAlterStelle(produkt, eintrag) || this._nbStillEinsetzen(produkt)) {
          gesetzt++;
        } else {
          bleibt.push(eintrag);
        }
      }
      this._nbGeparkt = bleibt;
      return gesetzt;
    }
    // Eine Farbe, die der Kunde gerade selbst in die Hand nimmt, hat im
    // Zwischenspeicher nichts mehr verloren. Ohne das setzt der Upgrade-Weg die
    // geparkte Fassung kurz vor seinem eigenen Tap noch einmal ein und die
    // Farbe laege doppelt in der Palette; und eine von Hand entfernte Farbe
    // kaeme beim naechsten Vergroessern ungefragt zurueck.
    nbVergissGeparkte(produkt) {
      try {
        if (!produkt || produkt.id === undefined || produkt.id === null) {
          return;
        }
        this._nbGeparkt = this._nbGeparkt.filter((e) => e.id !== produkt.id);
      } catch (e) { /* der Zwischenspeicher ist Zusatzkomfort */ }
    }
    _nbMeldeWiedereingesetzt(anzahl) {
      try {
        if (!anzahl || anzahl < 1) {
          return;
        }
        const text = anzahl === 1
          ? txt("relaunchParkedBackOne", "One shade is back in your palette.")
          : T(txt("relaunchParkedBackMessage", "{count} shades are back in your palette."), { count: anzahl });
        Notification.show(txt("relaunchParkedBackHeadline", "Your shades are back"), text);
      } catch (e) { /* die Meldung ist Beiwerk, der Wechsel zaehlt */ }
      try { nbMessen("byop_farben_zurueck", { anzahl }); } catch (e) { /* messen darf nie blockieren */ }
    }
    _switchPalette(newPalette) {
      this._saveUndo();
      const nbVerloren = [];
      const newPans = this._nbMapPansToPalette(newPalette, nbVerloren);
      if (newPans.length < this._pans.length) {
        Broadcast.send("paletteChangedWithPanLoss");
      }
      this._pans = newPans;
      this._palette = newPalette;
      // Zwischenspeicher: erst die frueher geparkten Farben zurueckholen (die
      // neue Groesse kann Platz haben), danach die Farben parken, die GERADE
      // herausgefallen sind. Diese Reihenfolge haelt die Rueckfrage ehrlich:
      // was der Dialog als "passt nicht" angekuendigt hat, bleibt draussen und
      // taucht nicht im selben Schritt an anderer Stelle wieder auf.
      // Alles in try/catch: ein Fehler hier darf den Groessenwechsel nicht
      // aufhalten, sonst haengt die Palette zwischen zwei Groessen.
      let nbZurueck = 0;
      try {
        nbZurueck = this._nbWiedereinsetzen();
        this._nbParken(nbVerloren);
      } catch (e) {
        console.warn("[BYOP][NB] Zwischenspeicher beim Groessenwechsel uebersprungen", e);
      }
      if (nbZurueck > 0) {
        this._nbMeldeWiedereingesetzt(nbZurueck);
      }
    }
    _notifyConfigurationChange(incremental = true) {
      this._notifyPropertyChanged("pans" + (incremental ? "[]" : ""));
      this._notifyPropertyChanged("originalPrice");
      this._notifyPropertyChanged("price");
      this._notifyPropertyChanged("isOnSale");
      // Waehrend der Kunde baut, den Zwischenspeicher der Geschenk-App fuellen,
      // damit der spaetere Klick auf "In den Warenkorb" nicht darauf warten muss.
      // Scheitert das aus irgendeinem Grund, bleibt alles wie bisher.
      try { nbEgVorwaermen(this); } catch (e) { /* darf den Designer nie stoeren */ }
      try { nbRenderVorwaermen(this); } catch (e) { /* darf den Designer nie stoeren */ }
      // byop_palette_voll: nur beim UEBERGANG auf voll, nicht bei jedem
      // weiteren Update, nach Leeren und erneutem Fuellen feuert es wieder,
      // weil _nbWarVoll dann wieder false stand.
      try {
        const nbVollJetzt = this.isComplete;
        if (nbVollJetzt && !this._nbWarVoll) {
          nbMessen("byop_palette_voll", { groesse: nbMessGroesse(this._palette) });
        }
        this._nbWarVoll = nbVollJetzt;
      } catch (e) { /* messen darf nie blockieren */ }
      // byop_rabattstufe: nur wenn der Prozentsatz gegenueber dem LETZTEN
      // Stand steigt (nicht dem hoechsten je erreichten), siehe Auftrag.
      try {
        const nbRabattJetzt = this.discountPercentage;
        if (nbRabattJetzt > (this._nbLetzterRabatt || 0)) {
          nbMessen("byop_rabattstufe", { prozent: Math.round(nbRabattJetzt * 100) });
        }
        this._nbLetzterRabatt = nbRabattJetzt;
      } catch (e) { /* messen darf nie blockieren */ }
    }
    _getFirstAvailableSlotIndex() {
      const occupiedSlots = {};
      for (let pan of this._pans) {
        occupiedSlots[pan.slotIndex] = true;
      }
      for (let i = 0; i < this.palette.columns * this.palette.rows; i++) {
        if (!occupiedSlots[i]) {
          return i;
        }
      }
      return null;
    }
    _getFirstAvailableGridOffset(width, height, rotate = false) {
      let widthInGridUnits = width / this.palette.gridWidth;
      let heightInGridUnits = height / this.palette.gridHeight;
      if (rotate) {
        [widthInGridUnits, heightInGridUnits] = [heightInGridUnits, widthInGridUnits];
      }
      const horzCells = this.palette.slotWidth / this.palette.gridWidth;
      const vertCells = this.palette.slotHeight / this.palette.gridHeight;
      const lookup = [];
      for (let j = 0; j < vertCells; j++) {
        const row = [];
        for (let i = 0; i < horzCells; i++) {
          row.push(false);
        }
        lookup.push(row);
      }
      
      for (let pan of this._pans) {
        const panWidth = pan.orientedWidth / this.palette.gridWidth;
        const panHeight = pan.orientedHeight / this.palette.gridHeight;
        for (let j = pan.gridOffsetY; j < pan.gridOffsetY + panHeight; j++) {
          for (let i = pan.gridOffsetX; i < pan.gridOffsetX + panWidth; i++) {
            lookup[j][i] = true;
          }
        }
      }
      let x = 0;
      let y = 0;
      while (true) {
        let isAvailable = true;
        for (let j = y; j < y + heightInGridUnits; j++) {
          for (let i = x; i < x + widthInGridUnits; i++) {
            if (lookup[j][i]) {
              isAvailable = false;
              break;
            }
          }
          if (!isAvailable) {
            break;
          }
        }
        if (isAvailable) {
          return { x, y };
        }
        x++;
        if (x + widthInGridUnits > horzCells) {
          x = 0;
          y++;
        }
        if (y + heightInGridUnits > vertCells) {
          break;
        }
      }
      return null;
    }
    addAtFirstAvailableSlot(pan) {
      if (this.palette.hasSlots) {
        if (pan.width !== this.palette.slotWidth || pan.height !== this.palette.slotHeight) {
          return false;
        }
        const firstAvailableSlotIndex = this._getFirstAvailableSlotIndex();
        if (firstAvailableSlotIndex !== null) {
          this.add(new PlacedPanModel(pan, firstAvailableSlotIndex));
          return true;
        } else {
          return false;
        }
      } else {
        let rotation = 0;
        let gridOffset = this._getFirstAvailableGridOffset(pan.width, pan.height);
        if (gridOffset === null) {
          gridOffset = this._getFirstAvailableGridOffset(pan.width, pan.height, true);
          rotation = 90;
        }
        if (gridOffset !== null) {
          this.add(new PlacedPanModel(pan, 0, gridOffset.x, gridOffset.y, rotation));
          return true;
        } else {
          return false;
        }
      }
    }
    add(pan, originalPan = null) {
      if (!originalPan) {
        this._saveUndo();
      }
      const changes = this.simulateAdd(pan, originalPan);
      for (let change of changes) {
        this._removeWithoutNotification(change.pan);
        if (change.change === "swap") {
          this._pans.push(new PlacedPanModel(
            change.pan.pan,
            originalPan.slotIndex,
            originalPan.gridOffsetX,
            originalPan.gridOffsetY,
            change.pan.rotation
          ));
        }
      }
      this._pans.push(pan);
      // Nur ein echtes Neu-Setzen (kein Verschieben/Tauschen innerhalb der
      // Palette, siehe originalPan) zaehlt als "erste Farbe". unserialize()
      // (gespeicherte/geteilte Palette, Undo/Redo) setzt _pans direkt und
      // laeuft nie ueber add(), zaehlt also folgerichtig nicht mit.
      if (!originalPan) {
        try {
          if (!nbErsteFarbeGefeuert) {
            nbErsteFarbeGefeuert = true;
            nbMessen("byop_erste_farbe", {});
          }
        } catch (e) { /* messen darf nie blockieren */ }
      }
      this._save();
      this._notifyConfigurationChange();
    }
    simulateAdd(newPan, originalPan = null) {
      const changes = [];
      if (this.palette.hasSlots) {
        for (let pan of this._pans) {
          if (pan.slotIndex === newPan.slotIndex) {
            changes.push({
              pan,
              change: originalPan ? "swap" : "delete"
            });
          }
        }
      } else {
        const width = newPan.orientedWidth / this.palette.gridWidth;
        const height = newPan.orientedHeight / this.palette.gridHeight;
        const minX = newPan.gridOffsetX;
        const minY = newPan.gridOffsetY;
        const maxX = minX + width;
        const maxY = minY + height;
        for (let pan of this._pans) {
          const panWidth = pan.orientedWidth / this.palette.gridWidth;
          const panHeight = pan.orientedHeight / this.palette.gridHeight;
          if (maxX <= pan.gridOffsetX || minX >= pan.gridOffsetX + panWidth || maxY <= pan.gridOffsetY || minY >= pan.gridOffsetY + panHeight) {
            continue;
          }
          const canSwap = originalPan && panWidth === width && panHeight === height && minX === pan.gridOffsetX && minY === pan.gridOffsetY;
          changes.push({
            pan,
            change: canSwap ? "swap" : "delete"
          });
        }
      }
      return changes;
    }
    // Zustand fuer Undo/Redo. Anders als serialize() nimmt er die Parkliste
    // mit: nach einem "Zurueck" muss der Zwischenspeicher wieder zu der
    // Palette passen, die gerade hergestellt wurde. Bewusst NICHT in
    // serialize() selbst, dessen Ergebnis landet auch im Teilen-Link (?pd=)
    // und in der gespeicherten Palette.
    _nbSnapshot() {
      const zustand = this.serialize();
      try {
        zustand.nbGeparkt = this._nbGeparkt.map((e) => ({ id: e.id, x: e.x, y: e.y, rotation: e.rotation }));
      } catch (e) {
        zustand.nbGeparkt = [];
      }
      return zustand;
    }
    _saveUndo() {
      this._redoStack.length = 0;
      this._undoStack.push(this._nbSnapshot());
      this._notifyPropertyChanged("canUndo");
      this._notifyPropertyChanged("canRedo");
    }
    get canUndo() {
      return this._undoStack.length > 0;
    }
    get canRedo() {
      return this._redoStack.length > 0;
    }
    undo() {
      if (this._undoStack.length > 0) {
        this._redoStack.push(this._nbSnapshot());
        this.unserialize(this._undoStack.pop());
      }
      this._save();
      this._notifyPropertyChanged("canUndo");
      this._notifyPropertyChanged("canRedo");
    }
    redo() {
      if (this._redoStack.length > 0) {
        this._undoStack.push(this._nbSnapshot());
        this.unserialize(this._redoStack.pop());
      }
      this._save();
      this._notifyPropertyChanged("canUndo");
      this._notifyPropertyChanged("canRedo");
    }
    get isSaving() {
      return this._isSaving;
    }
    _removeWithoutNotification(pan) {
      const index = this._pans.indexOf(pan);
      if (index < 0) {
        return;
      }
      this._pans.splice(index, 1);
    }
    remove(pan) {
      this._saveUndo();
      // Von Hand entfernte Farben werden nicht geparkt (und eine frueher
      // geparkte Fassung wird vergessen), sonst holt der naechste Wechsel auf
      // eine groessere Palette genau das zurueck, was der Kunde weghaben wollte.
      this.nbVergissGeparkte(pan && pan.pan);
      this._removeWithoutNotification(pan);
      this._save();
      this._notifyConfigurationChange();
    }
    // Was in dieser Palette steckt, das beim Hinzufuegen Aerger macht. Wird fuer
    // die Markierung am Warenkorb-Button gebraucht, damit der Kunde den Konflikt
    // sieht, BEVOR er klickt -- bisher merkte er es erst am Hinweisfenster danach.
    // Doppelte Farben werden nur einmal gezaehlt.
    get availabilityHinweis() {
      const ausverkauft = [];
      const vorbestellung = [];
      const pruefe = (produkt) => {
        if (!produkt) {
          return;
        }
        if (produkt.isSoldOut) {
          if (!ausverkauft.find((p) => p.id === produkt.id)) {
            ausverkauft.push(produkt);
          }
        } else if (produkt.isPreorder) {
          if (!vorbestellung.find((p) => p.id === produkt.id)) {
            vorbestellung.push(produkt);
          }
        }
      };
      pruefe(this._palette);
      this._pans.forEach((placedPan) => pruefe(placedPan.pan));
      // Die Basis-Palette selbst laesst sich nicht herausnehmen. Nur wenn
      // ausverkaufte PANS drin sind, kann Aufraeumen ueberhaupt helfen.
      const entfernbar = this._pans.some((placedPan) => placedPan.pan.isSoldOut);
      return { ausverkauft, vorbestellung, entfernbar };
    }
    // Entfernt alle ausverkauften Farben in einem Rutsch. Bewusst EIN Undo-Punkt
    // und EINE Benachrichtigung, sonst muesste der Kunde neunmal auf Rueckgaengig
    // klicken und die Palette wuerde neunmal neu aufgebaut.
    // zusaetzlicheIds: optional ein Set von Produkt-IDs, die der Server als
    // ausverkauft gemeldet hat, obwohl der Katalog sie noch fuehrt.
    removeSoldOutPans(zusaetzlicheIds = null) {
      const betroffen = this._pans.filter((placedPan) => placedPan.pan.isSoldOut
        || (zusaetzlicheIds && zusaetzlicheIds.has(placedPan.pan.id)));
      if (betroffen.length === 0) {
        return 0;
      }
      this._saveUndo();
      betroffen.forEach((placedPan) => this._removeWithoutNotification(placedPan));
      this._save();
      this._notifyConfigurationChange();
      return betroffen.length;
    }
    serialize() {
      return {
        palette: this._palette.id,
        pans: this._pans.map((pan) => {
          return {
            id: pan.pan.id,
            slotIndex: pan.slotIndex,
            gridOffsetX: pan.gridOffsetX,
            gridOffsetY: pan.gridOffsetY,
            rotation: pan.rotation
          };
        })
      };
    }
    unserialize(data, forcePaletteChange = false) {
      const palette = this._productsModel.lookup(data.palette);
      if (palette.id !== this.palette.id) {
        this._palette = palette;
        this._notifyPropertyChanged("palette");
      } else if (forcePaletteChange) {
        this._notifyPropertyChanged("palette");
      }
      
      // Filter out pans that reference products that no longer exist (offline products)
      const loadedPans = [];
      const missingProductIds = [];
      
      for (const panData of data.pans) {
        const product = this._productsModel.lookup(panData.id);
        
        if (product) {
          // Product exists, add it normally
          loadedPans.push(new PlacedPanModel(
            product,
            panData.slotIndex,
            panData.gridOffsetX,
            panData.gridOffsetY,
            panData.rotation
          ));
        } else {
          // Product not found (likely offline), skip it silently
          missingProductIds.push(panData.id);
        }
      }
      
      this._pans = loadedPans;

      // Parkliste: kommt sie aus einem Undo- oder Redo-Schritt mit, wird sie
      // mit wiederhergestellt. Jede andere Quelle (gespeicherte Palette,
      // geteilter Link ?pd=, Zufallsgenerator) startet bewusst ohne geparkte
      // Farben, sonst rutschten sie in eine fremde Palette.
      this._nbGeparkt = Array.isArray(data.nbGeparkt)
        ? data.nbGeparkt.map((e) => ({ id: e.id, x: e.x, y: e.y, rotation: e.rotation }))
        : [];

      // Notify user if some products couldn't be loaded
      if (missingProductIds.length > 0) {
        // Show a user-friendly notification
        if (typeof Notification !== 'undefined' && Notification.show) {
          Notification.show(
            T("Some products unavailable"),
            T(`${missingProductIds.length} product(s) from your palette are no longer available and were automatically removed.`)
          );
        }
      }
      
      this._notifyConfigurationChange(false);
    }
    async addToCart(allowBackorder = true) {
      try {
        const outOfStockItems = [];
        const backorderItems = [];
        const comingSoonItems = [];
        
        if (this._palette.availability === 'out_of_stock') {
          outOfStockItems.push(this._palette);
        } else if (this._palette.availability === 'backorder') {
          backorderItems.push(this._palette);
        } else if (this._palette.availability === 'coming_soon') {
          comingSoonItems.push(this._palette);
        }
        
        this._pans.forEach(placedPan => {
          const pan = placedPan.pan;
          if (pan.availability === 'out_of_stock') {
            if (!outOfStockItems.find(p => p.id === pan.id)) {
              outOfStockItems.push(pan);
            }
          } else if (pan.availability === 'backorder') {
            if (!backorderItems.find(p => p.id === pan.id)) {
              backorderItems.push(pan);
            }
          } else if (pan.availability === 'coming_soon') {
            if (!comingSoonItems.find(p => p.id === pan.id)) {
              comingSoonItems.push(pan);
            }
          }
        });
        
        if (outOfStockItems.length > 0 || comingSoonItems.length > 0 || (backorderItems.length > 0 && !allowBackorder)) {
          
          this._availabilityBreakdown = new AvailabilityBreakdown(
            [],
            backorderItems,
            outOfStockItems,
            comingSoonItems
          );
          try { nbMessen("byop_warenkorb_fehler", { grund: "ausverkauft" }); } catch (e) { /* messen darf nie blockieren */ }
          return false;
        }
        // Die fruehere Server-Verfuegbarkeitspruefung beim Agentur-Backend
        // (kombinat-berlin, getAvailabilityBreakdown) ist hier bewusst entfernt
        // (18.08.2026). Sie war seit Wochen kaputt (HTTP 500, fehlende
        // Shopify-Berechtigung), kostete bis zu 924 ms vor jedem /cart/add und
        // lieferte nichts, was dieser Shop braucht: den Live-Bestand prueft
        // Shopify beim /cart/add selbst und nennt das betroffene Produkt (die
        // Meldung zeigen wir an), "coming soon" gibt es im Katalog nicht, und der
        // Vorbestell-Bestaetigungsdialog ist nicht gewuenscht (markieren statt
        // blockieren). Die Pruefung auf Ausverkauft oben laeuft ohne Netzwerk aus
        // den Katalogdaten. Nebeneffekt: der Paletteninhalt geht beim
        // Hinzufuegen nicht mehr an einen Drittserver.
        this._nbNachWarenkorbLeeren(Cart.current.addItem(this, 1));
        return true;
      } catch (e) {
        console.error("Availability check failed, adding all products to cart as fallback:", e);
        // Fallback: Add all products to cart if availability check fails
        try {
          this._nbNachWarenkorbLeeren(Cart.current.addItem(this, 1));
          return true;
        } catch (cartError) {
          console.error("Cart fallback also failed:", cartError);
          Broadcast.send("asyncRequestFailed", cartError);
          return false;
        }
      }
    }
    // Die Parkliste gilt nur fuer die Palette, an der gerade gebaut wird. Liegt
    // sie im Warenkorb, ist der Vorgang abgeschlossen und geparkte Farben
    // duerfen nicht in die naechste Palette rutschen. Erst nach der Zusage des
    // Shops leeren: ein abgelehntes oder doppelt angestossenes Add (addItem
    // liefert dann null) laesst den Zwischenspeicher stehen.
    _nbNachWarenkorbLeeren(versprechen) {
      try {
        Promise.resolve(versprechen)
          .then((ergebnis) => { if (ergebnis) { this._nbGeparkt = []; } })
          .catch(() => { /* Add gescheitert, die Parkliste bleibt */ });
      } catch (e) { /* darf den Kauf nie stoeren */ }
    }
    loadSavedPalette(savedPalette) {
      this.unserialize(parsePaletteString(savedPalette.paletteString), true);
      this._id = savedPalette.id;
      this._notifyPropertyChanged("id");
    }
    async _save() {
      const nbWarGespeichert = !!this._id;
      this._isSaving = true;
      this._notifyPropertyChanged("isSaving");
      await this._userModel.savePalette(this);
      this._isSaving = false;
      this._notifyPropertyChanged("isSaving");
      // byop_palette_gespeichert: nur der UEBERGANG zu einer Server-ID zaehlt,
      // sonst feuerte das Ereignis bei jedem Autosave neu (_save laeuft bei
      // jeder Aenderung). Abgemeldete Kunden bekommen nie eine _id (siehe
      // UserModel.savePalette, nur localStorage), dort feuert es folgerichtig
      // nie: "gespeichert" heisst hier: im Kundenkonto abgelegt.
      try {
        if (!nbWarGespeichert && this._id && this._userModel.isLoggedIn) {
          nbMessen("byop_palette_gespeichert", {});
        }
      } catch (e) { /* messen darf nie blockieren */ }
    }
    load(palette) {
      this.unserialize(palette, true);
      this._id = null;
      this._notifyPropertyChanged("id");
    }
    reset(palette = null) {
      this._pans.length = 0;
      // Neue Palette heisst neuer Anfang: der Zwischenspeicher gehoert zur
      // alten Zusammenstellung und darf nicht in die neue hineinwirken.
      this._nbGeparkt = [];
      this._palette = palette || this._productsModel.defaultPalette;
      this._id = null;
      this._notifyPropertyChanged("palette");
      this._notifyPropertyChanged("id");
      this._notifyConfigurationChange(false);
    }
    get permaLink() {
      return window.inlineData.PaletteDesigner.longUrl + "?pd=" + stringifyPalette(this.serialize()) + (this._id ? "&sid=" + this._id : "");
    }
    get sharingLink() {
      return window.inlineData.PaletteDesigner.shortUrl + "?pd=" + stringifyPalette(this.serialize());
    }
    get sharingImageUri() {
      return window.inlineData.PaletteDesigner.imageUri + "?pd=" + stringifyPalette(this.serialize()) + "&format=shareable";
    }
    get availabilityBreakdown() {
      return this._availabilityBreakdown;
    }
  };

  // palette-designer/models/pal-model.js
  var PalModel = class extends Model {
    constructor(paletteModel, productsModel) {
      super();
      this._paletteModel = paletteModel;
      this._productsModel = productsModel;
      this._slots = [];
      this._rows = 0;
      this._columns = 0;
      this._hasStickyShadows = false;
      this._eyeshadows = productsModel.asArray().filter((product) => product.type === "eyeshadow");
      this._availableEyeshadows = this._eyeshadows.filter((product) => product.availability !== 'out_of_stock' && product.availability !== 'coming_soon');
      this._repeatShades = {};
      this._identifySlots();
      this._initialize();
    }
    _initialize() {
      for (let eyeshadow of this._eyeshadows) {
        for (let compareEyeshadow of this._eyeshadows) {
          if (eyeshadow === compareEyeshadow) {
            continue;
          }
          const hueDelta = Math.abs(eyeshadow.color.hsl[0] - compareEyeshadow.color.hsl[0]);
          const lightnessDelta = Math.abs(eyeshadow.color.hsl[2] - compareEyeshadow.color.hsl[2]);
          const isMatte = eyeshadow.finish.includes("matte");
          const compareIsMatte = compareEyeshadow.finish.includes("matte");
          if (isMatte !== compareIsMatte) {
            continue;
          }
          if (hueDelta < 0.03 && lightnessDelta < 0.15) {
            if (!Array.isArray(this._repeatShades[eyeshadow.id])) {
              this._repeatShades[eyeshadow.id] = [];
            }
            this._repeatShades[eyeshadow.id].push(compareEyeshadow);
          }
        }
      }
    }
    _identifySlots() {
      const paletteModel = this._paletteModel;
      const slots = [];
      const palette = paletteModel.palette;
      if (palette.hasSlots) {
        for (let j = 0; j < palette.rows; j++) {
          const row = [];
          for (let i = 0; i < palette.columns; i++) {
            row.push({
              slotIndex: i + j * palette.columns,
              gridOffsetX: 0,
              gridOffsetY: 0,
              rotation: 0
            });
          }
          slots.push(row);
        }
        this._rows = palette.rows;
        this._columns = palette.columns;
      } else {
        const panWidth = this._eyeshadows[0].width;
        const panHeight = this._eyeshadows[0].height;
        const columns = palette.slotWidth / panWidth;
        const rows = palette.slotHeight / panHeight;
        this._rows = rows;
        this._columns = columns;
        const panGridWidth = panWidth / palette.gridWidth;
        const panGridHeight = panHeight / palette.gridHeight;
        for (let j = 0; j < rows; j++) {
          const row = [];
          for (let i = 0; i < columns; i++) {
            row.push({
              slotIndex: 0,
              gridOffsetX: i * panGridWidth,
              gridOffsetY: j * panGridHeight,
              rotation: 0
            });
          }
          slots.push(row);
        }
      }
      this._slots = slots;
    }
    _createInitialPopulation(options) {
      const availableEyeshadows = this._availableEyeshadows;
      const numEyeshadows = availableEyeshadows.length;
      let population = new Array(this._rows * this._columns).fill(null);
      if (this._stickyShadows && !options.ignoreStickyShadows) {
        population = Array.from(this._stickyShadows);
      }
      let index = 0;
      for (let j = 0; j < this._rows; j++) {
        for (let i = 0; i < this._columns; i++) {
          if (population[index] !== null) {
            ++index;
            continue;
          }
          let randomEyeshadow;
          do {
            const randomIndex = Math.floor(Math.random() * numEyeshadows);
            randomEyeshadow = availableEyeshadows[randomIndex];
          } while (population.includes(randomEyeshadow));
          population[index] = randomEyeshadow;
          ++index;
        }
      }
      return population;
    }
    _getAdjacentPans(pan, population) {
      const index = population.indexOf(pan);
      const row = Math.floor(index / this._columns);
      const column = index % this._columns;
      let adjacentOffsets = [[0, -1], [1, 0], [0, 1], [-1, 0]];
      let adjacentPans = [];
      for (let offset of adjacentOffsets) {
        const adjacentColumn = column + offset[0];
        const adjacentRow = row + offset[1];
        const adjacentIndex = adjacentRow * this._columns + adjacentColumn;
        if (adjacentColumn >= 0 && adjacentColumn < this._columns && adjacentRow >= 0 && adjacentRow < this._rows) {
          adjacentPans.push(population[adjacentIndex]);
        } else {
          adjacentPans.push(null);
        }
      }
      return adjacentPans;
    }
    determinePaletteEligibility() {
      const panWidth = this._eyeshadows[0].width;
      const panHeight = this._eyeshadows[0].height;
      const panGridWidth = panWidth / this._paletteModel.palette.gridWidth;
      const panGridHeight = panHeight / this._paletteModel.palette.gridHeight;
      if (this._paletteModel.palette.hasSlots && (this._paletteModel.palette.slotWidth !== panWidth || this._paletteModel.palette.slotHeight !== panHeight)) {
        return "wrongSlotSize";
      } else if (this._paletteModel.pans.some((pan) => pan.pan.type !== "eyeshadow")) {
        return "paletteContainsNonEyeshadows";
      } else if (!this._paletteModel.palette.hasSlots && this._paletteModel.pans.some((pan) => pan.gridOffsetX % panGridWidth > 0 || pan.gridOffsetY % panGridHeight > 0)) {
        return "misalignedEyeshadow";
      }
      return "eligible";
    }
    getAffectedPans() {
      this._identifySlots();
      const affected = [];
      let index = 0;
      for (let row of this._slots) {
        for (let cell of row) {
          const item = this._paletteModel.pans.find((pan) => pan.slotIndex === cell.slotIndex && pan.gridOffsetX === cell.gridOffsetX && pan.gridOffsetY === cell.gridOffsetY);
          if (this._hasStickyShadows && this._stickyShadows) {
            if (!this._stickyShadows[index]) {
              affected.push(item);
            }
          } else {
            affected.push(item);
          }
          ++index;
        }
      }
      return affected;
    }
    _computeHueDelta(a, b) {
      let delta = b - a;
      delta += delta > 180 ? -360 : delta < -180 ? 360 : 0;
      return Math.abs(delta);
    }
    _score(population, options) {
      let matteCount = 0;
      let metallicCount = 0;
      let coolTonesCount = 0;
      let warmTonesCount = 0;
      let histogram = new Array(10).fill(0);
      let colorHistogram = new Array(6).fill(0);
      let lowContrastNeighbors = 0;
      let metallicNeighbors = 0;
      let neighborCount = 0;
      let repeatShadesCount = 0;
      let gradientOutliers = 0;
      let shadesMatchingPrimaryColor = 0;
      let shadesMatchingSecondaryColor = 0;
      const hasPrimaryColor = options.primaryColor !== null && options.primaryColor !== void 0;
      const hasSecondaryColor = options.secondaryColor !== null && options.primaryColor !== void 0;
      const shadowCount = this._rows * this._columns;
      for (let pan of population) {
        const panLightness = pan.color.hsl[2];
        const panHue = pan.color.hsl[0];
        histogram[Math.floor(Math.max(0, (panLightness * 10 - 1) * (10 / 9)))]++;
        let shiftedHue = panHue * 360 + 30;
        if (shiftedHue > 360) {
          shiftedHue -= 360;
        }
        colorHistogram[Math.floor(shiftedHue / 60)]++;
        if (hasPrimaryColor) {
          if (this._computeHueDelta(panHue * 360, options.primaryColor) < 40) {
            ++shadesMatchingPrimaryColor;
          }
        }
        if (hasSecondaryColor) {
          if (this._computeHueDelta(panHue * 360, options.secondaryColor) < 40) {
            ++shadesMatchingSecondaryColor;
          }
        }
        let isMatte = false;
        if (pan.finish.includes("matte")) {
          ++matteCount;
          isMatte = true;
        } else {
          ++metallicCount;
        }
        if (pan.color.tone === "warm") {
          ++warmTonesCount;
        } else {
          ++coolTonesCount;
        }
        const adjacentPans = this._getAdjacentPans(pan, population);
        let adjacentPanIndex = 0;
        for (let adjacentPan of adjacentPans) {
          ++adjacentPanIndex;
          if (!adjacentPan) {
            continue;
          }
          const adjacentPanLightness = adjacentPan.color.hsl[2];
          const adjacentPanHue = adjacentPan.color.hsl[0];
          const lightnessDelta = Math.abs(panLightness - adjacentPanLightness);
          const hueDelta = Math.abs(panHue - adjacentPanHue);
          if ((adjacentPanIndex === 1 || adjacentPanIndex === 4) && panLightness > adjacentPanLightness) {
            gradientOutliers += adjacentPanIndex === 4 ? 2 : 1;
          }
          let lowContrastThreshold = 0.1;
          const adjacentPanIsMatte = adjacentPan.finish.includes("matte");
          if (!isMatte && !adjacentPanIsMatte) {
            ++metallicNeighbors;
          }
          if (isMatte !== adjacentPanIsMatte) {
            lowContrastThreshold = 0.05;
          }
          if (lightnessDelta < lowContrastThreshold) {
            ++lowContrastNeighbors;
          } else if (hueDelta < lowContrastThreshold) {
            ++lowContrastNeighbors;
          }
          ++neighborCount;
        }
      }
      const lowContrastNeighborPercent = lowContrastNeighbors / neighborCount;
      const metallicNeighborsPercent = metallicNeighbors / neighborCount;
      const darkestIndex = histogram.findIndex((value) => value > 0);
      const lightestIndex = histogram.length - 1 - histogram.reverse().findIndex((value) => value > 0);
      histogram.reverse();
      const histogramSpread = lightestIndex - darkestIndex;
      const histogramPeak = histogram.reduce((prev, current) => Math.max(prev, current), 0);
      const colorSlots = colorHistogram.reduce((prev, current) => prev + (current === 0 ? 0 : 1), 0);
      const gradientOutlierPercent = gradientOutliers / shadowCount;
      let score = 0;
      let desiredMinLightness = options.minLightness * 10;
      let desiredMaxLightness = options.maxLightness * 10;
      let desiredLightnessSpread = desiredMaxLightness - desiredMinLightness;
      score += Math.abs(desiredLightnessSpread - histogramSpread) / desiredLightnessSpread * 1e4;
      score += Math.abs(darkestIndex - desiredMinLightness) / 10 * 4e5;
      score += Math.abs(lightestIndex - desiredMaxLightness) / 10 * 4e5;
      score += (histogramPeak - shadowCount / 10) * 1e3;
      score += lowContrastNeighborPercent * 1e4;
      score += metallicNeighborsPercent * 3e3;
      score += Math.abs(options.metallicsPercent - metallicCount / (matteCount + metallicCount)) * 5e4;
      if (!hasPrimaryColor && !hasSecondaryColor) {
        score += colorSlots * 3e5;
      }
      score += repeatShadesCount / 2 * 5e3;
      score += gradientOutlierPercent * 1e4;
      let primaryColorAbsoluteInfluence = options.primaryColorInfluence;
      let secondaryColorAbsoluteInfluence = options.secondaryColorInfluence;
      if (hasPrimaryColor && hasSecondaryColor) {
        const totalInfluence = primaryColorAbsoluteInfluence + secondaryColorAbsoluteInfluence;
        if (totalInfluence > 100) {
          primaryColorAbsoluteInfluence = primaryColorAbsoluteInfluence / totalInfluence;
          secondaryColorAbsoluteInfluence = secondaryColorAbsoluteInfluence / totalInfluence;
        }
      }
      if (hasPrimaryColor) {
        const expected = shadowCount * primaryColorAbsoluteInfluence;
        if (shadesMatchingPrimaryColor < expected) {
          score += (expected - shadesMatchingPrimaryColor) * 3e5;
        }
      }
      if (hasSecondaryColor) {
        const expected = shadowCount * secondaryColorAbsoluteInfluence;
        if (shadesMatchingSecondaryColor < expected) {
          score += (expected - shadesMatchingSecondaryColor) * 3e5;
        }
      }
      for (let pan of population) {
        const repeatShades = this._repeatShades[pan.id];
        if (repeatShades) {
          for (let repeatShade of repeatShades) {
            if (population.includes(repeatShade)) {
              score += 1e3;
            }
          }
        }
      }
      return score;
    }
    _serialize(population) {
      const serialized = {
        palette: this._paletteModel.palette.id,
        pans: []
      };
      let i = 0;
      for (let row of this._slots) {
        for (let cell of row) {
          serialized.pans.push(Object.assign({
            id: population[i++].id
          }, cell));
        }
      }
      return serialized;
    }
    debugScoreActivePalette(options) {
      this._identifySlots();
      const population = [];
      for (let row of this._slots) {
        for (let cell of row) {
          const item = this._paletteModel.pans.find((pan) => pan.slotIndex === cell.slotIndex && pan.gridOffsetX === cell.gridOffsetX && pan.gridOffsetY === cell.gridOffsetY);
          if (item) {
            population.push(item.pan);
          }
        }
      }
      const score = this._score(population, options);
      console.log(score);
    }
    captureStickyShadows() {
      this._identifySlots();
      const population = [];
      for (let row of this._slots) {
        for (let cell of row) {
          const item = this._paletteModel.pans.find((pan) => pan.slotIndex === cell.slotIndex && pan.gridOffsetX === cell.gridOffsetX && pan.gridOffsetY === cell.gridOffsetY);
          if (item) {
            population.push(item.pan);
          } else {
            population.push(null);
          }
        }
      }
      this._stickyShadows = population;
    }
    releaseStickyShadows() {
      this._stickyShadows = null;
    }
    _mutate(population, options, validIndices) {
      const mutated = Array.from(population);
      let randomEyeshadow;
      const availableEyeshadows = this._availableEyeshadows;
      const numEyeshadows = availableEyeshadows.length;
      do {
        const randomIndex2 = Math.floor(Math.random() * numEyeshadows);
        randomEyeshadow = availableEyeshadows[randomIndex2];
      } while (population.includes(randomEyeshadow));
      let randomIndex;
      if (!validIndices) {
        randomIndex = Math.floor(Math.random() * population.length);
      } else {
        const lookupIndex = Math.floor(Math.random() * validIndices.length);
        randomIndex = validIndices[lookupIndex];
      }
      mutated[randomIndex] = randomEyeshadow;
      return mutated;
    }
    get variations() {
      return this._variations;
    }
    generate(options) {
      this._identifySlots();
      let populations = [];
      for (let i = 0; i < 1e3; i++) {
        const candidate = this._createInitialPopulation(options);
        const score = this._score(candidate, options);
        populations.push([score, candidate]);
      }
      populations.sort((a, b) => a[0] - b[0]);
      populations = populations.slice(0, 10);
      let validIndices = null;
      if (this._stickyShadows && !options.ignoreStickyShadows) {
        validIndices = [];
        for (let i = 0; i < this._stickyShadows.length; i++) {
          if (this._stickyShadows[i] === null) {
            validIndices.push(i);
          }
        }
      }
      for (let i = 0; i < 1e3; i++) {
        for (let population of populations) {
          const candidate = this._mutate(population[1], options, validIndices);
          const score = this._score(candidate, options);
          if (score < population[0]) {
            population[1] = candidate;
            population[0] = score;
          }
        }
      }
      populations.sort((a, b) => a[0] - b[0]);
      populations = populations.slice(0, 5);
      this._variations = populations.map((value) => this._serialize(value[1]));
      this._notifyPropertyChanged("variations");
      this._hasStickyShadows = !options.ignoreStickyShadows;
    }
  };

  // views/modal-window.js
  var defaultModalWindowOptions = {
    lightDismiss: true,
    closeButton: true,
    headline: null,
    buttons: null,
    overflow: "inherit",
    maxHeight: "inherit",
    noPadding: false,
    noMargin: false
  };
  var ModalWindow2 = class {
    constructor(width, height, options = null) {
      this.width = width;
      this.height = height;
      this.options = Object.assign(Object.assign({}, defaultModalWindowOptions), options);
      this.element = $(`
            <div class="modal-window-container" style="overflow: ${this.options.overflow}">
                <section style="width: ${width}; height: ${height}; max-height: ${this.options.maxHeight};
                    overflow: ${this.options.overflow}" class="rows">
                    <header class="horizontal spaced full middle">
                        <h2 class="fill no-bottom-margin">Headline</h2>
                        <button class="close"></button>
                    </header>
                    <div class="content fill full" style="overflow: ${this.options.overflow}; ${this.options.noPadding ? "padding: 0;" : ""} ${this.options.noMargin ? "margin-top: 0;" : ""}"></div>
                    <footer class="horizontal spaced full right">
                        
                    </footer>
                </section>
            </div>
        `);
      if (this.options.lightDismiss) {
        this.element.on("click", () => this.hide());
        this.element.find("> section").on("click", (e) => e.stopPropagation());
      }
      this.element.find("header .close").toggle(this.options.closeButton).on("click", (e) => this.hide());
      this.element.find("header h2").text(this.options.headline || "");
      if (!this.options.closeButton && !this.options.headline) {
        this.element.find("header").hide();
        this.element.find(".content").addClass("small-space-before");
      }
      if (this.options.buttons) {
        this.options.buttons.forEach((button) => {
          const hollow = button.hollow ? ` class="hollow"` : "";
          const borderless = button.borderless ? ` class="borderless"` : "";
          const caption = button.caption || button;
          const data = button.hasOwnProperty("data") ? button.data : button.caption;
          const buttonElement = $(`<button${hollow}${borderless}>${caption}</button>`);
          buttonElement.data("value", data);
          this.element.find("> section > footer").append(buttonElement);
          buttonElement.click(() => {
            this.callback(data);
          });
        });
      } else {
        this.element.find("footer").hide();
      }
      $('#palette-designer-nh').append(this.element);
    }
    append(content) {
      this.element.find(".content").append(content);
    }
    show() {
      return new Promise((resolve, reject) => {
        this.callback = resolve;
        this._entfernt = false;
        // Das Einblenden lief frueher ungesichert nach 10 ms. Wurde der Dialog in
        // dieser Zeitspanne wieder geschlossen -- was bei schnellen Klicks und bei
        // programmatisch sofort verworfenen Dialogen passiert --, hat der Timer
        // die Klasse "visible" NACH dem Schliessen gesetzt. Ergebnis: der
        // abgedunkelte Hintergrund lag ueber der Seite, ohne Dialog, dauerhaft
        // und klickblockierend. Deshalb Timer merken und beim Schliessen stoppen.
        this._einblendTimer = window.setTimeout(() => {
          this._einblendTimer = null;
          if (this._entfernt) {
            return;
          }
          this.element.addClass("visible");
        }, 10);
      });
    }
    _stoppeEinblenden() {
      if (this._einblendTimer) {
        window.clearTimeout(this._einblendTimer);
        this._einblendTimer = null;
      }
    }
    hide() {
      if (this.onDismiss) {
        this.onDismiss();
      }
      // Fix: X-Button/Overlay-Dismiss liessen das show()-Promise ewig ungeloest --
      // Aufrufer wie AvailabilityView awaiten es, dadurch blieb der Add-to-Cart-
      // Button nach einem weggeklickten "Sold out"-Dialog dauerhaft gesperrt.
      // Dismiss bedeutet Abbruch -> wie der Close-Footer-Button mit false aufloesen.
      // (Mehrfach-resolve ist bei Promises ein No-op, daher kein Nullen noetig.)
      if (this.callback) {
        this.callback(false);
      }
      this._stoppeEinblenden();
      this.element.removeClass("visible");
    }
    remove() {
      this._entfernt = true;
      this._stoppeEinblenden();
      const element = this.element;
      const wegdamit = () => {
        element.off("transitionend");
        element.remove();
      };
      // Frueher hing das Entfernen allein an transitionend. Das Ereignis kommt
      // aber nur, wenn auch wirklich eine Ueberblendung laeuft. War der Dialog nie
      // eingeblendet oder schon wieder ausgeblendet, aendert removeClass nichts,
      // es gibt keine Ueberblendung, und das Element blieb fuer immer im DOM
      // liegen -- bei jedem Dialog eines mehr.
      if (!element.hasClass("visible")) {
        wegdamit();
        return;
      }
      element.removeClass("visible").one("transitionend", wegdamit);
      // Sicherheitsnetz: transitionend bleibt auch aus, wenn der Tab im
      // Hintergrund liegt oder der Nutzer Systemanimationen abgeschaltet hat.
      window.setTimeout(wegdamit, 600);
    }
  };

  // palette-designer/views/availability-view.js
  var AvailabilityView = class extends View {
    constructor(viewModel) {
      super(viewModel);
    }
    _renderList(title, list) {
      const items = [];
      items.push(`<h3>${title}</h3>`);
      items.push(`<ul compact="vertical">`);
      for (let item of list) {
        items.push(`
                <li class="horizontal middle">
                    <img src="${item.image}">
                    <div class="fields">
                        <p class="muted small">${item.productLine}</p>
                        <p>${item.name}</p>
                    </div>
                </li>
            `);
      }
      items.push("</ul>");
      return items.join("");
    }
    // kannAufraeumen: es liegen ausverkaufte PANS in der Palette, die sich
    // entfernen lassen. Ist nur die Basis-Palette ausverkauft, hilft Aufraeumen
    // nichts und der Button bleibt weg -- ein Knopf, der nichts bewirkt, ist
    // schlimmer als keiner.
    async show(kannAufraeumen = false) {
      const items = [];
      let hasOutOfStock = false;
      let hasComingSoon = false;
      if (this.viewModel.comingSoon.length > 0) {
        items.push(this._renderList(txt("availabilityListComingSoon", "Coming soon"), this._viewModel.comingSoon));
        hasComingSoon = true;
      }
      if (this.viewModel.outOfStock.length > 0) {
        items.push(this._renderList(txt("availabilityListSoldOut", "Sold out"), this._viewModel.outOfStock));
        hasOutOfStock = true;
      }
      if (this.viewModel.backorder.length > 0) {
        items.push(this._renderList(txt("availabilityListPreorder", "Preorder-only"), this._viewModel.backorder));
      }
      let title = "";
      let message = "";
      let buttons = null;
      const schliessen = txt("availabilityClose", "Close");
      if (hasOutOfStock) {
        title = txt("availabilitySoldOutHeadline", "Some shades are sold out");
        message = txt("availabilitySoldOutMessage", "You can swap them individually or remove them all at once.");
        // Bisher gab es hier NUR "Schliessen" -- eine Sackgasse: der Kunde musste
        // selbst herausfinden, welche seiner Farben das Problem sind, und sie
        // einzeln herausziehen.
        buttons = [{
          caption: schliessen,
          borderless: kannAufraeumen,
          data: false
        }];
        if (kannAufraeumen) {
          buttons.push({
            caption: txt("availabilityRemoveSoldOut", "Remove sold out"),
            data: "removeSoldOut"
          });
        }
      } else if (hasComingSoon) {
        title = txt("availabilityComingSoonHeadline", "Some shades are not available yet");
        message = txt("availabilityComingSoonMessage", "You can add your palette to cart once they have been released.");
        buttons = [{
          caption: schliessen,
          data: false
        }];
      } else {
        title = txt("availabilityPreorderHeadline", "Some shades are preorder-only");
        message = txt("availabilityPreorderMessage", "If you continue, your palette will ship in 1 to 2 weeks.");
        buttons = [
          {
            caption: txt("cancelButton", "Cancel"),
            borderless: true,
            data: false
          },
          {
            caption: txt("availabilityPreorderButton", "Preorder"),
            data: true
          }
        ];
      }
      const modalWindow = new ModalWindow2(
        "50em",
        "auto",
        {
          headline: title,
          closeButton: true,
          buttons
        }
      );
      const element = $(`
            <div class="availability-view vertical">
                <p>
                    ${message}
                </p>
                
                <div class="scroll-box fill space-above-m">
                    ${items.join("")}
                </div>
            </div>
        `);
      modalWindow.append(element);
      const result = await modalWindow.show();
      modalWindow.remove();
      return result;
    }
  };

  // palette-designer/view-models/availability-view-model.js
  var AvailabilityViewModel = class extends ViewModel {
    constructor(model) {
      super();
      this._model = model;
    }
    get inStock() {
      return this._model.inStock;
    }
    get backorder() {
      return this._model.backorder;
    }
    get outOfStock() {
      return this._model.outOfStock;
    }
    get comingSoon() {
      return this._model.comingSoon;
    }
  };

  // views/carousel.js
  var Carousel = class {
    constructor(element, autoRotateInterval = -1) {
      this._element = element;
      this._isDragging = false;
      this._offset = 0;
      this._index = 0;
      this._autoRotateInterval = autoRotateInterval;
      this._initializeView(element);
    }
    _initializeView(element) {
      this._slides = element.find(" .slide");
      this._slideCount = this._slides.length;
      this._dragStartHandle = (e) => this._handleDragStart(e);
      this._dragEndHandler = (e) => this._handleDragEnd(e);
      this._dragMoveHandler = (e) => this._handleDragMove(e);
      this._resizeHandler = (e) => this._handleResize(e);
      this._element.on("mousedown", this._dragStartHandle);
      this._element.on("touchstart", this._dragStartHandle);
      $(document).on("mouseup", this._dragEndHandler);
      $(document).on("touchend", this._dragEndHandler);
      $(document).on("mousemove", this._dragMoveHandler);
      $(document).on("touchmove", this._dragMoveHandler);
      $(window).on("resize", this._resizeHandler);
      this._prevButton = $(`
            <button class="previous">
                <span>${T("Previous")}</span>
            </button>
        `);
      this._nextButton = $(`
            <button class="next">
                <span>${T("Next")}</span>
            </button>
        `);
      this._prevButton.mousedown((e) => {
        e.stopPropagation();
        this._prev();
      });
      this._nextButton.mousedown((e) => {
        e.stopPropagation();
        this._next();
      });
      element.append(this._prevButton);
      element.append(this._nextButton);
      this._scheduleAutoRotate();
    }
    _scheduleAutoRotate() {
      if (this._autoRotateInterval <= 0) {
        return;
      }
      if (this._autoRotateTimer) {
        window.clearInterval(this._autoRotateTimer);
      }
      this._autoRotateTimer = window.setTimeout(() => this.next(), this._autoRotateInterval);
    }
    detach() {
      this._prevButton.remove();
      this._nextButton.remove();
      this._element.off("mousedown", this._dragStartHandle);
      this._element.off("touchstart", this._dragStartHandle);
      $(document).off("mouseup", this._dragEndHandler);
      $(document).off("touchend", this._dragEndHandler);
      $(document).off("mousemove", this._dragMoveHandler);
      $(document).off("touchmove", this._dragMoveHandler);
      $(window).off("resize", this._resizeHandler);
      this._element.find(".slide").css("margin-left", "");
    }
    get index() {
      return this._index;
    }
    _prev() {
      this._goto(this.index - 1, true, false);
    }
    _next() {
      this._goto(this.index + 1, true, false);
    }
    next() {
      this._goto(this.index + 1, true, true);
    }
    _goto(index, animate = true, wrapAround = false) {
      if (index < 0) {
        index = wrapAround ? this._slideCount - 1 : 0;
      } else if (index >= this._slideCount) {
        index = wrapAround ? 0 : this._slideCount - 1;
      }
      this._index = index;
      if (this.onchange) {
        this.onchange(index);
      }
      const oldOffset = parseInt(this._slides.first().css("margin-left"));
      this._offset = -(index * this._element.outerWidth());
      const offsetDelta = Math.abs(this._offset - oldOffset);
      if (animate) {
        this._slides.first().stop().animate({
          marginLeft: `${this._offset}px`
        }, offsetDelta / 2);
      } else {
        this._slides.first().css("margin-left", `${this._offset}px`);
      }
      this._scheduleAutoRotate();
    }
    _conformPointerEvent(e) {
      if (isNaN(parseInt(e.pageX)) && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches.length > 0) {
        e.pageX = e.originalEvent.changedTouches[0].pageX;
      }
      return e;
    }
    _handleResize(e) {
      this._goto(this._index, false);
    }
    _handleDragStart(e) {
      e = this._conformPointerEvent(e);
      this._isDragging = true;
      this._dragStartOffset = e.pageX;
      $(document.body).css("user-select", "none");
    }
    _handleDragEnd(e) {
      if (!this._isDragging) {
        return;
      }
      this._isDragging = false;
      e = this._conformPointerEvent(e);
      $(document.body).css("user-select", "");
      let newOffset = this._offset + (e.pageX - this._dragStartOffset);
      let index = Math.round(newOffset / this._element.outerWidth());
      this._goto(-index);
    }
    _handleDragMove(e) {
      if (!this._isDragging) {
        return;
      }
      e = this._conformPointerEvent(e);
      let delta = this._offset + (e.pageX - this._dragStartOffset);
      const overshoot = 0.1 * this._element.outerWidth();
      const max = (this._slideCount - 1) * this._element.outerWidth() + overshoot;
      const min = overshoot;
      if (delta < -max) {
        delta = -max;
      }
      if (delta > min) {
        delta = min;
      }
      this._slides.first().css("margin-left", `${delta}px`);
    }
  };

  // palette-designer/helpers/price.js
  // Frueher stand hier immer ein festes Euro-Zeichen vor der Zahl, auf jeder
  // Sprache und in jedem Markt, waehrend der Rest des Shops (Liquid-Filter
  // money) sprachrichtig formatiert. Jetzt richtet sich formatPrice nach der
  // Dokumentsprache (document.documentElement.lang) und der tatsaechlichen
  // Marktwaehrung: zuerst Shopify.currency.active, sonst die Katalogwaehrung
  // aus nbKatalogWaehrung (siehe ProductsModel._conformData). Fehlt beides
  // oder wirft Intl, greift das alte Verhalten als Rueckfall.
  let nbKatalogWaehrung = null;
  let nbPreisFormatiererSchluessel = null;
  let nbPreisFormatierer = null;
  function nbPreisAltesVerhalten(amount) {
    let fixed = amount.toFixed(2).replace(/,/g, ".");
    fixed = fixed.replace(
      ".",
      "."
      /*t("decimal_separator")*/
    );
    return "\u20AC%s".replace("%s", fixed);
  }
  function formatPrice(amount) {
    const sprache = (document.documentElement.lang || "en").trim() || "en";
    const waehrung = (window.Shopify && Shopify.currency && Shopify.currency.active) || nbKatalogWaehrung;
    if (typeof Intl === "undefined" || !Intl.NumberFormat || !waehrung) {
      return nbPreisAltesVerhalten(amount);
    }
    try {
      const schluessel = sprache + "|" + waehrung;
      if (nbPreisFormatiererSchluessel !== schluessel) {
        nbPreisFormatierer = new Intl.NumberFormat(sprache, { style: "currency", currency: waehrung });
        nbPreisFormatiererSchluessel = schluessel;
      }
      return nbPreisFormatierer.format(amount);
    } catch (fehler) {
      return nbPreisAltesVerhalten(amount);
    }
  }

  // palette-designer/views/product-details-view.js
  var ProductDetailsView = class {
    constructor(viewModel) {
      this._viewModel = viewModel;
    }
    async show() {
      const product = this._viewModel.product;
      const win = new ModalWindow2("35em", "auto", {
        headline: null,
        lightDismiss: false,
        buttons: [
          {
            caption: "Open product page",
            borderless: true,
            data: true
          },
          {
            caption: "close",
            data: false
          }
        ]
      });
      win.element.find("header").css("padding-bottom", 0);
      const body = $($("#product-details").html());
      win.append(body);
      console.log(product);
      const carouselElement = body.find(".carousel");
      body.find(".product-name").text(product.name);
      body.find(".product-line").text(product.productLine);
      body.find(".description").text(product.description);
      body.find(".price .current").text(formatPrice(product.price));
      body.find(".price .original").text(formatPrice(product.originalPrice)).toggle(product.isOnSale);
      const slidesElement = carouselElement.find(".slides");
      let gallery = [];
      if (product.gallery && product.gallery.length > 0) {
        gallery = product.gallery.slice(1).concat([product.gallery[0]]);
      }
      for (let medium of gallery) {
        slidesElement.append($(`
                <figure class="slide">${this._getMediaHtml(medium)}</figure>
            `));
      }
      const carousel = new Carousel(carouselElement);
      carousel.onchange = (index) => this._aktiviereSlide(slidesElement, index);
      this._aktiviereSlide(slidesElement, carousel.index);
      const geoeffnet = await win.show();
      // Karussell abmelden, BEVOR das Fenster aus dem DOM geht. Sonst haengt sein
      // window-resize-Handler weiter dran (auf dem Handy feuert resize bei jedem
      // Ein-/Ausblenden der Adressleiste), springt ueber onchange in
      // _aktiviereSlide und startet Videos in einem Baum, den niemand mehr sieht.
      carousel.onchange = null;
      carousel.detach();
      slidesElement.find("video").each((position, video) => video.pause());
      if (geoeffnet) {
        window.open(product.link);
      }
      win.remove();
    }
    // Erzeugt eine Slide. Frueher stand hier autoplay + preload="auto" und im
    // poster-Attribut die MP4-URL selbst. Damit hat JEDE Oeffnung des Modals
    // saemtliche Videos aller Slides vollstaendig geladen -- gemessen rund 10 MB,
    // obwohl der Kunde meist nur die erste Slide sieht. preload="none" allein
    // haette nichts gebracht: autoplay laedt trotzdem.
    // Jetzt traegt das video-Element keine Quelle, bis seine Slide dran ist
    // (siehe _aktiviereSlide). Sichtbar ist solange das echte Standbild.
    _getMediaHtml(medium) {
      const url = (medium && medium.uri) || "";
      if (!url) {
        return "";
      }
      if (url.includes(".mp4")) {
        const mp4Url = url.replace(/\.mp4.*$/g, ".mp4");
        const webmUrl = url.replace(/\.mp4.*$/g, ".webm");
        const poster = (medium && medium.posterUri) || "";
        return `<video muted playsinline loop preload="none"${poster ? ` poster="${poster}"` : ""}>
                <source data-src="${mp4Url}" type="video/mp4">
                <source data-src="${webmUrl}" type="video/webm">
            </video>`;
      } else {
        return `<img src="${url}" loading="lazy">`;
      }
    }
    // Spielt nur das Video der sichtbaren Slide und laedt seine Quelle erst hier.
    // Alle uebrigen werden angehalten, damit im Hintergrund nichts weiterlaeuft.
    _aktiviereSlide(slidesElement, index) {
      slidesElement.find("video").each((position, video) => {
        const slideIndex = $(video).closest(".slide").index();
        if (slideIndex !== index) {
          video.pause();
          return;
        }
        if (!video.dataset.quelleGesetzt) {
          video.querySelectorAll("source[data-src]").forEach((quelle) => {
            quelle.src = quelle.dataset.src;
          });
          video.load();
          video.dataset.quelleGesetzt = "1";
        }
        const laeuft = video.play();
        // Autoplay ohne Nutzergeste kann abgelehnt werden. Dann bleibt das
        // Standbild stehen -- kein Grund, die Konsole vollzuschreiben.
        if (laeuft && typeof laeuft.catch === "function") {
          laeuft.catch(() => {});
        }
      });
    }
  };

  // palette-designer/view-models/product-details-view-model.js
  var ProductDetailsViewModel = class extends ViewModel {
    constructor(product) {
      super();
      this._product = product;
    }
    get product() {
      return this._product;
    }
  };

  // palette-designer/view-models/palette-view-model.js
  var PaletteViewModel = class extends ViewModel {
    constructor(palette) {
      super();
      this._palette = palette;
      Broadcast.receive("activePanChanged", (value) => {
        this.activePan = value.pan;
      });
      this._palette.onPropertyChanged((property) => {
        if (property === "pans") {
          this._notifyPropertyChanged("palette.pans");
        } else if (property === "pans[]") {
          this._notifyPropertyChanged("palette.pans[]");
        } else if (property === "price") {
          this._notifyPropertyChanged("palette.price");
        } else if (property === "palette") {
          this._notifyPropertyChanged("palette.palette");
        } else if (property === "id") {
          this._notifyPropertyChanged("palette.id");
          this._notifyPropertyChanged("isSaved");
        } else if (property === "canUndo") {
          this._notifyPropertyChanged("palette.canUndo");
          this._notifyPropertyChanged("canUndo");
        } else if (property === "canRedo") {
          this._notifyPropertyChanged("palette.canRedo");
          this._notifyPropertyChanged("canRedo");
        } else if (property === "isSaving") {
          this._notifyPropertyChanged("isSaving");
        }
      });
    }
    get palette() {
      return this._palette;
    }
    get activePan() {
      return this._activePan;
    }
    set activePan(value) {
      this._activePan = value;
      this._notifyPropertyChanged("activePan");
    }
    set inspectedProduct(product) {
      Broadcast.send("inspectedProductChanged", {
        product,
        context: "palette"
      });
    }
    showProductDetails(product) {
      try { nbMessen("byop_detailansicht", {}); } catch (e) { /* messen darf nie blockieren */ }
      new ProductDetailsView(new ProductDetailsViewModel(product)).show();
    }
    placePan(pan, slotIndex, gridOffsetX, gridOffsetY, rotation, originalPan = null) {
      this._palette.add(new PlacedPanModel(pan, slotIndex, gridOffsetX, gridOffsetY, rotation), originalPan);
    }
    simulatedPlacePan(pan, slotIndex, gridOffsetX, gridOffsetY, rotation, originalPan = null) {
      return this._palette.simulateAdd(
        new PlacedPanModel(pan, slotIndex, gridOffsetX, gridOffsetY, rotation),
        originalPan
      );
    }
    removePan(pan) {
      this._palette.remove(pan);
    }
    reset() {
      this._palette.reset();
    }
    async _confirmAddIncompletePaletteToCart() {
      const modalWindow = new ModalWindow2(
        "50em",
        "auto",
        {
          // Stand ebenfalls nur englisch da, gleiche Ursache wie beim
          // Verfuegbarkeits-Fenster: T() uebersetzt nicht.
          headline: txt("incompleteHeadline", "Don't miss out!"),
          closeButton: true,
          buttons: [
            {
              caption: txt("addToCart", "Add to cart"),
              hollow: true,
              data: true
            },
            {
              caption: txt("cancelButton", "Cancel"),
              data: false
            }
          ]
        }
      );
      // Frueher stand hier pauschal "Unvollstaendige Paletten sind nicht
      // rabattberechtigt". Das stimmt nicht: der Rabatt haengt an der
      // Artikelzahl (siehe discountPercentage). Das Fenster nennt jetzt, was
      // die naechste Stufe konkret bringt.
      const naechste = this._nbErreichbareRabattstufe();
      const aktuell = Math.round((this._palette.discountPercentage || 0) * 100);
      const eine = naechste && naechste.fehlen === 1;
      let meldung;
      if (naechste && aktuell > 0) {
        meldung = eine
          ? T(txt("incompleteMessageNextActiveOne", "You already save {current}%. Add one more shade and it becomes {percent}%."), { current: aktuell, percent: Math.round(naechste.anteil * 100) })
          : T(txt("incompleteMessageNextActive", "You already save {current}%. Add {count} more shades and it becomes {percent}%."), { current: aktuell, count: naechste.fehlen, percent: Math.round(naechste.anteil * 100) });
      } else if (naechste) {
        meldung = eine
          ? T(txt("incompleteMessageNextOne", "Add one more shade and save {percent}% on your palette."), { percent: Math.round(naechste.anteil * 100) })
          : T(txt("incompleteMessageNext", "Add {count} more shades and save {percent}% on your palette."), { count: naechste.fehlen, percent: Math.round(naechste.anteil * 100) });
      } else {
        meldung = txt("incompleteMessageGeneric", "There is still room in your palette. More shades can unlock a higher discount.");
      }
      modalWindow.append(meldung);
      try { nbMessen("byop_nachfrage_gezeigt", {}); } catch (e) { /* messen darf nie blockieren */ }
      const result = await modalWindow.show();
      modalWindow.remove();
      try { nbMessen(result ? "byop_nachfrage_bestaetigt" : "byop_nachfrage_abgebrochen", {}); } catch (e) { /* messen darf nie blockieren */ }
      return result;
    }
    // Naechste Rabattstufe, die in DIESER Palette noch erreichbar ist (genug
    // freie Plaetze, siehe nbErreichbareRabattstufe im Modell). Laesst sich das
    // nicht bestimmen, liefert die Funktion undefined statt null, dann fragt
    // das Fenster mit dem allgemeinen Text nach.
    _nbErreichbareRabattstufe() {
      try {
        const stufe = this._palette.nbErreichbareRabattstufe;
        return stufe === undefined ? undefined : (stufe || null);
      } catch (e) {
        return undefined;
      }
    }
    async addToCart() {
      // Nachfragen nur, wenn weitere Farben wirklich noch etwas bringen. Ist
      // die hoechste erreichbare Stufe schon aktiv (etwa 24er mit 20 Farben),
      // waere "Nicht verpassen!" eine leere Drohung.
      if (!this._palette.isComplete && this._nbErreichbareRabattstufe() !== null) {
        if (!await this._confirmAddIncompletePaletteToCart()) {
          Notification.show(
            txt("incompleteNoticeTitle", "Don't miss out on your discount!"),
            txt("incompleteNoticeMessage", "Fill your palette and save.")
          );
          return;
        }
      }
      let result = await this._palette.addToCart(false);
      if (!result) {
        const availability = this._palette.availabilityBreakdown;
        const availabilityView = new AvailabilityView(new AvailabilityViewModel(availability));
        // Was das Fenster gerade als ausverkauft LISTET, ist auch das, was der
        // Aufraeum-Button entfernen soll. Die Liste kann vom Katalog stammen
        // (pan.isSoldOut) oder -- sobald das Agentur-Backend wieder antwortet --
        // vom Server, der neuer ist als der Katalog. Beide Quellen zusammenfuehren,
        // sonst fehlt der Button genau dann, wenn der Server etwas meldet.
        const serverAusverkauft = new Set(
          ((availability && availability.outOfStock) || [])
            .concat((availability && availability.comingSoon) || [])
            .map((produkt) => produkt && produkt.id)
            .filter((id) => id !== undefined && id !== null)
        );
        const kannAufraeumen = this._palette.availabilityHinweis.entfernbar
          || this._palette.pans.some((placedPan) => placedPan.pan && serverAusverkauft.has(placedPan.pan.id));
        const antwort = await availabilityView.show(kannAufraeumen);
        if (antwort === "removeSoldOut") {
          // Bewusst KEIN automatischer zweiter Versuch: die Palette ist nach dem
          // Aufraeumen meist unvollstaendig, der Kunde bekaeme sofort den naechsten
          // Dialog ("Rabatt verpasst") vor die Nase gesetzt. Stattdessen sieht er
          // die bereinigte Palette und entscheidet selbst, ob er nachfuellt.
          const entfernt = this._palette.removeSoldOutPans(serverAusverkauft);
          if (entfernt > 0) {
            Notification.show(
              txt("availabilityRemovedNotice", "Sold out shades removed"),
              txt("availabilityRemovedHint", "Add replacements to keep your discount.")
            );
          }
          return false;
        }
        if (antwort) {
          result = await this._palette.addToCart(true);
        }
      }
      return result;
    }
    get canUndo() {
      return this._palette.canUndo;
    }
    get canRedo() {
      return this._palette.canRedo;
    }
    undo() {
      this._palette.undo();
    }
    redo() {
      this._palette.redo();
    }
    get isSaving() {
      return this._palette.isSaving;
    }
    get isSaved() {
      return !!this._palette.id;
    }
  };

  // palette-designer/view-models/products-view-model.js
  var CategoryViewModel = class extends ViewModel {
    constructor(model) {
      super();
      this._model = model;
      this._isExpanded = model.isInitiallyExpanded;
      this._isVisible = true;
    }
    get name() {
      return this._model.name;
    }
    get type() {
      return this._model.type;
    }
    get filter() {
      return this._model.filter;
    }
    get isExpanded() {
      return this._isExpanded;
    }
    set isExpanded(value) {
      if (value !== this._isExpanded) {
        this._isExpanded = value;
        this._notifyPropertyChanged("isExpanded");
      }
    }
    get isVisible() {
      return this._isVisible;
    }
    set isVisible(value) {
      if (value !== this._isVisible) {
        this._isVisible = value;
        this._notifyPropertyChanged("isVisible");
      }
    }
  };
  var ProductsViewModel = class extends ViewModel {
    constructor(productsModel, paletteModel) {
      super();
      this._model = productsModel;
      this._paletteModel = paletteModel;
      paletteModel.onPropertyChanged((property) => {
        if (property === "pans[]" || property === "pans") {
          this._notifyPropertyChanged("selectedProducts");
        }
      });
      this._selectedPalette = null;
      // Herkunft des naechsten Groessenwechsels fuer byop_groesse_gewaehlt,
      // siehe _nbApplySelectedPalette.
      this._nbGroesseQuelle = null;
      this._priceRange = {
        minimum: this._model.asArray().reduce((acc, current) => Math.min(acc, current.price), Number.MAX_VALUE),
        maximum: this._model.asArray().reduce((acc, current) => Math.max(acc, current.price), Number.MIN_VALUE)
      };
      this.filters = {};
      this._priceRangeFilter = null;
      this._sortOrders = [
        {
          name: txt("relaunchSortPopularity", "Popularity"),
          comparer: (a, b) => a.salesRank - b.salesRank
        },
        {
          name: txt("relaunchSortName", "Name"),
          comparer: (a, b) => a.name.localeCompare(b.name)
        },
        {
          name: txt("relaunchSortRelease", "Release date"),
          comparer: (a, b) => b.created - a.created
        },
        {
          name: txt("relaunchSortPrice", "Price"),
          comparer: (a, b) => a.price - b.price
        },
        {
          // Frueher naiver Hue-Vergleich (a.color.hsl[0] - b.color.hsl[0]):
          // bei gedeckten Toenen, Neutralen und Brauns ergibt der reine
          // Farbwinkel visuelles Chaos. Jetzt eine vorberechnete Rangfolge
          // (nbFarbRaengeBerechnen am Dateiende): Farbbloecke wie eine
          // Farbkarte (pink -> rot -> ... -> lila, dann Braun/Nude, dann
          // Neutrale), innerhalb der Bloecke Nachbarschafts-Sortierung
          // ueber die wahrgenommene Farbdistanz (deltaE auf Lab).
          name: txt("relaunchSortColor", "Color"),
          comparer: (a, b) => (a.__nbFarbRang != null ? a.__nbFarbRang : 1e9) - (b.__nbFarbRang != null ? b.__nbFarbRang : 1e9)
        },
        {
          name: txt("relaunchSortLight", "Light to dark"),
          comparer: (a, b) => a.color && b.color ? b.color.hsl[2] - a.color.hsl[2] : 0
        }
      ];
      // Standard ist jetzt die Farbsortierung (Check-in 06.08.: "Farbsortierung
      // im Katalog nicht optimiert"). Beliebtheit bleibt im Sortier-Menue
      // waehlbar. Fuer den Termin als Entscheidungspunkt markiert.
      // Benannte Referenz statt hartem Index: Chip-Anzeige und Reset-Kreuz
      // vergleichen gegen DIESEN Default, nicht gegen sortOrders[0].
      this._defaultSortOrder = this._sortOrders[4];
      this._sortOrder = this._defaultSortOrder;
      this._categories = this._model.categories.map((category) => new CategoryViewModel(category));
      this._searchResultCategory = this._categories.find((category) => category.type === "search-results");
      this._searchResultCategory.isVisible = false;
      Broadcast.receive("requestProductsViewReset", () => {
        this.unsetAllFilters();
        this._categories[0].isExpanded = true;
        for (let i = 1; i < this._categories.length; i++) {
          this._categories[i].isExpanded = false;
        }
      });
    }
    get sortOrders() {
      return this._sortOrders;
    }
    get defaultSortOrder() {
      return this._defaultSortOrder;
    }
    get sortOrder() {
      return this._sortOrder;
    }
    set sortOrder(value) {
      this._sortOrder = value;
      this._notifyPropertyChanged("sortOrder");
      this._notifyPropertyChanged("products");
    }
    get categories() {
      return this._categories;
    }
    set keyword(value) {
      this._keyword = value;
      if (this._keyword.length > 0) {
        this._searchResultCategory.isVisible = true;
        this._searchResultCategory.isExpanded = true;
        this._categories.forEach((category) => {
          if (category !== this._searchResultCategory) {
            category.isVisible = false;
          }
        });
      } else {
        this._searchResultCategory.isVisible = false;
        this._categories.forEach((category) => {
          if (category !== this._searchResultCategory) {
            category.isVisible = true;
          }
        });
      }
      this._notifyPropertyChanged("keyword");
      this._notifyPropertyChanged("products");
    }
    setFilter(field, allowedValues) {
      this.filters[field] = allowedValues;
      this._notifyPropertyChanged("activeFilters");
      this._notifyPropertyChanged("products");
    }
    unsetFilter(field) {
      delete this.filters[field];
      this._notifyPropertyChanged("activeFilters");
      this._notifyPropertyChanged("products");
    }
    setPriceRangeFilter(minimum, maximum) {
      this._priceRangeFilter = {
        minimum,
        maximum
      };
      this._notifyPropertyChanged("activeFilters");
      this._notifyPropertyChanged("products");
    }
    unsetPriceRangeFilter() {
      this._priceRangeFilter = null;
      this._notifyPropertyChanged("activeFilters");
      this._notifyPropertyChanged("products");
    }
    unsetAllFilters() {
      this._priceRangeFilter = null;
      this.filters = {};
      this._notifyPropertyChanged("activeFilters");
      this._notifyPropertyChanged("products");
    }
    revertColorFilter() {
      if (!this.filters["color.canonical"] || this.filters["color.canonical"].length > 0) {
        this.filters["color.canonical"] = [];
      } else {
        delete this.filters["color.canonical"];
      }
      this._notifyPropertyChanged("activeFilters");
      this._notifyPropertyChanged("products");
    }
    get activeFilterCount() {
      return Object.keys(this.filters).length + (this._priceRangeFilter ? 1 : 0);
    }
    get matchingProductsCount() {
      return this._getFilteredProducts().length;
    }
    get priceRange() {
      return this._priceRange;
    }
    get priceRangeFilter() {
      return this._priceRangeFilter || this._priceRange;
    }
    get activeFilters() {
      return this.filters;
    }
    getProductsForCategory(category) {
      const filtered = this._getFilteredProducts().filter(category.filter);
      if (filtered.length > 0 && filtered[0].type === "empty_palette") {
        filtered.sort((a, b) => {
          const capacityA = a.hasSlots ? (a.rows * a.columns) : (a.eyeshadowEquivalentCapacity || 0);
          const capacityB = b.hasSlots ? (b.rows * b.columns) : (b.eyeshadowEquivalentCapacity || 0);
          return capacityA - capacityB;
        });
      } else {
        filtered.sort(this._sortOrder.comparer);
      }
      return filtered;
    }
    _getFilteredProducts() {
      let products = this._model.asArray();
      if (this._keyword && this._keyword.length > 0) {
        let keyword = this._keyword.toLowerCase().replace(/\s+/g, "");
        products = products.filter((product) => product.name.toLowerCase().replace(/\s+/g, "").indexOf(keyword) >= 0);
      }
      for (let key of Object.keys(this.filters)) {
        if (key.includes(".")) {
          let parts = key.split(/\./g);
          products = products.filter((product) => {
            let obj = product;
            for (let part of parts) {
              obj = obj[part];
              if (!obj) {
                return false;
              }
            }
            return this.filters[key].includes(obj);
          });
        } else if (key.endsWith("[]")) {
          const productKey = key.replace("[]", "");
          products = products.filter((product) => {
            return this.filters[key].some((filter) => product[productKey].includes(filter));
          });
        } else {
          products = products.filter((product) => this.filters[key].includes(product[key]));
        }
      }
      if (this._priceRangeFilter) {
        products = products.filter((product) => product.price >= this._priceRangeFilter.minimum && product.price <= this._priceRangeFilter.maximum);
      }
      return products;
    }
    get selectedPalette() {
      return this._paletteModel.palette;
    }
    set selectedPalette(value) {
      // Einziger Engpass fuer Groessenwechsel aus Katalog UND Groessenleiste.
      // Neu: (1) Wechsel auf die bereits aktive Groesse ist ein No-op -- vorher
      // lief die komplette Ueberblendung samt Bild-Load fuer nichts. (2) Wuerde
      // der Wechsel gesetzte Farben verwerfen, fragt ein Dialog nach, statt sie
      // stillschweigend zu loeschen (der fruehere paletteChangedWithPanLoss-
      // Listener war leer). Der Upgrade-Dialog in addPan setzt das Model direkt
      // und laeuft hier bewusst NICHT durch (er bestaetigt selbst).
      if (value === this._paletteModel.palette) {
        return;
      }
      // Solange die Rueckfrage zu einem anderen Ziel offen ist, wird gar nichts
      // gewechselt. Der Modal-Overlay blockt nur Zeigereingaben; per Tastatur
      // liess sich waehrenddessen ein zweiter, verlustfreier Groessen-Chip
      // ausloesen, der sofort durchlief. Bestaetigte der Kunde danach die ERSTE
      // Rueckfrage, sprang die Palette still auf ein Ziel zurueck, das er
      // inzwischen verlassen hatte, und die seither gesetzten Farben gingen
      // ungefragt verloren.
      if (this._nbSwitchDialogOffen) {
        return;
      }
      let nbVerlust = 0;
      try {
        nbVerlust = this._paletteModel.nbPredictPanLoss(value);
      } catch (e) { /* im Zweifel wie bisher ohne Rueckfrage wechseln */ }
      if (nbVerlust > 0) {
        nbConfirmPaletteSwitch(this, value, nbVerlust);
        return;
      }
      this._nbApplySelectedPalette(value);
    }
    _nbApplySelectedPalette(value) {
      // Zweites Netz gegen doppelte Anwendung (z. B. zwei nacheinander
      // bestaetigte Dialoge auf dasselbe Ziel).
      if (value === this._paletteModel.palette) {
        return;
      }
      this._paletteModel.palette = value;
      this._notifyPropertyChanged("selectedPalette");
      // Herkunft kommt von den drei Aufrufstellen (Katalog, Groessenleiste,
      // Erststart), die _nbGroesseQuelle unmittelbar vor dem Setzen von
      // selectedPalette belegen, auch nach einer bestaetigten Rueckfrage
      // noch gueltig, weil waehrenddessen kein zweiter Wechsel moeglich ist
      // (_nbSwitchDialogOffen). "katalog" ist nur ein Netz, falls doch einmal
      // ein Aufrufer vergessen wurde.
      try {
        const quelle = this._nbGroesseQuelle || "katalog";
        this._nbGroesseQuelle = null;
        nbMessen("byop_groesse_gewaehlt", { groesse: nbMessGroesse(value), quelle });
      } catch (e) { /* messen darf nie blockieren */ }
    }
    get selectedProducts() {
      return [this.selectedPalette].concat(this._paletteModel.pans.map((pan) => pan.pan).filter((pan) => !!pan));
    }
    set inspectedProduct(product) {
      Broadcast.send("inspectedProductChanged", {
        product,
        context: "catalog"
      });
    }
    showProductDetails(product) {
      try { nbMessen("byop_detailansicht", {}); } catch (e) { /* messen darf nie blockieren */ }
      new ProductDetailsView(new ProductDetailsViewModel(product)).show();
    }
    // Relaunch (03.09.): Passt ein Napf nicht in die gewaehlte Palette (etwa
    // Gesichtspuder in einer Lidschatten-Palette), endete der Versuch bisher
    // in einem stillen return, der Kunde sah nichts. Jetzt ein Fenster: welche
    // Palette passt, ein Knopf zum Wechseln, und ein Hinweis, falls dabei
    // Farben verloren gehen. Gilt fuer Tippen im Katalog und fuer Ziehen.
    _nbPasstInPalette(pan, palette) {
      if (pan.width === 26 && pan.height === 26) {
        return this._paletteModel._canHoldEyeshadows(palette);
      }
      return pan.width === palette.slotWidth && pan.height === palette.slotHeight;
    }
    _nbPassendePaletten(pan) {
      const pm = (this._paletteModel && this._paletteModel._productsModel) || this._productsModel;
      if (!pm || typeof pm.asArray !== 'function') return [];
      return pm.asArray()
        .filter((item) => item instanceof PaletteModel && this._nbPasstInPalette(pan, item))
        .sort((a, b) => a.eyeshadowEquivalentCapacity - b.eyeshadowEquivalentCapacity);
    }
    nbPruefePassung(pan) {
      if (!pan || !this._paletteModel || !this._paletteModel.palette) return;
      if (this._nbPasstInPalette(pan, this._paletteModel.palette)) return;
      if (this._nbHinweisOffen) return;
      this._nbHinweisPasstNicht(pan);
    }
    async _nbHinweisPasstNicht(pan) {
      if (this._nbHinweisOffen) return;
      this._nbHinweisOffen = true;
      try {
        const st = window.inlineData?.PaletteDesigner?.staticText || {};
        const aktuell = this._paletteModel.palette;
        const passende = this._nbPassendePaletten(pan).filter((p) => p !== aktuell);
        const naechste = passende[0];
        const arten = {
          eyeshadow: st.relaunchKindEyeshadow || "Lidschatten",
          face_powder: st.relaunchKindFacePowder || "Gesichtspuder",
          highlighter: st.relaunchKindHighlighter || "Highlighter"
        };
        const art = arten[pan.type] || (st.relaunchKindOther || "Diese Farbe");
        const headline = T(st.relaunchFitHeadline || "{product} passt nicht in die {current}", { product: pan.name, current: aktuell.name });
        const buttons = [];
        let text;
        if (naechste) {
          text = T(st.relaunchFitMessage || "{kind} braucht eine passende Palette, zum Beispiel die {next}.", { kind: art, next: naechste.name, product: pan.name, current: aktuell.name });
          let verlust = 0;
          try {
            const gemappt = this._paletteModel._nbMapPansToPalette(naechste) || [];
            verlust = Math.max(0, this._paletteModel.pans.length - gemappt.length);
          } catch (e) { verlust = 0; }
          if (verlust > 0) {
            text += "<br><br><strong>" + T(st.relaunchFitLoss || "Beim Wechsel gehen {count} deiner Farben verloren, weil sie nicht in die {next} passen.", { count: verlust, next: naechste.name }) + "</strong>";
          }
          buttons.push({ caption: T(st.relaunchFitSwitch || "Zur {next} wechseln", { next: naechste.name }), hollow: false, data: true });
          // Rueckfall englisch wie ueberall: er greift nur, wenn die Uebersetzung fehlt.
          buttons.push({ caption: st.cancelButton || "Cancel", hollow: true, data: false });
        } else {
          text = st.relaunchFitNone || "Dafuer gibt es gerade keine passende Palette.";
          buttons.push({ caption: st.availabilityClose || "Schliessen", hollow: false, data: false });
        }
        const modalWindow = new ModalWindow2("50em", "auto", { headline, closeButton: true, buttons });
        modalWindow.append("<p>" + text + "</p>");
        const result = await modalWindow.show();
        modalWindow.remove();
        if (result && naechste) {
          await this._nbKatalogZuklappen();
          this._nbWechselMitPlatzFuerEine(naechste, pan);
          this._paletteModel.addAtFirstAvailableSlot(pan);
        }
      } finally {
        this._nbHinweisOffen = false;
      }
    }
    async _confirmUpgradeToLargerPalette(nextPalette, currentPalette) {
      const staticText = window.inlineData?.PaletteDesigner?.staticText;
      const headlineText = staticText?.upgradePaletteHeadline || "Upgrade to larger palette?";
      const messageText = staticText?.upgradePaletteMessage || 
        "Your {currentPalette} is full! Upgrade to the {nextPalette} to add more shades and save even more.";
      const upgradeButtonText = staticText?.upgradePaletteButton || "Upgrade & Save";
      const cancelButtonText = staticText?.cancelButton || "Cancel";
      
      const modalWindow = new ModalWindow2(
        "50em",
        "auto",
        {
          headline: T(headlineText),
          closeButton: true,
          buttons: [
            {
              caption: T(upgradeButtonText),
              hollow: false,
              data: true
            },
            {
              caption: T(cancelButtonText),
              hollow: true,
              data: false
            }
          ]
        }
      );
      
      modalWindow.append(
        T(messageText, {
          currentPalette: currentPalette.name,
          nextPalette: nextPalette.name
        })
      );

      try { nbMessen("byop_upgrade_fenster", {}); } catch (e) { /* messen darf nie blockieren */ }
      const result = await modalWindow.show();
      modalWindow.remove();
      if (result) {
        try { nbMessen("byop_upgrade_angenommen", {}); } catch (e) { /* messen darf nie blockieren */ }
      }
      return result;
    }
    async addPan(pan) {
      // Relaunch Napf-Tap: Hat der Kunde vorher einen leeren Napf angetippt
      // (Ziel gesetzt im nbRelaunch-Modul), landet die naechste Farbe genau
      // dort statt im ersten freien Napf. Ziel gilt fuer EINE Platzierung;
      // danach greift wieder die normale Reihenfolge.
      const nbZiel = this._paletteModel._nbZielSlot;
      if (nbZiel != null && this._paletteModel.palette.hasSlots
        && pan.width === this._paletteModel.palette.slotWidth
        && pan.height === this._paletteModel.palette.slotHeight
        && !this._paletteModel.pans.some((p) => p.slotIndex === nbZiel)) {
        this._paletteModel._nbZielSlot = null;
        this._paletteModel.add(new PlacedPanModel(pan, nbZiel));
        return;
      }
      this._paletteModel._nbZielSlot = null;
      if (this._paletteModel.addAtFirstAvailableSlot(pan)) {
        return; // Successfully added
      }
      
      // Pan couldn't be added - check if it's compatible with current palette
      const palette = this._paletteModel.palette;
      
      let isPanCompatible = false;
      
      if (pan.width === 26 && pan.height === 26) {
        isPanCompatible = this._paletteModel._canHoldEyeshadows(palette);
      } else {
        isPanCompatible = pan.width === palette.slotWidth && pan.height === palette.slotHeight;
      }
      
      if (!isPanCompatible) {
        await this._nbHinweisPasstNicht(pan);
        return;
      }
      
      const nextPalette = this._paletteModel._getNextLargerPalette();
      
      if (!nextPalette) {
        return;
      }
      
      // Offer upgrade to user
      const confirmed = await this._confirmUpgradeToLargerPalette(
        nextPalette,
        this._paletteModel.palette
      );
      
      if (confirmed) {
        // Relaunch (03.09.): Am Handy liegt der Katalog ueber der Buehne.
        // Erst zuklappen, dann wechseln, sonst laeuft die Wechsel-Animation
        // unsichtbar hinter dem Katalog ab (Justin, 03.09.).
        await this._nbKatalogZuklappen();
        this._nbWechselMitPlatzFuerEine(nextPalette, pan);
        this._paletteModel.addAtFirstAvailableSlot(pan);
      }
    }
    // Groessenwechsel, bei dem direkt danach noch EINE Farbe gesetzt wird
    // (Upgrade-Dialog und "passt nicht"-Dialog). Der Zwischenspeicher darf die
    // groessere Palette dabei nicht bis zum letzten Platz fuellen, sonst
    // scheitert das anschliessende addAtFirstAvailableSlot und der Tap des
    // Kunden liefe ins Leere. Diese Wege setzen das Modell bewusst direkt,
    // laufen also nicht durch den Setter selectedPalette.
    _nbWechselMitPlatzFuerEine(zielPalette, pan) {
      try {
        // Steht genau diese Farbe noch im Zwischenspeicher, wuerde sie beim
        // Wechsel eingesetzt und gleich darauf ein zweites Mal gelegt.
        this._paletteModel.nbVergissGeparkte(pan);
        this._paletteModel._nbPlaetzeFreihalten = 1;
      } catch (e) { /* ohne Reserve wechseln ist immer noch besser als gar nicht */ }
      try {
        this._paletteModel.palette = zielPalette;
        // Setzt das Modell direkt (siehe Kommentar oben), also ausserhalb von
        // _nbApplySelectedPalette: die Herkunft ist hier immer "upgrade".
        try { nbMessen("byop_groesse_gewaehlt", { groesse: nbMessGroesse(zielPalette), quelle: "upgrade" }); } catch (e) { /* messen darf nie blockieren */ }
      } finally {
        try {
          this._paletteModel._nbPlaetzeFreihalten = 0;
        } catch (e) { /* nichts zu tun */ }
      }
    }
    // Klappt den Katalog am Handy/Tablet zu und wartet die Fahrt ab (0.24s
    // laut CSS, plus Puffer). Am Desktop steht der Katalog neben der Buehne,
    // dort passiert nichts. Loest nie eine Ausnahme aus.
    _nbKatalogZuklappen() {
      return new Promise((resolve) => {
        try {
          const menue = document.querySelector("#palette-designer-nh .menu");
          const schmal = window.matchMedia("(max-width: 1100px)").matches;
          if (!menue || !schmal || !menue.classList.contains("expanded")) {
            resolve();
            return;
          }
          Broadcast.send("nbKatalogZuklappen", {});
          setTimeout(resolve, 340);
        } catch (e) {
          resolve();
        }
      });
    }
  };

  // palette-designer/view-models/user-view-model.js
  var UserViewModel = class extends ViewModel {
    constructor(model, paletteModel) {
      super();
      this._model = model;
      this._paletteModel = paletteModel;
      this._activePane = "saved-palettes";
      model.onPropertyChanged((property) => {
        if (property === "savedPalettes") {
          this._notifyPropertyChanged("savedPalettes");
        }
      });
    }
    get isVisible() {
      return this._isVisible;
    }
    set isVisible(value) {
      this._isVisible = value;
      this._notifyPropertyChanged("isVisible");
    }
    get activePane() {
      return this._activePane;
    }
    set activePane(value) {
      this._activePane = value;
      this._notifyPropertyChanged("activePane");
    }
    get savedPalettes() {
      return this._model.savedPalettes;
    }
    get lastError() {
      return this._model.lastError;
    }
    loadSavedPalette(savedPalette) {
      this._paletteModel.loadSavedPalette(savedPalette);
      this.isVisible = false;
    }
    deleteSavedPalette(savedPalette) {
      this._model.deleteSavedPalette(savedPalette);
      if (savedPalette.id === this._paletteModel.id) {
        this._paletteModel.id = null;
      }
    }
    refreshSavedPalettes(force = false) {
      this._model.refreshSavedPalettes(force);
    }
    get currentPaletteId() {
      return this._paletteModel.id;
    }
  };

  // palette-designer/view-models/pal-view-model.js
  var PalViewModel = class extends ViewModel {
    constructor(model, paletteModel) {
      super();
      this._model = model;
      this._paletteModel = paletteModel;
      this._metallicsPercent = 0.5;
      this._variation = 0;
      this._minLightness = 0;
      this._maxLightness = 1;
      this._primaryColor = Math.random() * 360;
      this._primaryColorInfluence = 0.6;
      this._secondaryColor = null;
      this._secondaryColorInfluence = 0.5;
      this._restoreState = null;
      this._model.onPropertyChanged((propertyName) => {
        if (propertyName === "variations") {
          this._handleVariationsChanged();
        }
      });
      Broadcast.receive("openPal", () => {
        this.show();
      });
    }
    get metallicsPercent() {
      return this._metallicsPercent;
    }
    set metallicsPercent(value) {
      if (this._metallicsPercent !== value) {
        this._metallicsPercent = value;
        this._notifyPropertyChanged("metallicsPercent");
        this._update();
      }
    }
    get minLightness() {
      return this._minLightness;
    }
    set minLightness(value) {
      if (this._minLightness !== value) {
        this._minLightness = value;
        this._notifyPropertyChanged("minLightness");
        this._update();
      }
    }
    get maxLightness() {
      return this._maxLightness;
    }
    set maxLightness(value) {
      if (this._maxLightness !== value) {
        this._maxLightness = value;
        this._notifyPropertyChanged("maxLightness");
        this._update();
      }
    }
    get primaryColor() {
      return this._primaryColor;
    }
    set primaryColor(value) {
      if (this._primaryColor !== value) {
        this._primaryColor = value;
        this._notifyPropertyChanged("primaryColor");
        this._update();
      }
    }
    get primaryColorInfluence() {
      return this._primaryColorInfluence;
    }
    set primaryColorInfluence(value) {
      if (this._primaryColorInfluence !== value) {
        this._primaryColorInfluence = value;
        this._notifyPropertyChanged("primaryColorInfluence");
        this._update();
      }
    }
    get secondaryColor() {
      return this._secondaryColor;
    }
    set secondaryColor(value) {
      if (this._secondaryColor !== value) {
        this._secondaryColor = value;
        this._notifyPropertyChanged("secondaryColor");
        this._update();
      }
    }
    get secondaryColorInfluence() {
      return this._secondaryColorInfluence;
    }
    set secondaryColorInfluence(value) {
      if (this._secondaryColorInfluence !== value) {
        this._secondaryColorInfluence = value;
        this._notifyPropertyChanged("secondaryColorInfluence");
        this._update();
      }
    }
    get variation() {
      return this._variation;
    }
    set variation(value) {
      if (this._variation !== value) {
        this._variation = value;
        this._handleVariationChanged();
      }
    }
    get visible() {
      return this._visible;
    }
    get ignoreStickyShadows() {
      return this._ignoreStickyShadows;
    }
    set ignoreStickyShadows(value) {
      if (this._ignoreStickyShadows !== value) {
        this._ignoreStickyShadows = value;
        this._notifyPropertyChanged("ignoreStickyShadows");
        this._update();
      }
    }
    async show() {
      const paletteEligibility = this._model.determinePaletteEligibility();
      if (paletteEligibility !== "eligible") {
        const modalWindow = new ModalWindow2(
          "30em",
          "auto",
          { headline: null, closeButton: false, buttons: [T("Got it")] }
        );
        let message;
        switch (paletteEligibility) {
          case "wrongSlotSize":
            message = "Unfortunately PAL does not yet support face powder palettes. Please choose a different empty palette and try again.";
            break;
          case "paletteContainsNonEyeshadows":
            message = "Unfortunately PAL cannot yet complete palettes containing face powders. Please remove the face powders or start with an empty palette.";
            break;
          case "misalignedEyeshadow":
            message = "Unfortunately PAL cannot complete palettes containing eyeshadows that are aligned to odd-numbered grid rows or columns. Please move your eyeshadows and try again.";
            break;
        }
        modalWindow.append(message);
        await modalWindow.show();
        modalWindow.remove();
        return;
      }
      this._restoreState = this._paletteModel.serialize();
      if (this._paletteModel.isComplete) {
        this._model.releaseStickyShadows();
        this._paletteModel.reset(this._paletteModel.palette);
      } else if (this._paletteModel.pans.length > 0) {
        const modalWindow = new ModalWindow2(
          "30em",
          "auto",
          {
            headline: T("Fill the gaps?"),
            closeButton: true,
            buttons: [
              {
                caption: T("New palette"),
                hollow: true,
                data: false
              },
              {
                caption: T("Fill gaps"),
                data: true
              }
            ]
          }
        );
        modalWindow.append(T("Would you like to generate a new palette or fill the gaps in your current one?"));
        const result = await modalWindow.show();
        modalWindow.remove();
        if (!result) {
          this._model.releaseStickyShadows();
          this._paletteModel.reset(this._paletteModel.palette);
        } else {
          this._model.captureStickyShadows();
        }
      } else {
        this._model.releaseStickyShadows();
      }
      this._update();
      this._visible = true;
      this._notifyPropertyChanged("visible");
    }
    hide() {
      if (this._restoreState) {
        this._paletteModel.unserialize(this._restoreState, false);
      }
      this._visible = false;
      this._notifyPropertyChanged("visible");
    }
    accept() {
      const current = this._paletteModel.serialize();
      if (this._restoreState) {
        this._paletteModel.unserialize(this._restoreState, false);
      }
      this._paletteModel._saveUndo();
      this._paletteModel.unserialize(current, false);
      this._paletteModel._save();
      this._visible = false;
      this._notifyPropertyChanged("visible");
      Broadcast.send("requestHighlightPans", this._model.getAffectedPans());
    }
    refresh() {
      this._update();
    }
    _update() {
      this._model.generate(this._getOptions());
    }
    _getOptions() {
      return {
        metallicsPercent: this._metallicsPercent,
        minLightness: this._minLightness,
        maxLightness: this._maxLightness,
        primaryColor: this._primaryColor,
        secondaryColor: this._secondaryColor,
        primaryColorInfluence: this._primaryColorInfluence,
        secondaryColorInfluence: this._secondaryColorInfluence,
        ignoreStickyShadows: this._ignoreStickyShadows
      };
    }
    debugScoreActivePalette() {
      this._model.debugScoreActivePalette(Object.assign({
        debug: true
      }, this._getOptions()));
    }
    _handleVariationsChanged() {
      this._variation = 0;
      this._handleVariationChanged();
    }
    _handleVariationChanged() {
      this._notifyPropertyChanged("variation");
      this._paletteModel.unserialize(this._model.variations[this._variation]);
    }
  };

  // palette-designer/view-models/info-view-model.js
  var InfoViewModel = class extends ViewModel {
    constructor() {
      super();
      this._product = null;
      this._context = null;
      Broadcast.receive("inspectedProductChanged", (payload) => {
        this.context = payload.context;
        this.product = payload.product;
      });
    }
    get context() {
      return this._context;
    }
    set context(value) {
      this._context = value;
      this._notifyPropertyChanged("context");
    }
    get product() {
      return this._product;
    }
    set product(value) {
      this._product = value;
      this._notifyPropertyChanged("product");
    }
  };

  // palette-designer/view-models/new-palette-view-model.js
  var NewPaletteViewModel = class extends ViewModel {
    constructor(paletteModel, productsModel, productsViewModel, palViewModel) {
      super();
      this._paletteModel = paletteModel;
      this._productsModel = productsModel;
      this._productsViewModel = productsViewModel;
      this._palViewModel = palViewModel;
    }
    createEmpty() {
      this._paletteModel._saveUndo();
      // Keep the current palette, just remove all pans
      this._paletteModel.reset(this._paletteModel.palette);
      this._productsViewModel.categories[0].isExpanded = true;
    }
    generateWithAi() {
      try { nbMessen("byop_ueberrasche_mich", {}); } catch (e) { /* messen darf nie blockieren */ }
      this._palViewModel.show();
    }
    showInspiration() {
      window.location.href = window.inlineData.PaletteDesigner.byopUri;
    }
  };

  // palette-designer/helpers/date.js
  var dayOfWeekLookup = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];
  var monthLookup = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  function prettyDate(date) {
    if (!date || !(date instanceof Date)) {
      return T("Never");
    } else {
      const now = (/* @__PURE__ */ new Date()).getTime();
      let delta = parseInt((now - date.getTime()) / 1e3);
      let isInTheFuture = delta < 0;
      if (isInTheFuture) {
        delta = Math.abs(delta);
      }
      if (delta < 60) {
        return T("Just now");
      } else if (delta < 2 * 60) {
        if (isInTheFuture) {
          return T("In one minute");
        } else {
          return T("One minute ago");
        }
      } else if (delta < 60 * 60) {
        if (isInTheFuture) {
          return T("In {time} min", { time: parseInt(delta / 60) });
        } else {
          return T("{time} min ago", { time: parseInt(delta / 60) });
        }
      } else if (delta < 100 * 60) {
        if (isInTheFuture) {
          return T("In one hour");
        } else {
          return T("One hour ago");
        }
      } else if (delta < 24 * 60 * 60) {
        let hours = parseInt(delta / (60 * 60));
        let minutes = parseInt((delta - hours * 60 * 60) / 60);
        if (minutes === 1) {
          minutes = T("one");
        }
        if (isInTheFuture) {
          return T("In {hours} h, {minutes} min", { hours, minutes });
        } else {
          return T("{hours} h, {minutes} min ago", { hours, minutes });
        }
      } else if (delta < 26 * 60 * 60) {
        if (isInTheFuture) {
          return T("Tomorrow");
        } else {
          return T("Yesterday");
        }
      } else {
        const dayOfWeekName = dayOfWeekLookup[date.getDay()];
        const monthName = monthLookup[date.getMonth()];
        return "%A, %B %e, %Y".replace("%A", dayOfWeekName).replace("%B", monthName).replace("%e", date.getDate()).replace("%Y", date.getFullYear().toString());
      }
    }
  }

  // palette-designer/views/saved-palettes-view.js
  var SavedPalettesView = class extends View {
    constructor(element, viewModel) {
      super(viewModel);
      this._element = element;
      this._listElement = element.find("ul");
      this._initialize();
    }
    handlePropertyChanged(property) {
      if (property === "savedPalettes") {
        this._update();
      }
    }
    _handleItemClicked(e) {
      let target = $(e.target);
      if (!target.is("li")) {
        target = target.parents("li").first();
      }
      const savedPalette = target.data("savedPalette");
      if (savedPalette.id !== this._viewModel.currentPaletteId) {
        this._viewModel.loadSavedPalette(savedPalette);
      }
    }
    async _handleDeleteClicked(e) {
      e.stopPropagation();
      let target = $(e.target).closest("li");
      const modalWindow = new ModalWindow2(
        "30em",
        "auto",
        {
          // Lief bisher komplett ueber T(), das nicht uebersetzt: der Dialog war
          // auch im deutschen und franzoesischen Shop englisch. Jetzt ueber
          // staticText wie die uebrigen Dialoge.
          headline: txt("deletePaletteHeadline", "Are you sure?"),
          closeButton: true,
          buttons: [
            {
              caption: txt("deletePaletteButton", "Delete palette"),
              hollow: true,
              data: true
            },
            {
              caption: txt("cancelButton", "Cancel"),
              data: false
            }
          ]
        }
      );
      modalWindow.append(txt("deletePaletteMessage", "Deleting a saved palette is irreversible. Do you wish to continue?"));
      const result = await modalWindow.show();
      modalWindow.remove();
      if (result) {
        this._viewModel.deleteSavedPalette(target.data("savedPalette"));
      }
    }
    activate() {
      this._update();
    }
    _initialize() {
    }
    _update() {
      this._listElement.empty();
      if (this._viewModel.savedPalettes.length < 1) {
        this._element.addClass("empty");
        return;
      }
      this._element.removeClass("empty");
      for (let savedPalette of this._viewModel.savedPalettes) {
        const imageUri = window.inlineData.PaletteDesigner.imageUri + `?pd=${savedPalette.paletteString}&format=thumbnail`;
        // Name und Palettencode kommen aus dem Kundenkonto und werden deshalb als
        // Text bzw. Attribut gesetzt, nie als HTML (sonst laeuft eingeschleustes Markup).
        const item = $(`
                    <li class="horizontal middle">
                        <figure>
                            <img>
                        </figure>
                        <div class="info fill">
                            <time></time>
                            <h4></h4>
                        </div>
                        <button class="delete icon-only"></button>
                    </li>
            `);
        item.find("img").attr("src", imageUri);
        item.find("time").text(prettyDate(savedPalette.modified));
        item.find("h4").text(savedPalette.name);
        if (savedPalette.id === this._viewModel.currentPaletteId) {
          item.addClass("selected");
        }
        item.data("savedPalette", savedPalette);
        this._listElement.append(item);
        item.on("click", (e) => this._handleItemClicked(e));
        item.find("button.delete").click((e) => this._handleDeleteClicked(e));
      }
    }
  };

  // palette-designer/views/user-view.js
  var UserView = class extends View {
    constructor(element, viewModel) {
      super(viewModel);
      this._element = element;
      this._container = element.find(".pane-container");
      this._closeButton = element.find("button.close");
      this._savedPalettesView = new SavedPalettesView(element.find(".saved-palettes-pane"), viewModel);
      this._isVisible = false;
      Broadcast.receive("requestCloseUserView", () => {
        if (this._isVisible) {
          this._hide();
        }
      });
      this._initialize();
    }
    handlePropertyChanged(property) {
      if (property === "activePane") {
        this._switchPane();
      } else if (property === "isVisible") {
        this._handleVisibilityChanged();
      }
    }
    _initialize() {
      this._container.on("mousedown", (e) => e.stopPropagation());
      this._element.on("mousedown", (e) => this._viewModel.isVisible = false);
      this._closeButton.click((e) => this._viewModel.isVisible = false);
      this._switchPane();
    }
    _getActivePaneView() {
      return this._savedPalettesView;
    }
    _show() {
      // ueber waitForTransitionEnd, damit das Promise auch dann aufloest, wenn
      // gar keine Ueberblendung laeuft -- sonst bleibt das Panel im Zustand
      // "oeffnet gerade" haengen und laesst sich nicht mehr schliessen.
      this._element.addClass("visible");
      this._isVisible = true;
      this._getActivePaneView().activate();
      return waitForTransitionEnd(this._element);
    }
    _hide() {
      this._element.removeClass("visible");
      this._isVisible = false;
      Broadcast.send("userViewClosed", {});
      return waitForTransitionEnd(this._element);
    }
    _handleVisibilityChanged() {
      if (this._viewModel.isVisible) {
        this._show();
      } else {
        this._hide();
      }
    }
    async _switchPane() {
      const wasVisible = this._isVisible;
      if (wasVisible) {
        await this._hide();
        await new Promise((resolve) => window.setTimeout(resolve, 300));
      }
      this._container.find("> div").addClass("collapsed");
      this._container.find(">div." + this._viewModel.activePane + "-pane").removeClass("collapsed");
      if (wasVisible) {
        await this._show();
      }
    }
  };

  // palette-designer/helpers/draggable.js
  var Draggable = class _Draggable {
    constructor(direction = null, threshold = 0) {
      this._isMaybeDragging = false;
      this._isDragging = false;
      this._direction = direction;
      this._threshold = threshold;
      this._startX = 0;
      this._startY = 0;
      this._dragStartCallbacks = [];
      this._dragMoveCallbacks = [];
      this._dragEndCallbacks = [];
      this._currentElement = null;
      this._elements = [];
      document.addEventListener(
        "touchmove",
        (e) => this.handleDragMove(e),
        { passive: false }
      );
      $(document).on("mouseup", (e) => this.handleDragEnd(e));
      $(document).on("touchend", (e) => this.handleDragEnd(e));
      $(document).on("mousemove", (e) => this.handleDragMove(e));
      $(document).on("touchcancel", (e) => this.handleDragEnd(e));
    }
    makeDraggable(element) {
      // Der Katalog wird bei jeder Suche und jedem Filterwechsel komplett neu
      // aufgebaut, die alten Kacheln fliegen dabei aus dem DOM. Ohne diese
      // Bremse wuechse die Liste bei laengerem Tippen ins Unbegrenzte und
      // hielte lauter abgehaengte Knoten fest.
      if (this._elements.length > 1e3) {
        this._pruneElements();
      }
      this._elements.push(element);
      this._applyTouchAction(element);
      element.on("mousedown", (e) => this.handleDragStart(e));
      element.on("touchstart", (e) => this.handleDragStart(e));
    }
    _pruneElements() {
      this._elements = this._elements.filter((el) => {
        const node = el.get(0);
        return node && node.isConnected;
      });
    }
    // Sagt dem Browser, welche Achse er selbst behalten darf. Ein horizontaler
    // Draggable im vertikal scrollenden Katalog-Drawer bekommt pan-y: das
    // Scrollen erledigt der Browser, die Quergeste bleibt bei uns und der
    // touchmove bleibt cancelable. Ohne Richtung (Paletten-Flaeche) darf gar
    // nichts scrollen, also none.
    _touchActionValue() {
      if (this._direction === "horizontal") {
        return "pan-y";
      }
      if (this._direction === "vertical") {
        return "pan-x";
      }
      return "none";
    }
    _applyTouchAction(element) {
      element.css("touch-action", this._touchActionValue());
    }
    // Wechselt die Richtung, ohne eine neue Instanz zu bauen. Frueher hat
    // ProductsView bei JEDEM resize ein neues Draggable erzeugt -- jedes davon
    // haengt eigene Listener an document, und die alten Instanzen blieben mit
    // ihrer alten Richtung aktiv, weil die Elemente noch auf sie gebunden waren.
    setDirection(direction) {
      if (this._direction === direction) {
        return;
      }
      this._direction = direction;
      this._isMaybeDragging = false;
      this._isDragging = false;
      this._pruneElements();
      this._elements.forEach((el) => this._applyTouchAction(el));
    }
    static conformPointerEvent(e) {
      if (isNaN(parseInt(e.pageX)) && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches.length > 0) {
        e.pageX = e.originalEvent.changedTouches[0].pageX;
        e.pageY = e.originalEvent.changedTouches[0].pageY;
      } else if (isNaN(parseInt(e.pageX)) && e.changedTouches && e.changedTouches.length > 0) {
        e.pageX = e.changedTouches[0].pageX;
        e.pageY = e.changedTouches[0].pageY;
      }
      return e;
    }
    handleDragStart(e) {
      e = _Draggable.conformPointerEvent(e);
      this._currentElement = $(e.target);
      if (!this._currentElement.is(".draggable")) {
        this._currentElement = this._currentElement.parents(".draggable").first();
      }
      if (this._currentElement.hasClass("no-drag")) {
        return;
      }
      this._isMaybeDragging = true;
      this._startX = e.pageX;
      this._startY = e.pageY;
    }
    startDrag() {
      this._isMaybeDragging = true;
      this._isDragging = true;
      this._startX = 0;
      this._startY = 0;
      $(document.body).addClass("no-touch");
    }
    handleDragMove(e) {
      if (!this._isDragging && !this._isMaybeDragging) {
        return;
      }
      e = _Draggable.conformPointerEvent(e);
      const newX = e.pageX;
      const newY = e.pageY;
      const deltaX = newX - this._startX;
      const deltaY = newY - this._startY;
      if (!this._isDragging) {
        const absDeltaX = Math.abs(deltaX);
        const absDeltaY = Math.abs(deltaY);
        if (this._direction === "horizontal") {
          if (absDeltaY >= this._threshold) {
            this._isMaybeDragging = false;
            return;
          }
          if (absDeltaX >= this._threshold) {
            this._isDragging = true;
            const info = {
              target: this._currentElement,
              startX: this._startX,
              startY: this._startY
            };
            this._dragStartCallbacks.forEach((callback) => callback(info));
            $(document.body).addClass("no-touch");
          }
        } else if (this._direction === "vertical") {
          if (absDeltaX >= this._threshold) {
            this._isMaybeDragging = false;
            return;
          }
          if (absDeltaY >= this._threshold) {
            this._isDragging = true;
            const info = {
              target: this._currentElement,
              startX: this._startX,
              startY: this._startY
            };
            this._dragStartCallbacks.forEach((callback) => callback(info));
            $(document.body).addClass("no-touch");
          }
        } else {
          if (Math.sqrt(absDeltaX * absDeltaX + absDeltaY * absDeltaY) > this._threshold) {
            this._isDragging = true;
            const info = {
              target: this._currentElement,
              startX: this._startX,
              startY: this._startY
            };
            this._dragStartCallbacks.forEach((callback) => callback(info));
            $(document.body).addClass("no-touch");
          }
        }
      } else {
        const info = {
          target: this._currentElement,
          startX: this._startX,
          startY: this._startY,
          currentX: newX,
          currentY: newY
        };
        this._dragMoveCallbacks.forEach((callback) => callback(info));
      }
      // preventDefault erst, wenn die Geste als Drag erkannt ist. Vorher hat der
      // Browser das Sagen. Frueher stand das preventDefault ganz oben in dieser
      // Methode, also VOR der Richtungspruefung -- damit hat schon die blosse
      // Beruehrung einer Katalog-Kachel das vertikale Scrollen im Drawer
      // blockiert (Android komplett, iOS klebrig). Welche Achse der Browser
      // behalten darf, legt touch-action in makeDraggable() fest.
      if (this._isDragging && e.cancelable) {
        e.preventDefault();
      }
    }
    handleDragEnd(e) {
      $(document.body).removeClass("no-touch");
      if (this._isDragging) {
        this._isDragging = false;
        const info = {
          target: this._currentElement,
          startX: this._startX,
          startY: this._startY
        };
        this._dragEndCallbacks.forEach((callback) => callback(info));
      }
      this._isMaybeDragging = false;
    }
    onDragStart(callback) {
      this._dragStartCallbacks.push(callback);
    }
    onDragEnd(callback) {
      this._dragEndCallbacks.push(callback);
    }
    onDragMove(callback) {
      this._dragMoveCallbacks.push(callback);
    }
  };

  // palette-designer/helpers/easing.js
  function lerp(start, end, percent) {
    return start + percent * (end - start);
  }
  function easeInOutCubic(currentIteration, startValue, changeInValue, totalIterations) {
    if ((currentIteration /= totalIterations / 2) < 1) {
      return changeInValue / 2 * Math.pow(currentIteration, 3) + startValue;
    }
    return changeInValue / 2 * (Math.pow(currentIteration - 2, 3) + 2) + startValue;
  }

  // palette-designer/helpers/device.js
  function isTouchDevice() {
    return !!("ontouchstart" in window || navigator.maxTouchPoints);
  }

  // palette-designer/helpers/rectangle.js
  function computeRectOverlapArea(a, b) {
    const xOverlap = Math.max(0, Math.min(a.right, b.right) - Math.max(a.left, b.left));
    const yOverlap = Math.max(0, Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top));
    return xOverlap * yOverlap;
  }

  // palette-designer/views/palette-view.js
  var paletteViewDefaultOptions = {
    perspective: 1400
  };
  // Wartet auf das Ende einer Ueberblendung -- aber nicht endlos. transitionend
  // kommt nur, wenn tatsaechlich eine laeuft: nicht im Hintergrund-Tab, nicht bei
  // abgeschalteten Systemanimationen und nicht, wenn das Element den Zielzustand
  // schon hatte. Ohne Rueckfallebene bleibt das Promise dann fuer immer offen und
  // der Aufrufer haengt mitten in der Animation -- beim Palettenwechsel etwa
  // zwischen "alte Palette raus" und "neue rein".
  function waitForTransitionEnd(element, maximalMs = 1200) {
    return new Promise((resolve) => {
      let erledigt = false;
      const fertig = () => {
        if (erledigt) {
          return;
        }
        erledigt = true;
        element.off("transitionend", fertig);
        resolve();
      };
      element.one("transitionend", fertig);
      window.setTimeout(fertig, maximalMs);
    });
  }
  var PaletteView = class extends View {
    constructor(element, viewModel, options) {
      super(viewModel);
      this.options = Object.assign(Object.assign({}, paletteViewDefaultOptions), options);
      this.element = element;
      this.spinner = this.element.parent().find(".spinner");
      this.customPalette = this.viewModel.palette;
      this.base = element.find(".base");
      this.topLid = element.find(".top-lid");
      this.bottomLid = element.find(".bottom-lid");
      this.topLidShadow = element.find(".top-lid-shadow");
      this.bottomLidShadow = element.find(".bottom-lid-shadow");
      this.baseShadow = element.find(".base-shadow");
      this.slots = this.base.find(".slots");
      this.mirror = this.topLid.find(".mirror");
      this.dropIndicator = this.base.find(".drop-indicator");
      this.view = "closed";
      this.draggable = new Draggable(null, 10);
      this._paletteStyles = null;
      this.dropSlotIndex = -1;
      this.dropGridOffsetX = -1;
      this.dropGridOffsetY = -1;
      this.topLidOpenPercent = 0;
      this.bottomLidOpenPercent = 0;
      this.activePlacedPan = null;
      this.activePlacedPanRect = null;
      this._panTapTimes = {};
      this.draggable.onDragStart((e) => {
        this._cancelHold = true;
        const placedPan = e.target.data("placedPan");
        this.activePlacedPan = placedPan;
        this.activePlacedPanRect = e.target.get(0).getBoundingClientRect();
        Broadcast.send("activePanChanged", {
          screenRect: this.activePlacedPanRect,
          rotation: placedPan.rotation,
          pan: placedPan.pan
        });
        this._dragElement = $(e.target);
        this._dragElement.css("display", "none");
        this.viewModel.removePan(e.target.data("placedPan"));
      });
      const handleDragEnd = () => {
        if (this._dragElement) {
          this._dragElement.remove();
          this._dragElement = null;
        }
      };
      $(document).on("touchend", handleDragEnd);
      $(document).on("mouseup", handleDragEnd);
      this._handlePaletteChanged();
      window.addEventListener("resize", () => {
        this.resize();
        this._update();
      });
      window.addEventListener("focus", () => {
        this._update();
      });
      Broadcast.receive("requestHighlightPans", (pans) => {
        this._highlightPans(pans);
      });
    }
    _updateUrl() {
      window.history.replaceState({}, "", this._viewModel.palette.permaLink);
    }
    handlePropertyChanged(property) {
      if (property === "activePan") {
        this.dropIndicator.removeClass("visible");
      } else if (property === "palette.pans[]") {
        this._handlePansChanged(true);
        this._updateUrl();
      } else if (property === "palette.pans") {
        this._handlePansChanged(false);
        this._updateUrl();
      } else if (property === "palette.palette") {
        this._handlePaletteChanged();
        this._updateUrl();
      } else if (property === "palette.id") {
        this._updateUrl();
      }
    }
    _highlightPans(pans) {
      const panElements = this.element.find(".base .pan");
      const startTime = (/* @__PURE__ */ new Date()).getTime();
      const duration = 300;
      const colors = [[67, 255, 255]];
      const timer = window.setInterval(() => {
        const elapsed = (/* @__PURE__ */ new Date()).getTime() - startTime;
        let allDone = true;
        let i = 0;
        panElements.each((index, element) => {
          const pan = $(element);
          if (!pans.includes(pan.data("placedPan"))) {
            return;
          }
          const elapsedPercent = Math.min(1, (elapsed - i * 20) / duration);
          if (elapsedPercent < 0) {
            return;
          }
          ++i;
          let amount = Math.sin(Math.PI * elapsedPercent);
          let color = colors[i % colors.length];
          let r = lerp(85, color[0], amount);
          let g = lerp(85, color[1], amount);
          let b = lerp(85, color[2], amount);
          pan.css("border-color", `rgb(${r}, ${g}, ${b})`).css("box-shadow", `0 0 4px rgba(${color[0]}, ${color[1]}, ${color[2]}, ${amount})`);
          if (elapsedPercent < 1) {
            allDone = false;
          }
        });
        if (allDone) {
          window.clearInterval(timer);
          panElements.each((index, element) => {
            $(element).css("border-color", "").css("box-shadow", "");
          });
        }
      }, 10);
    }
    _loadImages(images) {
      // Zwei Altfehler behoben (30.08.): (1) Hier wurde "?r=1" angehaengt,
      // _applyPaletteStyles setzt die URLs aber OHNE Query -- anderer
      // Cache-Key, der komplette Vorlader war wirkungslos. (2) decode()
      // statt onload: sonst faellt das JPEG-Dekodieren mitten in die
      // Einblende-Animation (die gemessenen >80-ms-Frames beim Wechsel).
      const promises = images.map((url) => new Promise((resolve) => {
        const image = new Image();
        image.src = url;
        if (typeof image.decode === "function") {
          image.decode().then(resolve, resolve);
        } else {
          image.onload = resolve;
          image.onerror = resolve;
        }
      }));
      return Promise.all(promises);
    }
    async _handlePaletteChanged() {
      // Schnelle Folgewechsel serialisieren: laeuft bereits ein Wechsel, nur
      // vormerken -- der laufende Durchgang zieht am Ende genau EINMAL auf den
      // dann aktuellen Zielwert nach (Zwischenziele werden uebersprungen).
      // Vorher liefen zwei Durchgaenge parallel: der zweite blieb in
      // changeView() am _isChangingView-Guard haengen, "endPaletteChanging"
      // kam nie, und der Designer stand ausgegraut, bis die 8-Sekunden-
      // Notbremse ihn freigab (Justins Meldung vom 30.08., gleiche Wurzel
      // wie die Kundenmeldung vom 17.08.).
      if (this._nbWechselLaeuft) {
        this._nbWechselNachziehen = true;
        return;
      }
      this._nbWechselLaeuft = true;
      try {
        do {
          this._nbWechselNachziehen = false;
          await this._nbPaletteWechselDurchfuehren();
        } while (this._nbWechselNachziehen);
      } finally {
        this._nbWechselLaeuft = false;
      }
    }
    // Bildliste einer Palette -- EXAKT die URLs, die _applyPaletteStyles auch
    // setzt (frueher lud der Vorlader bottom-lid als .jpg, angewendet wird
    // .png; die inside-Variante existiert am CDN NUR als .png -> 404 ins
    // Leere). Wird auch vom Prefetch der Groessenleiste benutzt.
    _nbBildlisteFuer(palette) {
      const basis = window.inlineData.PaletteDesigner.imagePath + encodeURIComponent(palette.name.toLowerCase().replace(/\s+/g, '-')) + "_";
      const liste = [basis + "base.jpg"];
      if (palette.hasTopLid) {
        liste.push(basis + "top-lid-inside.jpg");
        if (palette.hasTopLidOverlay) {
          liste.push(basis + "top-lid-inside-overlay.png");
        }
        liste.push(basis + "top-lid-outside.jpg");
      }
      if (palette.hasBottomLid) {
        liste.push(basis + "bottom-lid-inside.png");
        liste.push(basis + "bottom-lid-outside.png");
      }
      return { basis, liste };
    }
    async _nbPaletteWechselDurchfuehren() {
      this._isPaletteChanging = true;
      Broadcast.send("beginPaletteChanging", {});
      // Bilder SOFORT anstossen, parallel zur Schliess-Animation -- vorher
      // begann das Laden erst nach dem Ausblenden und die volle Netzzeit
      // lag sichtbar zwischen den Animationen.
      const neuePalette = this.viewModel.palette.palette;
      const { basis: imageBasePath, liste: imageSet } = this._nbBildlisteFuer(neuePalette);
      const ladePromise = this._loadImages(imageSet);
      if (this.element.hasClass("visible")) {
        await this.disappear();
      }
      this.spinner.addClass("visible");
      this.palette = neuePalette;
      await ladePromise;
      let applyStyles = {
        ".preview .base": imageBasePath + "base.jpg"
      };
      if (this.palette.hasTopLid) {
        applyStyles = Object.assign(applyStyles, {
          ".preview .top-lid": imageBasePath + "top-lid-inside.jpg",
          ".preview .top-lid.backside": imageBasePath + "top-lid-outside.jpg"
        });
      }
      if (this.palette.hasBottomLid) {
        applyStyles = Object.assign(applyStyles, {
          ".preview .bottom-lid": imageBasePath + "bottom-lid-inside.png",
          ".preview .bottom-lid.backside": imageBasePath + "bottom-lid-outside.png"
        });
      }
      if (this.palette.hasTopLidOverlay) {
        applyStyles = Object.assign(applyStyles, {
          ".preview .top-lid .overlay": imageBasePath + "top-lid-inside-overlay.png"
        });
      } else {
        applyStyles = Object.assign(applyStyles, {
          ".preview .top-lid .overlay": "none"
        });
      }
      this._paletteStyles = applyStyles;
      this._applyPaletteStyles();
      this.createSlots();
      this.resize();
      this._update();
      this._isPaletteChanging = false;
      this._handlePansChanged();
      this.spinner.removeClass("visible");
      // "endPaletteChanging" bewusst VOR dem Aufklappen: der Katalog wird
      // wieder bedienbar, waehrend sich der Deckel noch oeffnet (bisheriges
      // Verhalten). Das appear() wird aber AWAITED, damit die Warteschlange
      // oben erst nach abgeschlossener Oeffnung nachzieht -- sonst kollidierte
      // ein Folgewechsel mit der laufenden changeView("open").
      Broadcast.send("endPaletteChanging", {});
      await this.appear();
    }
    _applyPaletteStyles() {
      for (let key of Object.keys(this._paletteStyles)) {
        $(key).css("background-image", `url(${this._paletteStyles[key]})`);
      }
    }
    _handleHold(element) {
      let timer;
      this._cancelHold = false;
      
      const panId = element.data("placedPan")?.pan?.id;
      
      const timerFired = () => {
        if (this._cancelHold) {
          return;
        }
        if (!isTouchDevice()) {
          this._viewModel.inspectedProduct = element.data("placedPan").pan;
        }
      };
      
      const handleDoubleTap = (e) => {
        if (!panId) return;
        
        const currentTime = new Date().getTime();
        const lastTap = this._panTapTimes[panId] || 0;
        const tapLength = currentTime - lastTap;
        
        if (tapLength < 300 && tapLength > 0) {
          // Double tap detected - show product details
          e.preventDefault();
          this._viewModel.showProductDetails(element.data("placedPan").pan);
          delete this._panTapTimes[panId]; // Reset to prevent triple tap
        } else {
          this._panTapTimes[panId] = currentTime;
        }
      };
      
      const start = (e) => {
        end();
        timer = window.setTimeout(timerFired, 800);
      };
      const end = (e) => {
        if (timer) {
          window.clearTimeout(timer);
          timer = null;
        }
        if (!isTouchDevice()) {
          this._viewModel.inspectedProduct = null;
        }
      };
      if (!isTouchDevice()) {
        element.on("mouseover", start);
        element.on("mouseout", end);
      } else {
        element.on("touchstart", start);
        element.on("touchend", (e) => {
          end(e);
          handleDoubleTap(e);
        });
      }
    }
    _handlePansChanged(incremental) {
      if (this._isPaletteChanging) {
        return;
      }
      const slots = this.slots.find(".slot").toArray();
      this.slots.find(".pan").data("keep", false);
      const addedPans = [];
      for (let placedPan of this.customPalette.pans) {
        const slot = slots[placedPan.slotIndex];
        const existing = $(slot).find(".pan").filter((index, element) => $(element).data("placedPan") === placedPan);
        if (existing.length > 0) {
          existing.data("keep", true);
          continue;
        }
        const panElement = $(`
                <div class="pan draggable" style="background-image: url(${placedPan.pan.image})"></div>
            `);
        panElement.addClass(placedPan.pan.type.replace("_", "-"));
        // Verfuegbarkeit dezent markieren. Der Pan bleibt voll ziehbar --
        // markieren statt blockieren war die Entscheidung im Check-in. Die Farbe
        // selbst wird nicht veraendert, sie ist schliesslich das Produkt.
        if (placedPan.pan.isSoldOut) {
          panElement.addClass("pan-sold-out");
          panElement.attr("title", `${placedPan.pan.name} (${txt("availabilityPanSoldOut", "sold out")})`);
        } else if (placedPan.pan.isPreorder) {
          panElement.addClass("pan-preorder");
          panElement.attr("title", `${placedPan.pan.name} (${txt("availabilityPanPreorder", "preorder")})`);
        }
        panElement.data("placedPan", placedPan);
        panElement.data("keep", true);
        addedPans.push(panElement);
        if (!isTouchDevice()) {
          panElement.on("click", (e) => this._handlePanClicked(e));
        }
        this._handleHold(panElement);
        this.draggable.makeDraggable(panElement);
        $(slot).append(panElement);
      }
      if (incremental) {
        this._animatePanChanges(
          this.slots.find(".pan").filter((index, element) => !$(element).data("keep")),
          addedPans
        );
      } else {
        this.slots.find(".pan").filter((index, element) => !$(element).data("keep")).remove();
      }
      this.resize();
      this._update();
    }
    _handlePanClicked(e) {
      if (!e.shiftKey) {
        return;
      }
      const pan = $(e.target).closest(".pan");
      const placedPan = pan.data("placedPan");
      this._viewModel.showProductDetails(placedPan.pan);
    }
    _animatePanChanges(removed, added) {
      if (removed.length < 1) {
        return;
      }
      const elementRect = this.element.get(0).getBoundingClientRect();
      const targetX = elementRect.x + 0.5 * elementRect.width;
      const targetY = elementRect.y + elementRect.height;
      if (this.activePlacedPan && removed.length === 1 && added.length === 2) {
        let first;
        let second;
        for (let newPan of added) {
          const newPlacedPan = newPan.data("placedPan");
          if (newPlacedPan.slotIndex === this.activePlacedPan.slotIndex && newPlacedPan.gridOffsetX === this.activePlacedPan.gridOffsetX && newPlacedPan.gridOffsetY === this.activePlacedPan.gridOffsetY) {
            first = newPan;
          } else {
            second = newPan;
          }
        }
        if (first && second) {
          removed.remove();
          first.css("opacity", 0);
          window.setTimeout(() => {
            const firstRect = first.get(0).getBoundingClientRect();
            const secondRect = second.get(0).getBoundingClientRect();
            const deltaX = secondRect.left - firstRect.left;
            const deltaY = secondRect.top - firstRect.top;
            first.css("transform", `translateX(${deltaX}px) translateY(${deltaY}px) rotate(${first.data("placedPan").rotation}deg)`).css("opacity", 1);
            window.setTimeout(() => {
              first.addClass("swapping").css("transform", `translateX(0) translateY(0) rotate(${first.data("placedPan").rotation}deg)`).one("transitionend", () => {
                first.removeClass("swapping");
                this.resize();
                this._update();
              });
            }, 50);
          }, 10);
          return;
        }
      }
      removed.each((index, element) => {
        element = $(element);
        if (!this._dragElement || element.get(0) !== this._dragElement.get(0)) {
          if (element.data("placedPan") === this.activePlacedPan) {
            element.remove();
          } else {
            const elementRect2 = element.get(0).getBoundingClientRect();
            element.addClass("removing").css("transform", `translateX(${targetX - elementRect2.x - 0.5 * elementRect2.width}px) translateY(${targetY - elementRect2.y}px) scale(0.5) rotate(${element.data("placedPan").rotation}deg)`).css("transition-duration", 0.2 + Math.random() * 0.3 + "s").css("opacity", 0).one("transitionend", () => element.remove());
          }
        }
      });
    }
    appear() {
      return new Promise((resolve, reject) => {
        this.element.addClass("visible");
        // 150 -> 60 ms: reicht, damit die visible-Transition anlaeuft, ohne
        // dem Wechsel eine spuerbare Kunstpause zu geben.
        window.setTimeout(() => this.changeView("open").then(resolve), 60);
      });
    }
    async disappear() {
      await this.changeView("closed");
      this.element.removeClass("visible");
      await waitForTransitionEnd(this.element.addClass("exit-right"));
      this.element.removeClass("exit-right");
      // 300 -> 100 ms: die transitionend-Wartezeit steht direkt davor, die
      // restliche Pause war reiner Sockel im 3,2-s-Wechsel.
      await new Promise((resolve) => window.setTimeout(resolve, 100));
    }
    async changeView(view) {
      return new Promise((resolve, reject) => {
        if (view === this.view || this._isChangingView) {
          // Vorher ein stilles return OHNE resolve: der Aufrufer (z. B.
          // disappear() beim Palettenwechsel) wartete dann ewig auf ein
          // Promise, das nie aufloest -- der Designer blieb grau, bis die
          // 8-Sekunden-Notbremse griff. Parallelitaet verhindert inzwischen
          // die Warteschlange in _handlePaletteChanged; das hier ist das
          // zweite Netz, damit KEIN Aufrufpfad je haengen bleiben kann.
          resolve();
          return;
        }
        this._isChangingView = true;
        this.view = view;
        const startTime = (/* @__PURE__ */ new Date()).getTime();
        // Die 1,6-s-Deckelinszenierung laeuft genau EINMAL pro Sitzung (der
        // Gaensehaut-Moment beim ersten Aufbau). Jeder weitere Wechsel ist
        // eine Arbeitsbewegung: 650 ms auf, 450 ms zu (Material/Carbon-
        // Groessenordnung fuer Container-Transitionen; die Kurve und die
        // Winkel bleiben unveraendert -- daran haengt die Schnittkante).
        // Bei reduzierter Bewegung springt der Deckel direkt in den Endzustand.
        let duration;
        if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
          duration = 1;
        } else if (view === "open") {
          duration = PaletteView._nbSchonGeoeffnet ? 650 : 1600;
          PaletteView._nbSchonGeoeffnet = true;
        } else {
          duration = 450;
        }
        const timer = () => {
          const elapsed = (/* @__PURE__ */ new Date()).getTime() - startTime;
          // easeInOutCubic ist ungeclamped und nur fuer [0, duration] gueltig.
          // Bei den neuen Kurzdauern (bis hinab zu 1 ms fuer reduced-motion)
          // laege ein einzelner rAF-Tick sonst WEIT ausserhalb der Kurve und
          // der Deckel bekaeme absurde Winkel. Abbruchbedingung unveraendert.
          const gekappt = Math.min(elapsed, duration);
          let percent;
          if (view === "open") {
            percent = easeInOutCubic(gekappt, 0, 0.6, duration);
          } else {
            percent = easeInOutCubic(gekappt, 0.6, -0.6, duration);
          }
          this.topLidOpenPercent = percent;
          this.bottomLidOpenPercent = percent;
          this._update();
          if (elapsed < duration) {
            window.requestAnimationFrame(timer);
          } else {
            this._isChangingView = false;
            resolve();
          }
        };
        window.requestAnimationFrame(timer);
      });
    }
    createSlots() {
      this.slots.empty();
      let nbSlotIndex = 0;
      for (let i = 0; i < this.palette.rows; i++) {
        for (let j = 0; j < this.palette.columns; j++) {
          const slot = $(`<div class="slot"></div>`);
          // Relaunch: Napf-Tap. Ein leerer Napf war die naheliegendste Geste
          // ueberhaupt und tat NICHTS. Die Logik (Ziel setzen, Katalog
          // oeffnen) sitzt im nbRelaunch-Modul am Dateiende.
          slot.attr("data-nb-slot", nbSlotIndex);
          const nbDieserIndex = nbSlotIndex;
          slot.on("click", () => Broadcast.send("nbSlotTap", { index: nbDieserIndex }));
          nbSlotIndex++;
          if (this.palette.gridWidth < this.palette.slotWidth || this.palette.gridHeight < this.palette.slotHeight) {
            const gridCols = parseInt(this.palette.slotWidth / this.palette.gridWidth);
            const gridRows = parseInt(this.palette.slotHeight / this.palette.gridHeight);
            for (let m = 0; m < gridRows; m++) {
              for (let n = 0; n < gridCols; n++) {
                const cell = $(`<div class="cell"></div>`);
                cell.css("width", 100 / gridCols + "%").css("height", 100 / gridRows + "%");
                slot.append(cell);
              }
            }
          }
          this.slots.append(slot);
        }
      }
      // Fuer den Ziel-Napf-Marker im nbRelaunch-Modul: die Slots sind neu.
      Broadcast.send("nbSlotsNeu", {});
    }
    get pixelsPerMm() {
      let bounds = this.element.get(0).getBoundingClientRect();
      let horzMm = bounds.width / this.palette.baseWidth;
      let vertMm = bounds.height / this.palette.baseHeight;
      return Math.min(horzMm, vertMm) * 0.75;
    }
    resize() {
      let mmToPixel = this.pixelsPerMm;
      const paletteWidth = this.palette.baseWidth * mmToPixel + "px";
      const paletteHeight = this.palette.baseHeight * mmToPixel + "px";
      this.base.width(paletteWidth);
      this.base.height(paletteHeight);
      this.baseShadow.width(paletteWidth);
      this.baseShadow.height(paletteHeight);
      this.baseShadow.css("transform", `translateX(-${3 * mmToPixel}px) translateY(${3 * mmToPixel}px)`);
      if (this.palette.hasTopLid) {
        const topLidHeight = this.palette.topLidHeight * mmToPixel + "px";
        this.topLid.width(paletteWidth);
        this.topLidShadow.width(paletteWidth);
        this.topLid.height(topLidHeight);
        this.topLidShadow.height(topLidHeight);
        this.topLid.show();
        this.topLidShadow.show();
        if (this.palette.hasMirror) {
          this.mirror.css("width", `${this.palette.mirrorWidth * mmToPixel}px`);
          this.mirror.css("height", `${this.palette.mirrorHeight * mmToPixel}px`);
          this.mirror.show();
        } else {
          this.mirror.hide();
        }
      } else {
        this.topLid.hide();
        this.topLidShadow.hide();
      }
      if (this.palette.hasBottomLid) {
        const bottomLidHeight = this.palette.bottomLidHeight * mmToPixel + "px";
        this.bottomLid.width(paletteWidth);
        this.bottomLidShadow.width(paletteWidth);
        this.bottomLid.height(bottomLidHeight);
        this.bottomLidShadow.height(bottomLidHeight);
        this.bottomLid.show();
        this.bottomLidShadow.show();
      } else {
        this.bottomLid.hide();
        this.bottomLidShadow.hide();
      }
      this.resizeSlots(mmToPixel);
      this.resizePans(mmToPixel);
      this.updateMirror();
    }
    updateMirror() {
      if (this.palette.hasMirror) {
        this.mirror.empty();
        this.mirror.append(this.base.clone());
        this.baseMirror = this.mirror.find(".base");
      }
    }
    resizeSlots(mmToPixel) {
      const slotWidth = Math.round(this.palette.slotWidth * mmToPixel);
      const slotHeight = Math.round(this.palette.slotHeight * mmToPixel);
      const rowSpacing = Math.round(this.palette.rowSpacing * mmToPixel);
      const columnSpacing = Math.round(this.palette.columnSpacing * mmToPixel);
      const slotsWidth = slotWidth * this.palette.columns + columnSpacing * (this.palette.columns - 1);
      const slotsHeight = slotHeight * this.palette.rows + rowSpacing * (this.palette.rows - 1);
      this.slots.css("width", `${slotsWidth}px`).css("height", `${slotsHeight}px`);
      const slots = this.slots.find(".slot");
      slots.css("width", `${slotWidth}px`).css("height", `${slotHeight}px`);
      
      slots.css("margin-right", "0").css("margin-bottom", "0");
      
      for (let i = 0; i < this.palette.rows; i++) {
        for (let j = 0; j < this.palette.columns; j++) {
          const slot = slots.eq(i * this.palette.columns + j);
          if (i < this.palette.rows - 1) {
            slot.css("margin-bottom", `${rowSpacing}px`);
          }
          if (j < this.palette.columns - 1) {
            slot.css("margin-right", `${columnSpacing}px`);
          }
        }
      }
    }
    resizePans(mmToPixel) {
      const pans = this.slots.find(".pan");
      pans.each((index, element) => {
        element = $(element);
        const placedPan = element.data("placedPan");
        const panWidth = placedPan.pan.width * mmToPixel;
        const panHeight = placedPan.pan.height * mmToPixel;
        let offsetX = placedPan.gridOffsetX * this.palette.gridWidth * mmToPixel;
        let offsetY = placedPan.gridOffsetY * this.palette.gridHeight * mmToPixel;
        if (placedPan.gridOffsetX < 0) {
          offsetX = 0;
        }
        if (placedPan.gridOffsetY < 0) {
          offsetY = 0;
        }
        element.css("width", `${panWidth}px`);
        element.css("height", `${panHeight}px`);
        element.css("left", `${offsetX}px`);
        element.css("top", `${offsetY}px`);
        if (placedPan.rotation > 0) {
          if (!element.hasClass("removing") && !element.hasClass("swapping")) {
            element.css("transform", `rotate(${placedPan.rotation}deg)`);
          }
          if (placedPan.rotation === 90) {
            element.css("margin-left", `${panHeight}px`);
            element.css("transform-origin", "0 0");
          } else if (placedPan.rotation === 270) {
            element.css("margin-top", `${panWidth}px`);
            element.css("transform-origin", "0 0");
          }
        }
      });
    }
    handlePanDraggedOver(panView, viewModel) {
      this.dropSlotIndex = -1;
      this.dropGridOffsetX = -1;
      this.dropGridOffsetY = -1;
      const slotsRect = this.slots.get(0).getBoundingClientRect();
      const panRect = panView.screenRect;
      let panWidth = viewModel.orientedWidth;
      let panHeight = viewModel.orientedHeight;
      const panSizeMatchesSlotSize = this.palette.slotWidth === panWidth && this.palette.slotHeight === panHeight;
      if (computeRectOverlapArea(panRect, slotsRect) <= 0 || this.palette.hasSlots && !panSizeMatchesSlotSize) {
        this.dropIndicator.removeClass("visible");
        return;
      }
      let maxIntersectArea = Number.MIN_VALUE;
      let maxIntersectRect = null;
      let maxIntersectSlot = null;
      this.slots.find(".slot").each((index, element) => {
        const slotRect = element.getBoundingClientRect();
        const intersectArea = computeRectOverlapArea(panRect, slotRect);
        if (intersectArea > maxIntersectArea) {
          maxIntersectArea = intersectArea;
          maxIntersectSlot = $(element);
          maxIntersectRect = element.getBoundingClientRect();
          this.dropSlotIndex = index;
          this.dropGridOffsetX = 0;
          this.dropGridOffsetY = 0;
        }
      });
      if (maxIntersectSlot) {
        this.dropIndicator.addClass("visible");
        const baseRect = this.base.get(0).getBoundingClientRect();
        if (this.palette.hasSlots) {
          this.dropIndicator.css("left", maxIntersectRect.left - baseRect.left + "px").css("top", maxIntersectRect.top - baseRect.top + "px").css("width", maxIntersectRect.width + "px").css("height", maxIntersectRect.height + "px");
        } else {
          const pixelGridWidth = this.palette.gridWidth * this.pixelsPerMm;
          const pixelGridHeight = this.palette.gridHeight * this.pixelsPerMm;
          const gridColumns = this.palette.slotWidth / this.palette.gridWidth;
          const gridRows = this.palette.slotHeight / this.palette.gridHeight;
          const panColumns = viewModel.orientedWidth / this.palette.gridWidth;
          const panRows = viewModel.orientedHeight / this.palette.gridHeight;
          const gridOffsetX = Math.floor((panRect.left - maxIntersectRect.left) / pixelGridWidth);
          const gridOffsetY = Math.floor((panRect.top - maxIntersectRect.top) / pixelGridHeight);
          let maxGridIntersectArea = Number.MIN_VALUE;
          let maxGridIntersectRect = null;
          for (let j = Math.max(gridOffsetY - 1, 0); j < gridOffsetY + panRows + 1; j++) {
            for (let i = Math.max(gridOffsetX - 1, 0); i < gridOffsetX + panColumns + 1; i++) {
              if (j + panRows > gridRows || i + panColumns > gridColumns) {
                continue;
              }
              const gridRect = {
                left: maxIntersectRect.left + i * pixelGridWidth,
                top: maxIntersectRect.top + j * pixelGridHeight,
                right: maxIntersectRect.left + i * pixelGridWidth + panColumns * pixelGridWidth,
                bottom: maxIntersectRect.top + j * pixelGridHeight + panRows * pixelGridHeight,
                width: panColumns * pixelGridWidth,
                height: panRows * pixelGridHeight
              };
              const intersectArea = computeRectOverlapArea(panRect, gridRect);
              if (intersectArea > maxGridIntersectArea) {
                this.dropGridOffsetX = i;
                this.dropGridOffsetY = j;
                maxGridIntersectArea = intersectArea;
                maxGridIntersectRect = gridRect;
              }
            }
          }
          if (maxGridIntersectRect) {
            this.dropSlotIndex = 0;
            this.dropIndicator.css("left", maxGridIntersectRect.left - baseRect.left + "px").css("top", maxGridIntersectRect.top - baseRect.top + "px").css("width", maxGridIntersectRect.width + "px").css("height", maxGridIntersectRect.height + "px");
          } else {
            this.dropSlotIndex = -1;
            this.dropIndicator.removeClass("visible");
          }
        }
      }
    }
    handlePanDropped(panView, viewModel) {
      this.dropIndicator.removeClass("visible");
      if (this.dropSlotIndex >= 0) {
        panView.origin = this.dropIndicator.get(0).getBoundingClientRect();
        Broadcast.send("panDroppedInPalette", {});
        panView.returnToOrigin(true).then(() => {
          this.viewModel.placePan(
            viewModel.pan,
            this.dropSlotIndex,
            this.dropGridOffsetX,
            this.dropGridOffsetY,
            viewModel.rotation,
            this.activePlacedPan
          );
          this.activePlacedPan = null;
        });
        return true;
      } else if (this.activePlacedPan) {
        panView.origin = this.activePlacedPanRect;
        Broadcast.send("panDroppedInPalette", {});
        panView.returnToOrigin(true).then(() => {
          this.viewModel.placePan(
            this.activePlacedPan.pan,
            this.activePlacedPan.slotIndex,
            this.activePlacedPan.gridOffsetX,
            this.activePlacedPan.gridOffsetY,
            this.activePlacedPan.rotation,
            this.activePlacedPan
          );
          this.activePlacedPan = null;
        });
        return true;
      } else {
        Broadcast.send("panDropped", {});
        this.activePlacedPan = null;
        return false;
      }
    }
    _update() {
      const baseHeight = this.base.height();
      const topLidHeight = this.topLid.height();
      const bottomLidHeight = this.bottomLid.height();
      let topLidIsBackside = this.topLid.get(0).getBoundingClientRect().top >= this.base.get(0).getBoundingClientRect().top - 1;
      let bottomLidIsBackside = this.bottomLid.get(0).getBoundingClientRect().bottom <= this.base.get(0).getBoundingClientRect().bottom;
      const topLidTranslate = baseHeight * 0.5 + topLidHeight * 0.5 - (topLidIsBackside ? -1 : 1);
      const bottomLidTranslate = baseHeight * 0.5 + bottomLidHeight * 0.5;
      const topLidRotate = (1 - this.topLidOpenPercent) * 180;
      const bottomLidRotate = (1 - this.bottomLidOpenPercent) * 180;
      const topLidHalfPercent = (topLidRotate < 90 ? 90 - topLidRotate : topLidRotate - 90) / 90;
      const topLidShadowSkew = 20 * (1 - topLidHalfPercent);
      const topLidShadowRotate = topLidRotate + 20 * (1 - topLidHalfPercent);
      const bottomLidHalfPercent = (bottomLidRotate < 90 ? 90 - bottomLidRotate : bottomLidRotate - 90) / 90;
      const bottomLidShadowSkew = 20 * (1 - bottomLidHalfPercent);
      const bottomLidShadowRotate = bottomLidRotate - 40 * (1 - bottomLidHalfPercent);
      this.topLid.css("transform", `perspective(${this.options.perspective}px)  translateY(-${parseInt(topLidTranslate)}px) rotateX(-${topLidRotate}deg`);
      this.topLidShadow.css("transform", `perspective(${this.options.perspective}px)  translateY(-${parseInt(topLidTranslate)}px) rotateX(-${topLidShadowRotate}deg) skewX(${topLidShadowSkew}deg)`);
      this.bottomLid.css("transform", `perspective(${this.options.perspective}px)  translateY(${parseInt(bottomLidTranslate)}px) rotateX(${bottomLidRotate}deg`);
      this.bottomLidShadow.css("transform", `perspective(${this.options.perspective}px)  translateY(${parseInt(bottomLidTranslate)}px) rotateX(${bottomLidShadowRotate}deg) skewX(-${bottomLidShadowSkew}deg)`);
      const openPercent = Math.max(this.topLidOpenPercent, this.bottomLidOpenPercent);
      const baseShadedPercent = Math.min(1, openPercent / 0.5);
      this.base.css("filter", `brightness(${lerp(0.5, 1, baseShadedPercent)})`);
      this.topLid.css("filter", `brightness(${lerp(0.6, 1, Math.min(1, topLidHalfPercent))})`);
      this.bottomLid.css("filter", `brightness(${lerp(0.6, 1, Math.min(1, bottomLidHalfPercent))})`);
      if (this.palette.hasMirror) {
        let mirrorRotation = topLidRotate - 40;
        let mirrorTranslate = Math.max(0, 90 - topLidRotate) / 90 * this.topLid.height();
        this.baseMirror.css("transform", `perspective(${parseInt(this.options.perspective / 2)}px) rotateX(${mirrorRotation}deg) translateY(${mirrorTranslate}px)`).css("opacity", 1 - Math.max(0, 60 - topLidRotate) / 50);
      }
      let needsStylesReapplied = false;
      if (topLidIsBackside) {
        needsStylesReapplied = needsStylesReapplied || !this.topLid.hasClass("backside");
        this.topLid.addClass("backside");
      } else {
        needsStylesReapplied = needsStylesReapplied || this.topLid.hasClass("backside");
        this.topLid.removeClass("backside");
      }
      if (bottomLidIsBackside) {
        needsStylesReapplied = needsStylesReapplied || !this.bottomLid.hasClass("backside");
        this.bottomLid.addClass("backside");
      } else {
        needsStylesReapplied = needsStylesReapplied || this.bottomLid.hasClass("backside");
        this.bottomLid.removeClass("backside");
      }
      if (this._paletteStyles && needsStylesReapplied) {
        this._applyPaletteStyles();
      }
    }
  };

  // palette-designer/controls/flyout.js
  var Flyout = class _Flyout {
    constructor(element) {
      this.element = element;
    }
    show(target, anchor = "bottom-right") {
      _Flyout.current = this;
      this.element.css("visibility", "hidden");
      this.element.css("transition", "none");
      this.element.css("left", 0);
      this.element.css("top", 0);
      this.element.on("mousedown", (e) => e.stopPropagation());
      window.setTimeout(() => {
        const targetRect = target.get(0).getBoundingClientRect();
        const flyoutRect = this.element.get(0).getBoundingClientRect();
        const anchorParts = anchor.split("-");
        if (anchorParts[1] === "right") {
          this.element.css("left", targetRect.right - flyoutRect.right + "px");
        } else {
          this.element.css("left", targetRect.left - flyoutRect.left + "px");
        }
        if (anchorParts[0] === "bottom") {
          this.element.css("top", targetRect.bottom - flyoutRect.top + "px");
        } else {
          this.element.css("top", targetRect.top - flyoutRect.bottom + "px");
        }
        window.setTimeout(() => {
          this.element.css("visibility", "");
          this.element.css("transition", "");
          this.element.addClass("open");
        }, 10);
        window.setTimeout(() => {
          $(document.body).one("mousedown", () => this.hide());
        }, 300);
      }, 10);
    }
    hide() {
      this.element.removeClass("open");
      this.element.off("mousedown");
      // Zeitpunkt merken: Klickt man ein zweites Mal auf den Knopf, der das
      // Flyout geoeffnet hat, schliesst der mousedown-Waechter oben es bereits,
      // BEVOR das click-Ereignis ankommt. Ohne diese Spur wuerde der
      // Klick-Handler es sofort wieder oeffnen, und das Flyout liesse sich nie
      // ueber seinen eigenen Knopf schliessen (Justin, 01.09.).
      this._zuletztVersteckt = Date.now();
      _Flyout.current = null;
    }
    // true, wenn dieses Flyout gerade eben durch den Klick geschlossen wurde,
    // der diesen Handler ausgeloest hat.
    geradeGeschlossen() {
      return this.element.hasClass("open") ||
        (this._zuletztVersteckt && Date.now() - this._zuletztVersteckt < 350);
    }
  };

  // palette-designer/views/product-filter-view.js
  var ProductFilterView = class extends View {
    constructor(element, viewModel) {
      super(viewModel);
      this.element = element;
      this.flyout = new Flyout(element);
      this.render(element);
    }
    handlePropertyChanged(property) {
      if (property === "products") {
        this._update();
      }
    }
    render(element) {
      const body = $($("#product-filters").html());
      element.append(body);
      const sortOrders = body.find(".sort-orders");
      this.viewModel.sortOrders.forEach((order) => {
        const li = $(`<li>${order.name}</li>`);
        li.on("click", () => this._selectSortOrder(order));
        li.data("order", order);
        sortOrders.append(li);
      });
      element.find("ul.filters li").on("click", (e) => this._handleFilterClicked(e));
    }
    _handleFilterClicked(e) {
      const li = $(e.target).closest("li");
      const field = li.data("field");
      let value = li.data("value");
      if (typeof value === "string" && value.includes(",")) {
        value = value.split(",");
      } else {
        value = [value];
      }
      this.viewModel.unsetAllFilters();
      if (field) {
        this.viewModel.setFilter(field, value);
      }
      this.flyout.hide();
    }
    _selectSortOrder(order) {
      this.viewModel.sortOrder = order;
      this.flyout.hide();
    }
    show(target) {
      this._update();
      this.flyout.show(target);
    }
    _update() {
      this.element.find(".checked").removeClass("checked");
      this.element.find(".sort-orders li").each((index, element) => {
        element = $(element);
        if (element.data("order") === this.viewModel.sortOrder) {
          element.addClass("checked");
          return false;
        }
      });
      const activeFilters = this.viewModel.activeFilters || {};
      let hasFilter = false;
      this.element.find(".filters li").each((index, element) => {
        element = $(element);
        const field = element.data("field");
        let value = element.data("value");
        if (typeof value === "string" && value.includes(",")) {
          value = value.split(",");
        } else {
          value = [value];
        }
        const activeFilter = activeFilters[field];
        if (activeFilter && Array.isArray(activeFilter) && activeFilter.length === value.length && activeFilter.every((entry) => value.includes(entry))) {
          element.addClass("checked");
          hasFilter = true;
          return false;
        }
      });
      if (!hasFilter) {
        this.element.find(".filters li:first-child").addClass("checked");
      }
    }
  };

  // palette-designer/views/products-view.js
  var ProductsView = class extends View {
    constructor(element, viewModel) {
      super(viewModel);
      this.element = element;
      this._draggable = new Draggable(null, 15);
      this._draggable.onDragStart((e) => this._handleDragStart(e));
      this.filterFlyout = new ProductFilterView(element.find(".filter-overlay"), viewModel);
      $(window).on("resize", () => this.handleResize());
      this.handleResize();
      this.initialize();
      // Vorher ein Toggle mit irrefuehrendem Namen: war der Drawer schon offen,
      // hat "requestOpenDrawer" ihn geschlossen. Jetzt idempotent.
      Broadcast.receive("requestOpenDrawer", () => {
        if (!this.element.hasClass("expanded")) {
          this.handleExpandClicked();
        }
      });
    }
    handleResize() {
      // "sichtbar" statt woertlich "block": die FARBEN-Lasche ist seit dem
      // Relaunch ein Flex-Container -- der starre block-Vergleich liess das
      // Handy heimlich im Sidebar-Modus laufen (CTA blieb versteckt, Napf-Tap
      // oeffnete den Katalog nicht, Drag-Richtung falsch).
      this._viewStyle = this.element.find(".expand-button").css("display") !== "none" ? "drawer" : "sidebar";
      // Nur die Richtung umstellen. Vorher entstand hier je resize eine neue
      // Draggable-Instanz samt neuer document-Listener und einem weiteren
      // onDragStart-Callback -- nach ein paar Resizes feuerte "activePanChanged"
      // entsprechend oft, und die Kacheln blieben an der ersten Instanz haengen.
      this._draggable.setDirection(this._viewStyle === "sidebar" ? null : "horizontal");
    }
    handlePropertyChanged(property) {
      if (property === "products") {
        this._repopulateExpandedCategories();
      } else if (property === "activeFilters" || property === "sortOrder") {
        this._updateSortOrderAndFilters();
      } else if (property === "selectedPalette") {
        this._handleSelectedPaletteChanged();
      } else if (property === "selectedProducts") {
        this._handleSelectedProductsChanged();
      }
    }
    _updateSortOrderAndFilters() {
      // Gegen den benannten Default vergleichen, nicht gegen Index 0 --
      // seit die Farbsortierung Standard ist, zeigte der harte Index sonst
      // dauerhaft einen "Sortierung"-Filterchip an, dessen Kreuz die
      // Sortierung auf Beliebtheit "zuruecksetzte".
      const hasCustomSortOrder = this.viewModel.sortOrder !== this.viewModel.defaultSortOrder;
      const hasCustomFilter = this.viewModel.activeFilters && Object.keys(this.viewModel.activeFilters).length > 0;
      const activeFilters = this.element.find(".active-filters");
      activeFilters.toggleClass("visible", hasCustomFilter || hasCustomSortOrder);
      const ul = activeFilters.find("ul");
      ul.empty();
      let li;
      if (hasCustomSortOrder) {
        li = $(`<li><span>${T("Sort")}: ${this.viewModel.sortOrder.name}</span><button class="icon-only remove-button"></button></li>`);
        li.find("button").on("click", () => this.viewModel.sortOrder = this.viewModel.defaultSortOrder);
        ul.append(li);
      }
      if (hasCustomFilter) {
        const keys = Object.keys(this.viewModel.activeFilters);
        const filter = keys[0];
        const value = this.viewModel.activeFilters[filter];
        let activeFilterName = "";
        switch (filter) {
          case "isOnSale":
            activeFilterName = T("On sale");
            break;
          case "availability":
            activeFilterName = T("In stock");
            break;
          case "isOwned":
            activeFilterName = value[0] ? T("Owned by me") : T("Not owned by me");
            break;
        }
        li = $(`<li><span>${T("Filter")}: ${activeFilterName}</span><button class="icon-only remove-button"></button></li>`);
        li.find("button").on("click", () => this.viewModel.unsetAllFilters());
        ul.append(li);
      }
    }
    handleViewModelChanged() {
      this.initialize();
    }
    _handleSelectedProductsChanged() {
      const productLookup = {};
      for (let product of this._viewModel.selectedProducts) {
        productLookup[product.id] = productLookup[product.id] ? productLookup[product.id] + 1 : 1;
      }
      this.catalogue.find("li.category").each((index, element) => {
        const category = $(element).data("category");
        let count = 0;
        for (let product of this._viewModel.getProductsForCategory(category)) {
          if (productLookup.hasOwnProperty(product.id)) {
            ++count;
          }
        }
        const span = $(element).find("> header > div > span");
        span.text(span.text().replace(/^[0-9]+/g, count));
      });
    }
    initialize() {
      this.catalogue = this.element.find(".catalogue > ul");
      this.catalogue.empty();
      for (let category of this.viewModel.categories) {
        category.onPropertyChanged((property) => this._handleCategoryPropertyChanged(category, property));
        const element = $(`
                <li class="rows full category">
                    <header class="horizontal full middle">
                        <div class="fill">
                            <h2>${category.name}</h2>
                            <span>${T(txt("relaunchSelectedCount", "{count} Selected"), { count: 0 })}</span>
                        </div>
                        <button></button>
                    </header>
                    <div class="full products">
                    </div>
                </li>
            `);
        element.toggle(category.isVisible);
        element.data("category", category);
        element.find("header").click((e) => this.handleHeaderClicked(e));
        if (category.isExpanded) {
          this.populateSection(element, category);
          element.addClass("expanded");
          element.find(".products").css("display", "block");
        }
        this.catalogue.append(element);
      }
      const sortOptions = this.element.find(".sort-overlay ul");
      for (let sortOrder of this.viewModel.sortOrders) {
        const option = $(`<li>${sortOrder.name}</li>`);
        sortOptions.append(option);
        option.data("value", sortOrder);
      }
      // Markiert die TATSAECHLICHE Standard-Sortierung (jetzt "Nach Farbe"),
      // nicht mehr stur den ersten Eintrag.
      sortOptions.find("li").each((index2, el2) => {
        $(el2).toggleClass("selected", $(el2).data("value") === this.viewModel.sortOrder);
      });
      this.catalogue.find("> li").first();
      this.element.find(".sort").click((e) => this.showSortOverlay(e));
      this.element.find(".filter").click((e) => this.showFilterOverlay(e));
      this.element.find(".search-filter input").on("input", (e) => this.handleSearchChanged(e));
      this.element.find(".sort-overlay").find("li").click((e) => this.handleSortOptionClicked(e));
      this.element.find(".expand-button").on("click", () => this.handleExpandClicked());
      this.element.find(".expand-button").on("touchstart", (e) => {
        e.preventDefault();
        this.handleExpandClicked();
      });
      // Die Lasche ist ein div mit role=button -- Enter/Leertaste liefert der
      // Browser dort nicht automatisch, das muss selbst verdrahtet werden.
      this.element.find(".expand-button").on("keydown", (e) => {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          this.handleExpandClicked();
        }
      });
      this.element.on("mousedown", (e) => {
        e.stopPropagation();
        if (Flyout.current) {
          Flyout.current.hide();
        }
      });
      $(document.body).on("mousedown", () => {
      });
      this._handleSelectedProductsChanged();
    }
    collapseDrawer() {
      this.element.removeClass("expanded");
    }
    expandDrawer() {
      this.element.addClass("expanded");
    }
    _handleCategoryPropertyChanged(category, property) {
      const categoryElement = this.element.find(".category").filter((index, element) => $(element).data("category") === category);
      switch (property) {
        case "isVisible":
          categoryElement.toggle(category.isVisible);
          break;
        case "isExpanded":
          if (category.isExpanded) {
            this.populateSection(categoryElement, category);
            categoryElement.find(".products").show();
            categoryElement.addClass("expanded");
          } else {
            categoryElement.find(".products").hide();
            categoryElement.removeClass("expanded");
          }
          break;
      }
    }
    _repopulateExpandedCategories() {
      this.element.find(".category").each((index, element) => {
        element = $(element);
        const category = element.data("category");
        if (category.isExpanded) {
          this.populateSection(element, category);
        }
      });
    }
    _handleProductClicked(e) {
      let target = $(e.target);
      if (!target.is("li")) {
        target = target.parents("li").first();
      }
      const product = target.data("product");
      if (!isTouchDevice() && e.shiftKey) {
        this._viewModel.showProductDetails(product);
        return;
      }
      if (product.type === "empty_palette") {
        this.viewModel._nbGroesseQuelle = "katalog";
        this.viewModel.selectedPalette = product;
        // Der Setter kann jetzt auf die Verlust-Rueckfrage warten. Nur zuklappen,
        // wenn der Wechsel schon wirksam ist -- sonst schloesse ein spaeteres
        // "Abbrechen" den Katalog, obwohl sich nichts geaendert hat. Nach
        // bestaetigtem Dialog klappt nbConfirmPaletteSwitch selbst zu.
        if (this.viewModel.selectedPalette === product) {
          this.collapseDrawer();
        }
      } else {
        // Use async/await to handle the modal
        (async () => {
          await this.viewModel.addPan(product);
          Broadcast.send("productAdded", {});
        })();
      }
    }
    _handleSelectedPaletteChanged() {
      this.catalogue.find(".expanded li.selected").removeClass("selected");
      this.catalogue.find("li").filter((index, element) => $(element).data("product") === this.viewModel.selectedPalette).addClass("selected");
    }
    _handleHold(item) {
      let timer;
      this._cancelHold = false;
      const timerFired = () => {
        if (this._cancelHold) {
          return;
        }
        if (!isTouchDevice()) {
          this._viewModel.inspectedProduct = item.data("product");
        } else {
          this._viewModel.showProductDetails(item.data("product"));
        }
      };
      // Startpunkt der Beruehrung, um Scrollen von echtem Halten zu trennen.
      let startX = 0;
      let startY = 0;
      const punktVon = (e) => {
        const oe = e && (e.originalEvent || e);
        const t = oe && oe.touches && oe.touches[0];
        return t || null;
      };
      const start = (e) => {
        end();
        const t = punktVon(e);
        startX = t ? t.clientX : 0;
        startY = t ? t.clientY : 0;
        timer = window.setTimeout(timerFired, 800);
      };
      // Sobald der Finger sich merklich bewegt, ist es Scrollen und kein
      // Halten. Ohne das feuerte der Timer mitten im Scrollen und riss die
      // Detailansicht der Farbe auf, ueber die man gerade wischte (Justin,
      // 01.09.: "wenn man runterscrollen will, oeffnen sich die Details").
      // touchend kommt beim Scrollen erst am Ende der Geste, also viel zu
      // spaet. 10px Schwelle, damit ein ruhiger Finger nicht abbricht.
      const move = (e) => {
        const t = punktVon(e);
        if (!t) {
          return;
        }
        if (Math.abs(t.clientX - startX) > 10 || Math.abs(t.clientY - startY) > 10) {
          end();
        }
      };
      const end = (e) => {
        if (timer) {
          window.clearTimeout(timer);
          timer = null;
        }
        if (!isTouchDevice()) {
          this._viewModel.inspectedProduct = null;
        }
      };
      if (!isTouchDevice()) {
        item.on("mouseover", start);
        item.on("mouseout", end);
      } else {
        item.on("touchstart", start);
        item.on("touchmove", move);
        item.on("touchend touchcancel", end);
      }
    }
    _productToItem(product, width = null, height = null) {
      let topPadding = ~~(product.height / product.width * 100);
      if (topPadding < 1) {
        topPadding = 100;
      }
      let badgeClass = product.availability === "out_of_stock" ? "out-of-stock" : "";
      let badge = "";
      let name = product.name;
      if (product.isOwned) {
        badge = `<span class="badge owned" title="In your stash"></span>`;
      } else if (product.isNew) {
        badge = `<span class="badge">NEW</span>`;
      } else if (product.isOnSale) {
        const salePercent = Math.round((product.originalPrice - product.price) / product.originalPrice * 100);
        badge = `<span class="badge" style="background: #7304c7">-${salePercent}%</span>`;
      }
      if (product.availability === "out_of_stock") {
        name = `<span>${product.name}</span><span>Out of stock</span>`;
      }
      let style = "";
      if (width && height) {
        style = ` style="width: ${width}px; height: ${height}px"`;
      }
      let color = "transparent";
      if (product.color && product.color.rgb) {
        color = `rgb(${product.color.rgb.join(", ")})`;
      }
      const item = $(`<li class="${badgeClass}"${style}>
                        <figure class="draggable ${product.type.replace("_", "-")}" style="background-image: url(${product.image}); padding-top: ${topPadding}%; background-color: ${color}"></figure>
                        <figcaption>${name}</figcaption>
                        ${badge}
               </li>`);
      item.data("product", product);
      if (product.availability === "out_of_stock") {
        item.find("figcaption span:first-child").css("animation-delay", Math.random() * 2 + "s");
      }
      if (product === this.viewModel.selectedPalette) {
        item.addClass("selected");
      }
      this._handleHold(item);
      return item;
    }
    populateSection(section, category) {
      const products = this.viewModel.getProductsForCategory(category);
      const container = section.find(".products");
      container.empty();
      const ul = $(`<ul></ul>`);
      container.append(ul);
      if (category.type === "single") {
        ul.addClass("single");
      }
      for (let product of products) {
        let item = this._productToItem(product);
        ul.append(item);
      }
      if (category.type !== "single") {
        ul.find(".draggable").each((index, element) => {
          this._draggable.makeDraggable($(element));
        });
      }
      // Klickziel ist das ganze <li>, nicht nur die figure: der Produktname
      // (figcaption) liegt ausserhalb der figure und war vorher tote Flaeche --
      // auf dem Handy fast die halbe Kachel. _handleProductClicked loest das
      // Produkt ohnehin ueber parents("li") auf.
      ul.find("li").click((e) => this._handleProductClicked(e));
    }
    _handleDragStart(e) {
      Broadcast.send("activePanChanged", {
        screenRect: e.target.get(0).getBoundingClientRect(),
        rotation: 0,
        pan: e.target.parents("li").first().data("product")
      });
      if (this._viewStyle === "drawer") {
        this.collapseDrawer();
        this._cancelHold = true;
      }
    }
    handleSearchChanged(e) {
      const value = this.element.find(".search-filter input").val();
      this.viewModel.keyword = value;
    }
    handleExpandClicked() {
      if (this.element.hasClass("expanded")) {
        Broadcast.send("drawerCollapsed", {});
        this.collapseDrawer();
      } else {
        Broadcast.send("drawerExpanded", {});
        this.expandDrawer();
      }
    }
    handleSortOptionClicked(e) {
      let target = $(e.target);
      if (!target.is("li")) {
        target = target.parents("li").first();
      }
      const sortOverlay = this.element.find(".sort-overlay");
      sortOverlay.find(".selected").removeClass("selected");
      target.addClass("selected");
      window.setTimeout(() => {
        this.hideSortOverlay();
        this.viewModel.sortOrder = target.data("value");
      }, 100);
    }
    async showFilterOverlay(e) {
      let button = $(e.target);
      if (!button.is("button")) {
        button = button.parents("button").first();
      }
      this.filterFlyout.show(button);
    }
    showSortOverlay(e) {
      let button = $(e.target);
      if (!button.is("button")) {
        button = button.parents("button").first();
      }
      const flyout = new Flyout(this.element.find(".sort-overlay"));
      flyout.show(button);
    }
    hideSortOverlay() {
      this.element.find(".sort-overlay").removeClass("open");
    }
    handleHeaderClicked(e) {
      let element = $(e.target).closest("li.category");
      const category = element.data("category");
      category.isExpanded = !category.isExpanded;
    }
  };

  // palette-designer/views/share-view.js
  var ShareView = class extends View {
    constructor(element, viewModel) {
      super(viewModel);
      this._element = element;
      this._flyout = new Flyout(element);
      this._initialize();
    }
    _copyToClipboard(value) {
      const input = document.createElement("input");
      input.style.opacity = 0;
      input.style.position = "fixed";
      document.body.append(input);
      input.value = value;
      input.focus();
      input.select();
      try {
        return !!document.execCommand("copy");
      } catch (e) {
        return false;
      } finally {
        document.body.removeChild(input);
      }
    }
    _downloadUri(uri) {
      const a = document.createElement("a");
      a.href = uri;
      a.download = Math.floor((/* @__PURE__ */ new Date()).getTime() / 1e3) + "-share-me.jpg";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    async _showInstagramMessage() {
      const modalWindow = new ModalWindow2(
        "30em",
        "auto",
        { headline: T("Sharing to Instagram"), closeButton: false, buttons: [T("Got it")] }
      );
      modalWindow.append(T("Instagram doesn't support sharing from the web, so we're downloading a shareable picture for you instead."));
      await modalWindow.show();
      modalWindow.remove();
    }
    _initialize() {
      this._element.find("li").click((e) => {
        let target = $(e.target);
        if (!target.is("li")) {
          target = target.parents("li").first();
        }
        const site = target.attr("class");
        if (site === "instagram") {
          this._downloadUri(this._viewModel.sharingImageUri);
          this._showInstagramMessage();
        } else if (site === "download-image") {
          this._downloadUri(this._viewModel.sharingImageUri);
        } else if (site === "copy-link") {
          const success = this._copyToClipboard(this._viewModel.sharingLink);
          if (success) {
            Notification.show(T("Copied to clipboard"), T("A link has been copied to your clipboard"));
          } else {
            Notification.showError(T("Could not copy link"), T("Look like your browser doesn't support this"));
          }
        } else {
          const link = this._viewModel.linkForSite(site);
          window.open(link);
        }
        this._flyout.hide();
      });
    }
    show(target) {
      this._flyout.show(target, "top-right");
    }
  };

  // palette-designer/view-models/share-view-model.js
  var ShareViewModel = class extends ViewModel {
    constructor(customPalette) {
      super();
      this._customPalette = customPalette;
    }
    linkForSite(site) {
      const uri = this._customPalette.permaLink;
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      switch (site) {
        case "facebook":
          return "https://www.facebook.com/sharer.php?u=" + encodeURIComponent(uri);
        case "twitter":
          return "https://twitter.com/intent/tweet?text=" + encodeURIComponent("Designed by me on lethalcosmetics.com") + "&via=" + encodeURIComponent("lethalcosmetics") + "&url=" + encodeURIComponent(uri);
        case "whatsapp":
          return isMobile ? "whatsapp://send?text=" + encodeURIComponent("Designed by me on lethalcosmetics.com: " + uri) : "https://wa.me/?text=" + encodeURIComponent("Designed by me on lethalcosmetics.com: " + uri);
        case "messenger":
          return "fb-messenger://share?link=" + encodeURIComponent(uri) + "&app_id=261045168135893";
        default:
          return null;
      }
    }
    get sharingLink() {
      return this._customPalette.sharingLink;
    }
    get sharingImageUri() {
      return this._customPalette.sharingImageUri;
    }
  };

  // palette-designer/view-models/pan-view-model.js
  var PanViewModel = class extends ViewModel {
    constructor(pan) {
      super();
      this._pan = pan;
      this._rotation = 0;
    }
    get rotation() {
      return this._rotation;
    }
    set rotation(value) {
      this._rotation = value;
      this._notifyPropertyChanged("rotation");
    }
    get orientedWidth() {
      if (this._rotation === 0 || this._rotation === 180) {
        return this._pan.width;
      } else {
        return this._pan.height;
      }
    }
    get orientedHeight() {
      if (this._rotation === 0 || this._rotation === 180) {
        return this._pan.height;
      } else {
        return this._pan.width;
      }
    }
    rotateLeft() {
      this._rotation -= 90;
      if (this._rotation < 0) {
        this._rotation = 270;
      }
      this._notifyPropertyChanged("rotation");
    }
    rotateRight() {
      this._rotation += 90;
      if (this._rotation > 270) {
        this._rotation = 0;
      }
      this._notifyPropertyChanged("rotation");
    }
    get pan() {
      return this._pan;
    }
  };

  // palette-designer/views/pan-view.js
  var timeStep = 150;
  var PanView = class extends View {
    constructor(parent, origin, targetScale, viewModel) {
      super(viewModel);
      this.parent = parent;
      this._origin = origin;
      this._targetScale = targetScale / (origin.width / viewModel.pan.width);
      this._currentScale = 1;
      this._initialize();
      this.lastX = 0;
      this.lastY = 0;
      this.rotateX = 0;
      this.rotateY = 0;
      this.targetRotateX = 0;
      this.targetRotateY = 0;
      this.currentRotateX = 0;
      this.currentRotateY = 0;
      this.currentRotateZ = viewModel.rotation;
      this.lastStepTime = (/* @__PURE__ */ new Date()).getTime();
      this.lastFrameTime = (/* @__PURE__ */ new Date()).getTime();
      this.velocity = 30;
      window.requestAnimationFrame(() => this.animate());
    }
    handlePropertyChanged(property) {
      if (property === "rotation") {
        this._handleRotationChanged();
      }
    }
    get origin() {
      return this._origin;
    }
    set origin(value) {
      let scaleChange;
      if (this.viewModel.rotation === 90 || this.viewModel.rotation === 270) {
        this.element.css("height", value.width + "px");
        this.element.css("width", value.height + "px");
        this.shadow.css("height", value.width + "px");
        this.shadow.css("width", value.height + "px");
        scaleChange = value.height / this._origin.width;
      } else {
        this.element.css("width", value.width + "px");
        this.element.css("height", value.height + "px");
        this.shadow.css("width", value.width + "px");
        this.shadow.css("height", value.height + "px");
        scaleChange = value.width / this._origin.width;
      }
      this._origin = value;
      this._currentScale /= scaleChange;
      this.update();
    }
    _initialize() {
      this.centerX = this._origin.left + 0.5 * this._origin.width;
      this.centerY = this._origin.top + 0.5 * this._origin.height;
      this.targetX = this.centerX;
      this.targetY = this.centerY;
      this._isRemoved = false;
      this._isReturningToOrigin = false;
      this.element = $(`<div class="pan"></div>`);
      this.element.addClass(this.viewModel.pan.type.replace("_", "-"));
      this.element.css("touch-action", "none");
      this.element.css("pointer-events", "none");
      const ratio = this.viewModel.pan.height / this.viewModel.pan.width;
      this.shadow = $(`<div class="pan-shadow"></div>`);
      this.element.css("width", this._origin.width + "px");
      this.element.css("height", this._origin.width * ratio + "px");
      this.shadow.css("width", this._origin.width + "px");
      this.shadow.css("height", this._origin.width * ratio + "px");
      this.element.css("background-image", `url(${this.viewModel.pan.image})`);
      this.parent.append(this.shadow);
      this.parent.append(this.element);
    }
    moveTo(x, y) {
      if (this._isReturningToOrigin) {
        return;
      }
      this.targetX = x;
      this.targetY = y;
    }
    returnToOrigin(remove = false) {
      return new Promise((resolve, reject) => {
        this._isRemoved = remove;
        this._isReturningToOrigin = true;
        this._returnToOriginCallback = resolve;
        this.velocity = 5;
        this.targetX = this._origin.left + 0.5 * this._origin.width;
        this.targetY = this._origin.top + 0.5 * this._origin.height;
        this._targetScale = 1;
      });
    }
    get screenRect() {
      return this.element.get(0).getBoundingClientRect();
    }
    _handleRotationChanged() {
      let currentRotation = this.currentRotateZ % 360;
      if (currentRotation < 0) {
        currentRotation += 360;
      }
      const newRotation = this.viewModel.rotation;
      let delta = newRotation - currentRotation;
      if (delta === -270) {
        delta = 90;
      } else if (delta === 270) {
        delta = -90;
      }
      this._rotateAnimated(delta);
    }
    async _rotateAnimated(change) {
      if (this._isRemoved) {
        return;
      }
      this._savedBoundingRect = this.element.get(0).getBoundingClientRect();
      this._savedBoundingRect = {
        x: this._savedBoundingRect.x,
        y: this._savedBoundingRect.y,
        height: this._savedBoundingRect.width,
        width: this._savedBoundingRect.height
      };
      await new Promise((resolve, reject) => {
        const startRotate = this.currentRotateZ;
        const startTime = (/* @__PURE__ */ new Date()).getTime();
        const timer = window.setInterval(() => {
          const elapsed = (/* @__PURE__ */ new Date()).getTime() - startTime;
          this.currentRotateZ = easeInOutCubic(Math.min(400, elapsed), startRotate, change, 400);
          if (elapsed > 400) {
            window.clearInterval(timer);
            resolve();
          }
        }, 20);
      });
      this._savedBoundingRect = null;
    }
    update() {
      const parentRect = this.parent.get(0).getBoundingClientRect();
      let elementRect;
      if (this._savedBoundingRect) {
        elementRect = this._savedBoundingRect;
      } else {
        elementRect = this.element.get(0).getBoundingClientRect();
      }
      let relativeX = this.centerX - parentRect.left - 0.5 * (elementRect.width / this._currentScale);
      let relativeY = this.centerY - parentRect.top - 0.5 * (elementRect.height / this._currentScale);
      if (this.viewModel.rotation === 90 || this.viewModel.rotation === 270) {
        relativeX = this.centerX - parentRect.left - 0.5 * (elementRect.height / this._currentScale);
        relativeY = this.centerY - parentRect.top - 0.5 * (elementRect.width / this._currentScale);
      }
      this.element.css("transform", `translateX(${relativeX}px) translateY(${relativeY}px) rotateZ(${this.currentRotateZ}deg) scale(${this._currentScale}) perspective(170px) rotateX(${this.currentRotateX}deg) rotateY(${this.currentRotateY}deg)`);
      this.shadow.css("transform", `translateX(${relativeX}px) translateY(${relativeY}px) rotateZ(${this.currentRotateZ}deg) scale(${this._currentScale})`);
      elementRect = this.element.get(0).getBoundingClientRect();
      let elementCenterX = elementRect.left + 0.5 * (elementRect.width / this._currentScale);
      let elementCenterY = elementRect.top + 0.5 * (elementRect.height / this._currentScale);
      let elementHorzOffset = (elementCenterX - parentRect.left) / parentRect.width;
      let elementVertOffset = (elementCenterY - parentRect.top) / parentRect.height;
      this.shadow.css("margin-left", `${(elementHorzOffset - 0.5) / 0.5 * 40}px`);
      this.shadow.css("margin-top", `${(elementVertOffset - 0.5) / 0.5 * 10}px`);
    }
    animate() {
      if (!this.element) {
        return;
      }
      let frameTime = (/* @__PURE__ */ new Date()).getTime();
      let elapsed = frameTime - this.lastFrameTime;
      if (frameTime >= this.lastStepTime + timeStep) {
        this.rotateX = this.targetRotateX;
        this.rotateY = this.targetRotateY;
        let deltaX = this.centerX - this.lastX;
        let deltaY = this.centerY - this.lastY;
        if (this.viewModel.rotation === 90 || this.viewModel.rotation === 270) {
          [deltaX, deltaY] = [(this.viewModel.rotation === 270 ? -1 : 1) * deltaY, (this.viewModel.rotation === 90 ? -1 : 1) * deltaX];
        } else if (this.viewModel.rotation === 180) {
          deltaX = -deltaX;
          deltaY = -deltaY;
        }
        const xPercent = Math.sign(deltaX) * Math.min(1, Math.abs(deltaX) / 50);
        const yPercent = Math.sign(deltaY) * Math.min(1, Math.abs(deltaY) / 50);
        let tiltIntensity = 2.5 + (Math.max(1, Math.min(3, this._currentScale)) - 1) / 2 * 5;
        this.targetRotateX = parseInt(-yPercent * tiltIntensity);
        this.targetRotateY = parseInt(xPercent * tiltIntensity);
        this.lastX = this.centerX;
        this.lastY = this.centerY;
        this.lastStepTime = frameTime;
      }
      this.currentRotateX = lerp(this.rotateX, this.targetRotateX, (frameTime - this.lastStepTime) / 100);
      this.currentRotateY = lerp(this.rotateY, this.targetRotateY, (frameTime - this.lastStepTime) / 100);
      let centerDeltaX = this.targetX - this.centerX;
      let centerDeltaY = this.targetY - this.centerY;
      let scaleDelta = this._targetScale - this._currentScale;
      let deltaLength = Math.sqrt(centerDeltaX * centerDeltaX + centerDeltaY * centerDeltaY);
      if (isNaN(deltaLength) || deltaLength === 0) {
        deltaLength = 1;
      }
      let stepX = Math.sign(centerDeltaX) * Math.min(Math.abs(centerDeltaX), Math.abs(centerDeltaX / deltaLength * this.velocity));
      let stepY = Math.sign(centerDeltaY) * Math.min(Math.abs(centerDeltaY), Math.abs(centerDeltaY / deltaLength * this.velocity));
      let stepScale = Math.sign(scaleDelta) * Math.min(Math.abs(scaleDelta), 0.1);
      this.velocity *= 1.2;
      if (!this.hasMovedFromOrigin && Math.abs(stepX) === 0 && Math.abs(stepY) === 0 && stepScale === 0) {
        this.hasMovedFromOrigin = true;
      }
      if (this._isReturningToOrigin && Math.abs(stepX) === 0 && Math.abs(stepY) === 0) {
        this._isReturningToOrigin = false;
        if (this._returnToOriginCallback) {
          this._returnToOriginCallback();
          this._returnToOriginCallback = null;
        }
        if (this._isRemoved) {
          this.element.remove();
          this.shadow.remove();
          this.shadow = null;
          this.element = null;
          return;
        }
      }
      if (!this.hasMovedFromOrigin || this._isReturningToOrigin) {
        this.centerX += stepX;
        this.centerY += stepY;
        this._currentScale += stepScale;
      } else {
        this.centerX = this.targetX;
        this.centerY = this.targetY;
        this._currentScale = this._targetScale;
      }
      this.update();
      this.lastFrameTime = frameTime;
      window.requestAnimationFrame(() => this.animate());
    }
  };

  // palette-designer/views/new-palette-view.js
  var NewPaletteView = class extends View {
    constructor(element, viewModel) {
      super(viewModel);
      this._element = element;
      this._flyout = new Flyout(element);
      this._initialize();
    }
    _initialize() {
      this._element.find("li").on("click", (e) => this._handleItemClicked(e));
    }
    _handleItemClicked(e) {
      this._flyout.hide();
      const li = $(e.target).closest("li");
      switch (li.data("action")) {
        case "empty":
          this.viewModel.createEmpty();
          break;
        case "ai":
          this.viewModel.generateWithAi();
          break;
        case "inspiration":
          this.viewModel.showInspiration();
          break;
      }
    }
    show(target) {
      this._flyout.show(target, "top-left");
    }
  };

  // palette-designer/views/designer-view.js
  var DesignerView = class extends View {
    constructor(element, viewModel, paletteView, userViewModel, newPaletteViewModel) {
      super(viewModel);
      this._element = element;
      this._paletteView = paletteView;
      this._userViewModel = userViewModel;
      this._draggable = new Draggable();
      this._contextualButtons = element.find(".contextual-buttons");
      this._deletePanButton = element.find(".delete-pan");
      this._undoButton = element.find(".undo");
      this._redoButton = element.find(".redo");
      this._newButton = element.find(".new");
      this._shareButton = element.find(".share");
      this._savedPalettesButton = element.find(".saved");
      this._shareView = new ShareView(
        this._element.find(".sharing-overlay"),
        new ShareViewModel(viewModel.palette)
      );
      this._newPaletteView = new NewPaletteView(
        this._element.find(".new-palette-overlay"),
        newPaletteViewModel
      );
      this._initialize();
      this._activePanView = null;
      this._activePanViewModel = null;
      this._rotatePanTimer = null;
      Broadcast.receive("beginPaletteChanging", () => {
        this._disable();
        // Notbremse. Waehrend eines Palettenwechsels liegt der Katalog auf 40 %
        // Deckkraft und nimmt keine Klicks an (CSS: .page-palette-designer.disabled).
        // Bleibt "endPaletteChanging" aus -- etwa weil der Wechsel mitten in einer
        // Ueberblendung von einem neuen Wechsel unterbrochen wurde --, blieb der
        // Designer bisher DAUERHAFT gesperrt: abgedunkelt und unbedienbar.
        // Genau das war die Kundenmeldung vom 17.08.2026.
        if (this._entsperrNotbremse) {
          window.clearTimeout(this._entsperrNotbremse);
        }
        this._entsperrNotbremse = window.setTimeout(() => this._enable(), 8e3);
      });
      Broadcast.receive("endPaletteChanging", () => {
        window.setTimeout(() => {
          this._enable();
        }, 500);
      });
    }
    _disable() {
      this._element.addClass("disabled");
    }
    _enable() {
      if (this._entsperrNotbremse) {
        window.clearTimeout(this._entsperrNotbremse);
        this._entsperrNotbremse = null;
      }
      this._element.removeClass("disabled");
    }
    _initialize() {
      this._element.on("contextmenu", (e) => e.preventDefault());
      this._draggable.onDragMove((e) => this._handleDragMove(e));
      this._draggable.onDragEnd((e) => this._handleDragEnd(e));
      // Relaunch (03.09.): die Katalogspalte ist am Laptop/Desktop eine zweite
      // Loeschzone. Wer einen Napf nach rechts in den Katalog zieht, sieht dort
      // einen Muelleimer-Hinweis und entfernt die Farbe beim Loslassen. Bisher
      // musste man den kleinen Loesch-Knopf unter der Palette treffen.
      this._nbMenu = this._element.find(".menu");
      this._nbMenu.attr("data-nb-loeschen", txt("relaunchDropDelete", "Loslassen zum Entfernen"));
      this._nbUeberKatalog = false;
      this._undoButton.click(() => {
        this._viewModel.undo();
        Broadcast.send("undo", {});
      });
      this._redoButton.click(() => {
        this._viewModel.redo();
        Broadcast.send("redo", {});
      });
      this._newButton.click(() => this._handleNewClicked());
      this._shareButton.click(() => this._handleShareClicked());
      this._savedPalettesButton.click(() => {
        this._userViewModel.isVisible = true;
        Broadcast.send("savedPalettesOpened", {});
      });
      Broadcast.receive("activePanChanged", (value) => {
        this._updateActivePan(value);
      });
      Broadcast.receive("paletteChangedWithPanLoss", () => {
      });
      Broadcast.receive("asyncRequestFailed", (e) => {
        Notification.showError(e);
      });
      $(document).on("gesturestart", (e) => {
        e.preventDefault();
        console.log("Gesture start");
      });
    }
    // Beide Knoepfe schalten das Flyout um, statt es nur zu oeffnen: ein
    // zweiter Druck auf denselben Knopf schliesst die Auswahl wieder.
    _handleShareClicked() {
      if (this._nbFlyoutUmschalten(this._shareView)) {
        return;
      }
      try { nbMessen("byop_teilen", {}); } catch (e) { /* messen darf nie blockieren */ }
      this._shareView.show(this._shareButton);
    }
    _handleNewClicked() {
      if (this._nbFlyoutUmschalten(this._newPaletteView)) {
        return;
      }
      this._newPaletteView.show(this._newButton);
    }
    // Gibt true zurueck, wenn dieser Klick das Schliessen war und deshalb
    // nichts mehr geoeffnet werden soll.
    _nbFlyoutUmschalten(view) {
      try {
        // ShareView und NewPaletteView halten ihr Flyout als _flyout,
        // ProductFilterView als flyout. Beide Schreibweisen abdecken.
        const f = view && (view._flyout || view.flyout);
        if (!f || !f.geradeGeschlossen()) {
          return false;
        }
        f.hide();
        return true;
      } catch (e) {
        return false;
      }
    }
    _handleDragMove(e) {
      if (!this._activePanView) {
        return;
      }
      this._activePanView.moveTo(e.currentX, e.currentY);
      this._paletteView.handlePanDraggedOver(this._activePanView, this._activePanViewModel);
      const panRect = this._activePanView.screenRect;
      // Loeschzone Katalog: nur wenn der Katalog als feste Spalte steht (ab 701px),
      // und nur wenn mindestens ein Drittel des Napfs ueber der Spalte liegt.
      if (this._nbMenu && this._nbMenu.length && window.matchMedia("(min-width: 701px)").matches) {
        const menuRect = this._nbMenu.get(0).getBoundingClientRect();
        const anteil = computeRectOverlapArea(menuRect, panRect) / Math.max(1, panRect.width * panRect.height);
        const ueber = anteil >= 0.33;
        if (ueber !== this._nbUeberKatalog) {
          this._nbUeberKatalog = ueber;
          this._nbMenu.toggleClass("nb-loeschzone", ueber);
        }
      }
      let maxOverlap = Number.MIN_VALUE;
      let maxElement;
      this._contextualButtons.find("button").each((index, element) => {
        const rect = element.getBoundingClientRect();
        const overlap = computeRectOverlapArea(rect, panRect);
        if (overlap > 0 && overlap > maxOverlap) {
          maxOverlap = overlap;
          maxElement = element;
        }
      });
      if (maxElement) {
        maxElement = $(maxElement);
        const callback = () => {
          maxElement.find("div").one("animationend", () => maxElement.removeClass("turning"));
          maxElement.addClass("turning");
          maxElement.find("div").css("-webkit-animation-play-state", "running");
          if (maxElement.attr("class").indexOf("left") >= 0) {
            Broadcast.send("panRotatedleft", {});
            this._activePanViewModel.rotateLeft();
          } else {
            Broadcast.send("panRotatedRight", {});
            this._activePanViewModel.rotateRight();
          }
          this._rotatePanTimer = window.setTimeout(callback, 1e3);
        };
        if (!maxElement.hasClass("active")) {
          this._contextualButtons.find("button.active").removeClass("active").removeClass("turning");
          maxElement.addClass("active");
          if (maxElement.attr("class").indexOf("rotate") >= 0) {
            this._rotatePanTimer = window.setTimeout(callback, 350);
          } else {
            window.clearTimeout(this._rotatePanTimer);
          }
        }
      } else {
        this._contextualButtons.find("button.active").removeClass("active").removeClass("turning");
        window.clearTimeout(this._rotatePanTimer);
      }
    }
    _handleDragEnd(e) {
      if (this._nbUeberKatalog) {
        // Ueber dem Katalog losgelassen: der Napf fliegt in den Hinweis und ist
        // weg. Der Weg ist derselbe wie beim Loesch-Knopf, inklusive Rueckgaengig.
        const r = this._nbMenu.get(0).getBoundingClientRect();
        this._activePanView.origin = { left: r.left + r.width / 2 - 24, top: r.top + r.height / 2 - 24, width: 48, height: 48 };
        this._activePanView.returnToOrigin(true);
        Broadcast.send("panDeleted", {});
        this._nbUeberKatalog = false;
        this._nbMenu.removeClass("nb-loeschzone");
        this._activePanView = null;
        this._element.removeClass("dragging");
        return;
      }
      // Relaunch (04.09.): Passt der gezogene Napf nicht in die Palette (etwa
      // Gesichtspuder in eine Lidschatten-Palette), lief der Drop bisher in
      // handlePanDropped/placePan und wurde dort still verworfen, der Hinweis
      // kam nur beim Antippen. Jetzt vor dem Drop pruefen: zurueck zum
      // Ursprung und dasselbe Fenster wie beim Tippen.
      let nbPasstNicht = false;
      try {
        const pan = this._activePanViewModel && this._activePanViewModel.pan;
        const pm = this._paletteView && this._paletteView.viewModel && this._paletteView.viewModel._palette;
        const pal = pm && pm.palette;
        if (pan && pal && typeof pan.width === "number") {
          nbPasstNicht = (pan.width === 26 && pan.height === 26)
            ? !pm._canHoldEyeshadows(pal)
            : !(pan.width === pal.slotWidth && pan.height === pal.slotHeight);
        }
      } catch (e) { nbPasstNicht = false; }
      if (nbPasstNicht && !this._deletePanButton.hasClass("active")) {
        try { this._paletteView.dropIndicator.removeClass("visible"); this._paletteView.activePlacedPan = null; } catch (e) {}
        this._activePanView.returnToOrigin(true);
        Broadcast.send("panDropped", {});
        // Das Hinweisfenster lebt im Katalog-View-Model (dort sitzt auch das
        // Tipp-Verhalten). Der Haupt-View kennt es nicht, deshalb per Broadcast.
        Broadcast.send("nbPassungPruefen", { pan: this._activePanViewModel.pan });
      } else if (this._deletePanButton.hasClass("active")) {
        this._activePanView.origin = this._deletePanButton.get(0).getBoundingClientRect();
        this._activePanView.returnToOrigin(true);
        Broadcast.send("panDeleted", {});
      } else if (!this._paletteView.handlePanDropped(this._activePanView, this._activePanViewModel)) {
        this._activePanView.returnToOrigin(true);
        Broadcast.send("panDropped", {});
      } else {
        Broadcast.send("panDropped", {});
      }
      this._activePanView = null;
      this._element.removeClass("dragging");
    }
    handlePropertyChanged(property) {
      if (property === "canUndo") {
        this._undoButton.toggleClass("disabled", !this.viewModel.canUndo);
      } else if (property === "canRedo") {
        this._redoButton.toggleClass("disabled", !this.viewModel.canRedo);
      }
    }
    _updateActivePan(panInfo) {
      const pan = panInfo.pan;
      if (this._activePanView) {
        this._activePanView.remove();
        this._activePanView = null;
        this._element.removeClass("dragging");
      }
      if (pan !== null) {
        this._activePanViewModel = new PanViewModel(pan);
        this._activePanViewModel.rotation = panInfo.rotation;
        this._activePanView = new PanView(
          this._element,
          panInfo.screenRect,
          this._paletteView.pixelsPerMm * 1.1,
          this._activePanViewModel
        );
        this._element.addClass("dragging");
        this._draggable.startDrag();
      }
    }
  };

  // palette-designer/views/breakdown-view.js
  var BreakdownView = class {
    constructor(viewModel) {
      this.viewModel = viewModel;
    }
    async show() {
      const staticText = window.inlineData?.PaletteDesigner?.staticText;
      const modalWindow = new ModalWindow2(
        "50em",
        "auto",
        { headline: staticText?.yourPalette || T("Your palette"), closeButton: true, buttons: [{
          caption: staticText?.close || T("Close")
        }] }
      );
      const table = [`<table><thead><tr><td></td><td>${staticText?.product || T("Product")}</td><td>${staticText?.price || T("Price")}</td><td> </td><td>${staticText?.savings || T("Savings")}</td></tr></thead><tbody></tbody>`];
      let hasUndiscounted = false;
      for (let info of this.viewModel.palette.discountInformation) {
        table.push(`<tr><td><img src="${info.image}"></td><td>${info.name}</td><td>${formatPrice(info.discountedPrice)}</td>
<td>${formatPrice(info.originalPrice)}</td><td>${Math.round(info.discountPercent * 100)}%${!info.hasDiscount ? "*" : ""}</td></tr>`);
        if (!info.hasDiscount) {
          hasUndiscounted = true;
        }
      }
      table.push(`</tbody></table>`);
      let outro = "";
      // Der Hinweis gilt nur, solange wirklich noch kein Rabatt greift (unter 5
      // Artikeln). Frueher erschien er bei jeder nicht vollen Palette, auch
      // wenn der Checkout schon 5 oder 10 % abzog.
      if (!this.viewModel.palette.isComplete && !(this.viewModel.palette.discountPercentage > 0)) {
        outro = "<p class='space-above error'>" + (staticText?.paletteIncompleteError || T("Your palette is incomplete and therefore not eligible for a discount.")) + "</p>";
      } else if (hasUndiscounted) {
        outro = "<p class='space-above'>" + (staticText?.productNotEligibleForDiscount || T("* Product not eligible for a discount")) + "</p>";
      }
      const element = $(T(`
            <div class="breakdown-view inverse">
               <div class="scroll-container">
                    ${table.join("")}          
               </div>    
               ${outro}
           </div>
        `));
      modalWindow.append(element);
      await modalWindow.show();
      modalWindow.remove();
    }
  };

  // palette-designer/views/price-and-cart-view.js
  var PriceAndCartView = class extends View {
    constructor(element, viewModel) {
      super(viewModel);
      this._element = element;
      this._paletteName = element.find("h2");
      this._discountBadges = element.find(".badge");
      this._priceAmount = element.find("h3");
      this._originalPiceAmount = element.find(".original-price");
      this._addToCartButton = element.find(".add-to-cart");
      this._breakdownButton = element.find(".breakdown-button");
      this._addToCartButton.click(() => this._handleAddToCart());
      this._breakdownButton.click(() => this._handleShowBreakdown());
      this._update();
    }
    async _handleShowBreakdown() {
      try { nbMessen("byop_preisdetails", {}); } catch (e) { /* messen darf nie blockieren */ }
      new BreakdownView(this.viewModel).show();
    }
    async _handleAddToCart() {
      // Reentry-Schutz auf Button-Ebene (zusaetzlich zum Guard in Cart.addItem):
      // disabled unterdrueckt Klicks bereits, dies faengt programmatische Aufrufe.
      if (this._nbAtcBusy) return;
      this._nbAtcBusy = true;
      try { nbMessen("byop_warenkorb_klick", {}); } catch (e) { /* messen darf nie blockieren */ }
      // Native Bundles: sichtbares Feedback am Haupt-Button (.price-and-cart, nicht
      // die gleichnamigen Katalog-Buttons). Labels kommen lokalisiert aus byop.liquid.
      const nbBtn = document.querySelector('.price-and-cart button.add-to-cart');
      const nbSpan = nbBtn ? nbBtn.querySelector('span') : null;
      const nbPrevText = nbSpan ? nbSpan.textContent : '';
      // Edit-Modus? Gleiche Gueltigkeitsregel wie der Konsument in Cart.addItem (30 Min).
      const nbCheckEdit = function () {
        try {
          const raw = sessionStorage.getItem('nbEditBundle');
          if (!raw) return false;
          const edit = JSON.parse(raw);
          return !!(edit && edit.id && (Date.now() - (edit.ts || 0)) < 1800000);
        } catch (e) { return false; }
      };
      const nbWasEdit = nbCheckEdit();
      // Render-Prefetch schon beim Klick, nicht erst nach der Add-Response: Der
      // Server braucht fuer den Erst-Render ~10 s, der Add-Flow selbst ~7-10 s.
      // Startet der Render sofort, ist das Palettenbild meist fertig, wenn sich
      // der Drawer oeffnet (sonst zeigt er kurz die Leerpalette und tauscht nach).
      try {
        const nbImgBase = (window.inlineData && window.inlineData.PaletteDesigner && window.inlineData.PaletteDesigner.imageUri) || '';
        const nbPal = this.viewModel && this.viewModel.palette;
        if (nbImgBase && nbPal && typeof nbPal.serialize === 'function') {
          new Image().src = nbImgBase + '?pd=' + encodeURIComponent(stringifyPalette(nbPal.serialize()));
        }
      } catch (nbPrefetchError) { /* Anzeige-Detail, darf den Add nie brechen */ }
      try {
        this._addToCartButton.addClass("busy");
        if (nbBtn) {
          // Breite exakt einfrieren, BEVOR der Text wechselt: "Adding ..." ist
          // kuerzer als "Add to cart", dazu kommt der Ring davor -- ohne Sperre
          // wuerde der Button mal schmaler, mal breiter und alles links davon
          // ruckt mit. Der Button ist border-box mit 2.5em Innenabstand je
          // Seite, laengerer Busy-Text laeuft dort hinein statt zu ueberlaufen.
          // Freigabe im finally.
          nbBtn.style.width = nbBtn.getBoundingClientRect().width + 'px';
          nbBtn.disabled = true;
          const nbBusyLabel = nbBtn.getAttribute(nbWasEdit ? 'data-nb-label-busy-update' : 'data-nb-label-busy-add');
          if (nbSpan && nbBusyLabel) nbSpan.textContent = nbBusyLabel;
        }
        // Einen Bildaufbau abwarten, damit der Button seinen Busy-Zustand
        // sichtbar zeigt, BEVOR der Haupt-Thread mit dem Hinzufuegen belegt ist.
        // Frueher stand hier eine feste Pause von 100 ms; ein Frame reicht und
        // kostet nur rund 16 ms. requestAnimationFrame liefert im
        // Hintergrund-Tab nichts, deshalb ein Zeitgeber als Rueckfall.
        await new Promise((resolve) => {
          let nbFertig = false;
          const nbWeiter = () => { if (!nbFertig) { nbFertig = true; resolve(); } };
          window.requestAnimationFrame(() => window.requestAnimationFrame(nbWeiter));
          window.setTimeout(nbWeiter, 120);
        });
        // Notausstieg: addToCart kann in Vendor-Pfaden haengen (Modal-Promises,
        // Availability-Fetch ohne Timeout). Der Button darf NIE dauerhaft gesperrt
        // bleiben -- nach 60 s wird er freigegeben; der Wurzel-Guard in Cart.addItem
        // verhindert dabei weiterhin jedes Doppel-Add.
        await Promise.race([
          this.viewModel.addToCart(),
          new Promise((resolve) => window.setTimeout(resolve, 60000))
        ]);
        // addToCart() awaited Cart.addItem nicht (Add + Edit-Replace laufen danach
        // weiter). Auf das echte Ende warten, damit der Button erst wieder klickbar
        // wird, wenn der Warenkorb wirklich fertig ist (Timeout als Fallback: 30 s).
        // Feiner nachfragen: 30 ms statt 150 ms. Der Warenkorb ist oft mitten
        // in einem Intervall fertig, und die grobe Taktung verschenkte im Mittel
        // 75 ms, im schlechtesten Fall 150 ms, in denen der Button noch gesperrt
        // aussah, obwohl alles erledigt war. Der Notausstieg bleibt bei 30 s
        // (1000 Runden mal 30 ms).
        for (let nbI = 0; nbI < 1000 && Cart.current && Cart.current._nbAddInFlight; nbI++) {
          await new Promise((resolve) => window.setTimeout(resolve, 30));
        }
      } catch (e) {
        console.log(e);
      } finally {
        this._addToCartButton.removeClass("busy");
        if (nbBtn) {
          nbBtn.disabled = false;
          nbBtn.style.width = '';
          if (nbSpan) {
            if (nbCheckEdit()) {
              // Edit-Kontext besteht noch (z. B. Add am Verfuegbarkeits-Check gescheitert)
              nbSpan.textContent = nbBtn.getAttribute('data-nb-label-update') || nbPrevText;
            } else if (nbWasEdit) {
              // Edit-Kontext wurde konsumiert -> naechster Klick waere ein neues Add
              nbSpan.textContent = nbBtn.getAttribute('data-nb-label-add') || nbPrevText;
            } else {
              nbSpan.textContent = nbPrevText;
            }
          }
        }
        this._nbAtcBusy = false;
      }
    }
    _update() {
      this._paletteName.text(this.viewModel.palette.name);
      this._priceAmount.text(formatPrice(this.viewModel.palette.price));
      this._originalPiceAmount.text(formatPrice(this.viewModel.palette.originalPrice)).toggle(this.viewModel.palette.isOnSale);
      const percentage = Math.round(this.viewModel.palette.actualDiscountPercentage * 100);
      const displayPercentage = percentage + "%";
      this._discountBadges.text(`-${displayPercentage}`).toggleClass("visible", percentage > 0);
      this._saveInfoButton = this._element.find(".save-info-button");
      this._saveInfoButton.click(() => this._handleSaveInfo());
      this._updateVerfuegbarkeitshinweis();
      this._nbUpdateFortschritt();
    }
    // Relaunch: Fortschritt + Rabatt-Hinweis in der Preisleiste. Der Rabatt
    // (5 bis 20 %) haengt an der Artikelzahl im Warenkorb (ab 5, 10, 13, 21
    // Artikeln, Palette zaehlt mit) und wurde frueher nirgends vorab
    // kommuniziert, der Kunde sah den Preissprung erst beim Vollwerden.
    // "N von M" ergibt nur bei Slot-Paletten Sinn; Raster-Paletten (Highlighter/
    // Face) bekommen den qualitativen Hinweis. Die Zeile ist immer im DOM
    // (byop.liquid), damit die Leistenhoehe stabil bleibt; bei ausverkauften/
    // vorbestellbaren Farben blendet CSS sie zugunsten der Warnung aus.
    _nbUpdateFortschritt() {
      const zeile = this._element.find(".nb-progress");
      if (!zeile.length) {
        return;
      }
      try {
        const modell = this.viewModel && this.viewModel.palette;
        const basis = modell && modell.palette;
        // Die Fuellstand-Klasse VOR dem fruehen Ausstieg setzen. Sonst behielt
        // sie in Zwischenzustaenden (etwa mitten im Groessenwechsel, wenn kurz
        // keine Basis-Palette haengt) ihren alten Wert, und fuer einen Moment
        // war der falsche Knopf limegruen gefuellt.
        if (modell) {
          this._nbFuellstandKlasse(modell);
        }
        if (!modell || !basis) {
          return;
        }
        const stufe = Math.round((modell.maxDiscountEligibility || 0) * 100);
        let text = "";
        let teilA = "";
        let teilB = "";
        let aktiv = false;
        // Der Rabatt haengt an der Artikelzahl (siehe discountPercentage), also
        // kann er schon vor der vollen Palette gelten, und die naechste Stufe
        // liegt oft nur wenige Farben entfernt. Die Zeile nennt deshalb immer
        // die NAECHSTE erreichbare Stufe statt pauschal den Hoechstrabatt.
        const gesamt = basis.hasSlots ? basis.rows * basis.columns : 0;
        const gefuellt = basis.hasSlots ? Math.min(modell.pans.length, gesamt) : 0;
        // null, wenn die naechste Stufe in dieser Palette nicht mehr erreichbar ist
        const naechste = modell.nbErreichbareRabattstufe || null;
        const gespart = (modell.originalPrice || 0) - (modell.price || 0);
        const rabattAktiv = (modell.discountPercentage || 0) > 0 && gespart > 0;
        if (modell.isComplete || (rabattAktiv && !naechste)) {
          // Vorher stand hier "−5 % freigeschaltet". Genau das sagt eine Zeile
          // tiefer schon die Blase am Preis. Die Zeile muss aus Hoehengruenden
          // ohnehin im DOM bleiben, also traegt sie jetzt, was die Blase NICHT
          // sagt: den gesparten Betrag in Euro.
          text = gespart > 0
            ? T(txt("relaunchProgressSaved", "You save {amount}"), { amount: formatPrice(gespart) })
            : (modell.discountPercentage > 0
              ? T(txt("relaunchProgressDiscountActive", "−{percent}% unlocked"), { percent: Math.round(modell.discountPercentage * 100) })
              // Volle Palette mit weniger als 5 Artikeln (grosse Pfaennchen):
              // kein Rabatt, die Zeile soll trotzdem nicht leer stehen.
              : T(txt("relaunchDrawerProgressFree", "{filled} shades chosen"), { filled: modell.pans.length }));
          aktiv = gespart > 0 || modell.discountPercentage > 0;
        } else if (naechste) {
          // Zweigeteilt, weil auf dem Handy nur der zweite Teil stehen bleibt:
          // "3 von 12 gefuellt" wiederholte nur, was schon auf dem Knopf steht
          // ("Farben waehlen · 3/12"). Der Rest-bis-Rabatt-Teil ist der einzige
          // mit Zusatznutzen. CSS blendet .nb-gefuellt unter 700 px aus.
          // Gilt schon ein Rabatt, steht vorn die Ersparnis statt des Zaehlers.
          // Paletten ohne Platzraster (24er) haben keinen Zaehler, dort bleibt
          // der vordere Teil ohne Rabatt leer.
          teilA = rabattAktiv
            ? T(txt("relaunchProgressSaved", "You save {amount}"), { amount: formatPrice(gespart) }) + " · "
            : (basis.hasSlots
              ? T(txt("relaunchProgressFilled", "{filled} of {total} filled"), { filled: gefuellt, total: gesamt }) + " · "
              : "");
          teilB = T(txt("relaunchProgressToDiscount", "{count} more to −{percent}%"), { count: naechste.fehlen, percent: Math.round(naechste.anteil * 100) });
          aktiv = rabattAktiv;
        } else if (basis.hasSlots) {
          text = T(txt("relaunchProgressFilled", "{filled} of {total} filled"), { filled: gefuellt, total: gesamt });
        } else {
          text = T(txt("relaunchProgressFillHint", "A full palette saves up to −{percent}%"), { percent: stufe });
        }
        if (teilB) {
          zeile.empty()
            .append($('<span class="nb-gefuellt"></span>').text(teilA))
            .append($('<span class="nb-rest"></span>').text(teilB));
        } else {
          zeile.text(text);
        }
        zeile.toggleClass("nb-active", aktiv);
        this._nbFuellstandKlasse(modell);
      } catch (e) { /* Anzeige-Detail, darf die Preisleiste nie brechen */ }
    }
    // Relaunch (01.09.): Auf dem Handy trug alles gleichzeitig Limegruen --
    // Groessenpille, Ziel-Napf, Katalog-Lasche, "Farben waehlen" UND der
    // Kaufknopf. Wo alles betont ist, fuehrt nichts. Diese Klasse sagt dem
    // CSS, welche Handlung gerade die naechste ist: bei leerer Palette
    // "Farben waehlen", ab der ersten Farbe der Warenkorb. Nur die traegt
    // dann die Vollflaeche. Ausschliesslich Optik, keine Funktionsaenderung.
    _nbFuellstandKlasse(modell) {
      try {
        const wurzel = document.querySelector(".page-palette-designer");
        if (!wurzel) {
          return;
        }
        const leer = !modell.pans.length;
        const warLeer = wurzel.classList.contains("nb-leer");
        wurzel.classList.toggle("nb-leer", leer);
        // Der Moment, in dem der Kaufknopf die Fuehrung uebernimmt, bekommt
        // einen kurzen Impuls -- sonst wechselt die Flaeche unbemerkt.
        if (warLeer && !leer) {
          const knopf = this._element.find("button.add-to-cart");
          knopf.addClass("nb-uebernimmt");
          setTimeout(() => knopf.removeClass("nb-uebernimmt"), 300);
        }
      } catch (e) { /* reine Optik */ }
    }
    // Markiert den Warenkorb-Bereich, solange die Palette ausverkaufte oder
    // vorbestellbare Farben enthaelt. Bisher erfuhr der Kunde davon erst nach dem
    // Klick durch das Hinweisfenster. Ausverkauft hat Vorrang, weil es den Kauf
    // wirklich verhindert -- Vorbestellung ist nur ein spaeterer Versand.
    _updateVerfuegbarkeitshinweis() {
      const palette = this.viewModel && this.viewModel.palette;
      if (!palette || typeof palette.availabilityHinweis === "undefined") {
        return;
      }
      const hinweis = palette.availabilityHinweis;
      const hatAusverkauft = hinweis.ausverkauft.length > 0;
      const hatVorbestellung = !hatAusverkauft && hinweis.vorbestellung.length > 0;
      this._element.toggleClass("has-sold-out", hatAusverkauft);
      this._element.toggleClass("has-preorder", hatVorbestellung);
      let notiz = this._element.find(".availability-note");
      if (!hatAusverkauft && !hatVorbestellung) {
        notiz.remove();
        return;
      }
      if (notiz.length === 0) {
        // Vor den Button haengen, damit die Notiz in der Zeile links davon steht
        // und den Button nicht verschiebt.
        notiz = $('<span class="availability-note"></span>');
        this._addToCartButton.before(notiz);
      }
      const text = hatAusverkauft
        ? txt("availabilityCartNoteSoldOut", "Contains sold out shades")
        : txt("availabilityCartNotePreorder", "Contains preorders");
      const anzahl = hatAusverkauft ? hinweis.ausverkauft.length : hinweis.vorbestellung.length;
      notiz.text(`${text} (${anzahl})`);
    }
    handlePropertyChanged(property) {
      if (property === "palette.price") {
        this._update();
      } else if (property === "palette.pans" || property === "palette.pans[]" || property === "palette.palette") {
        // Der Preis aendert sich nicht zwingend mit (Tausch gleich teurer Farben),
        // die Verfuegbarkeit schon. "palette.palette" ist der Name, unter dem das
        // PaletteViewModel einen Wechsel der Basis-Palette weitergibt.
        this._updateVerfuegbarkeitshinweis();
        this._nbUpdateFortschritt();
      }
    }
  };

  // models/user.js - mostly legacy from WooCommerce
  var User = class _User {
    static get current() {
      if (!_User._current) {
        _User._current = new _User();
      }
      return _User._current;
    }
    static login() {
      window.location.href = "/apps/deluxe/account/login";
    }
    static signup() {
      window.location.href = "/apps/deluxe/account/login";
    }
    constructor() {
      this._isLoggedIn = !!window.inlineData.User.isLoggedIn;
      this._myAccount = null;
    }
    async update() {
      if (this._myAccount !== null) {
        return;
      }
      const result = await ApiClient.makeRequest("user", "getMyAccount", {});
      if (result && result.html) {
        this._myAccount = result.html;
      }
    }
    get myAccount() {
      return this._myAccount;
    }
    async getOrderHistory() {
      const result = await ApiClient.makeRequest("user", "getOrderHistory", {});
      return result.html;
    }
    get isLoggedIn() {
      return this._isLoggedIn;
    }
    async logout() {
      const result = await ApiClient.makeRequest("user", "logout", {});
      window.location.href = window.inlineData.Permalinks.loginUri + "?return=" + encodeURIComponent("/");
    }
  };

  // palette-designer/views/save-view.js
  var SaveView = class extends View {
    constructor(element, viewModel, userViewModel) {
      super(viewModel);
      this._element = element;
      this._element.click(async () => {
        if (!User.current.isLoggedIn) {
          // T() uebersetzt nicht (siehe Kommentar an der Funktion) -- dieser
          // Dialog war deshalb auch im deutschen und franzoesischen Shop
          // englisch. Jetzt ueber staticText/locales wie die anderen Fenster.
          const modalWindow = new ModalWindow2(
            "50em",
            "auto",
            {
              headline: txt("relaunchLoginHeadline", "Log-in to see your saved palettes"),
              closeButton: true,
              buttons: [
                {
                  caption: txt("cancelButton", "Cancel"),
                  borderless: true,
                  data: "cancel"
                },
                {
                  caption: txt("relaunchLoginSignup", "Sign-up"),
                  hollow: true,
                  data: "signup"
                },
                {
                  caption: txt("relaunchLoginLogin", "Log-in"),
                  data: "login"
                }
              ]
            }
          );
          modalWindow.append(txt("relaunchLoginMessage", "Log into an existing account or create a new one to never lose your most precious creations."));
          const result = await modalWindow.show();
          if (result === "login") {
            User.login();
          } else if (result === "signup") {
            User.signup();
          }
          modalWindow.remove();
        } else {
          userViewModel.isVisible = true;
        }
      });
      this._update();
    }
    handlePropertyChanged(property) {
      if (property === "isSaving" || property === "isSaved") {
        this._update();
      }
    }
    _update() {
      if (this._viewModel.isSaving) {
        this._savingStart = (/* @__PURE__ */ new Date()).getTime();
        this._element.addClass("saving").removeClass("not-saved");
      } else {
        if (!this._viewModel.isSaved) {
          this._element.addClass("not-saved");
        }
        const delta = (/* @__PURE__ */ new Date()).getTime() - this._savingStart;
        window.setTimeout(() => {
          this._element.removeClass("saving");
        }, Math.max(1, 300 - delta));
      }
    }
  };

  // palette-designer/views/info-view.js
  var InfoView = class extends View {
    constructor(element, viewModel) {
      super(viewModel);
      this._element = element;
      this._isSuspended = false;
      Broadcast.receive("suspendProductInfo", () => {
        this._isSuspended = true;
        this._element.removeClass("visible");
      });
      Broadcast.receive("resumeProductInfo", () => this._isSuspended = false);
      Broadcast.receive("activePanChanged", () => this.close());
      $(document).on("mousemove", (e) => {
        this._mouseX = e.pageX;
        this._mouseY = e.pageY;
      });
      $(document).on("mousewheel", (e) => {
        this.close();
      });
    }
    close() {
      this._element.removeClass("visible");
    }
    handlePropertyChanged(property) {
      if (property === "product") {
        this._update();
      }
    }
    _findTarget() {
      const hoverElements = $(".draggable:hover");
      if (hoverElements.length > 0) {
        return hoverElements.first();
      }
      return null;
    }
    _inRect(container, contained) {
      return contained.x >= container.x && contained.y >= container.y && contained.right <= container.right && contained.bottom <= container.bottom;
    }
    _positionElement() {
      const element = this._element;
      const target = this._findTarget();
      let position = { x: this._mouseX || 0, y: this._mouseY || 0 };
      let targetRect = null;
      if (target) {
        targetRect = target.get(0).getBoundingClientRect();
        position.x = targetRect.x + 0.5 * targetRect.width;
        position.y = targetRect.y + 0.5 * targetRect.height;
      }
      const viewportRect = {
        x: 0,
        y: 0,
        right: $(window).width(),
        bottom: $(window).height()
      };
      const elementRect = element.get(0).getBoundingClientRect();
      const candidateRects = [
        ["bottom", {
          x: position.x - 0.5 * elementRect.width,
          y: position.y + (targetRect ? 0.5 * targetRect.height : 0),
          right: position.x + 0.5 * elementRect.width,
          bottom: position.y + (targetRect ? 0.5 * targetRect.height : 0) + elementRect.height
        }],
        ["top", {
          x: position.x - 0.5 * elementRect.width,
          y: position.y - (targetRect ? 0.5 * targetRect.height : 0) - elementRect.height,
          right: position.x + 0.5 * elementRect.width,
          bottom: position.y - (targetRect ? 0.5 * targetRect.height : 0)
        }],
        ["left", {
          x: position.x - (targetRect ? 0.5 * targetRect.width : 0) - elementRect.width,
          y: position.y - 0.5 * elementRect.height,
          right: position.x - (targetRect ? 0.5 * targetRect.width : 0),
          bottom: position.y + 0.5 * elementRect.height
        }],
        ["right", {
          x: position.x + (targetRect ? 0.5 * targetRect.width : 0),
          y: position.y - 0.5 * elementRect.height,
          right: position.x + (targetRect ? 0.5 * targetRect.width : 0) + elementRect.width,
          bottom: position.y + 0.5 * elementRect.height
        }]
      ];
      let rect = null;
      let anchor = "bottom";
      for (let candidate of candidateRects) {
        if (this._inRect(viewportRect, candidate[1])) {
          anchor = candidate[0];
          rect = candidate[1];
          break;
        }
      }
      element.removeClass("bottom").removeClass("top").removeClass("left").removeClass("right");
      element.addClass(anchor);
      position.x = rect.x;
      position.y = rect.y;
      const parentRect = element.parent().get(0).getBoundingClientRect();
      position.x -= parentRect.x;
      position.y -= parentRect.y;
      element.css("left", `${position.x}px`);
      element.css("top", `${position.y}px`);
    }
    _update() {
      if (this._isSuspended) {
        return;
      }
      const product = this._viewModel.product;
      if (!product) {
        this.close();
        return;
      }
      const element = this._element;
      element.find(".product-line").text(product.productLine);
      element.find("h2").text(product.name);
      element.find(".description").text(product.description);
      element.find(".price .current").text(formatPrice(product.price));
      if (product.isOnSale) {
        element.find(".price .original").show().text(formatPrice(product.originalPrice));
      } else {
        element.find(".price .original").hide();
      }
      this._positionElement();
      element.addClass("visible");
    }
  };

  // palette-designer/controls/slider.js
  var Slider = class {
    constructor(element) {
      this.element = element;
      this._minimum = 0;
      this._maximum = 100;
      this._value = 50;
      this._step = 0;
      this.changedHandlers = [];
      this.changingHandlers = [];
      element.append(`
            <div class="bar">
            </div>
            <div class="handle"><span></span></div>
        `);
      this.handle = element.find(".handle");
      this.bar = element.find(".bar");
      this.handle.on("mousedown", (e) => this.handleDragStart(e));
      this.handle.on("touchstart", (e) => this.handleDragStart(e));
      $(document).on("mousemove", (e) => this.handleDragMove(e));
      $(document).on("touchmove", (e) => this.handleDragMove(e));
      $(document).on("mouseup", (e) => this.handleDragRelease(e));
      $(document).on("touchend", (e) => this.handleDragRelease(e));
      this.update();
    }
    get minimum() {
      return this._minimum;
    }
    set minimum(value) {
      this._minimum = value;
      this.update();
    }
    get step() {
      return this._step;
    }
    set step(value) {
      this._step = value;
      this.update();
    }
    get maximum() {
      return this._maximum;
    }
    set maximum(value) {
      this._maximum = value;
      this.update();
    }
    get value() {
      return this._value;
    }
    set value(value) {
      this._value = value;
      this.update();
      this.changedHandlers.forEach((handler) => handler());
    }
    update() {
      if (this._minimum > this._maximum) {
        const temp = this._minimum;
        this._minimum = this._maximum;
        this._maximum = temp;
      }
      this._step = Math.min(Math.max(0, this._step), this._maximum - this._minimum);
      this._value = Math.max(this._value, this._minimum);
      this._value = Math.min(this._value, this._maximum);
      if (this._step > 0) {
        this._value = Math.round(this._value / this._step) * this._step;
      }
      const size = this._maximum - this._minimum;
      const valuePercent = (this._value - this._minimum) / size;
      this.handle.css("left", `${valuePercent * 100}%`);
    }
    conformPointerEvent(e) {
      if (isNaN(parseInt(e.pageX)) && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches.length > 0) {
        e.pageX = e.originalEvent.changedTouches[0].pageX;
        e.pageY = e.originalEvent.changedTouches[0].pageY;
      }
      return e;
    }
    handleDragStart(e) {
      e = this.conformPointerEvent(e);
      this.startX = e.pageX;
      this.dragging = true;
      this.dragElement = $(e.target);
      if (this.dragElement.is("span")) {
        this.dragElement = this.dragElement.parent();
      }
      this.initialLeft = this.dragElement.position().left;
      this.maxLeft = this.element.width();
    }
    handleDragMove(e) {
      e = this.conformPointerEvent(e);
      if (!this.dragging) {
        return;
      }
      const delta = e.pageX - this.startX;
      let newLeft = this.initialLeft + delta;
      let percent = newLeft / this.maxLeft;
      if (percent < 0) {
        percent = 0;
      }
      if (percent > 1) {
        percent = 1;
      }
      let oldValue = this._value;
      this._value = this._minimum + percent * (this._maximum - this._minimum);
      this.update();
      if (this._value !== oldValue) {
        this.changingHandlers.forEach((handler) => handler());
      }
    }
    handleDragRelease(e) {
      if (this.dragging) {
        this.dragging = false;
        this.update();
        this.changedHandlers.forEach((handler) => handler());
      }
    }
    onChanged(handler) {
      this.changedHandlers.push(handler);
    }
    onChanging(handler) {
      this.changingHandlers.push(handler);
    }
  };

  // palette-designer/controls/range-slider.js
  var RangeSlider = class {
    constructor(element) {
      this.element = element;
      this._minimum = 0;
      this._maximum = 100;
      this._rangeStart = 25;
      this._rangeEnd = 75;
      this._step = 0;
      this.rangeChangedHandlers = [];
      this.rangeChangingHandlers = [];
      element.append(`
            <div class="bar">
                <div></div>
            </div>
            <div class="left"><span></span></div>
            <div class="right"><span></span></div>
        `);
      this.leftHandle = element.find(".left");
      this.rightHandle = element.find(".right");
      this.bar = element.find(".bar");
      this.rangeIndicator = this.bar.find("> div");
      this.leftHandle.on("mousedown", (e) => this.handleDragStart(e));
      this.rightHandle.on("mousedown", (e) => this.handleDragStart(e));
      this.leftHandle.on("touchstart", (e) => this.handleDragStart(e));
      this.rightHandle.on("touchstart", (e) => this.handleDragStart(e));
      $(document).on("mousemove", (e) => this.handleDragMove(e));
      $(document).on("touchmove", (e) => this.handleDragMove(e));
      $(document).on("mouseup", (e) => this.handleDragRelease(e));
      $(document).on("touchend", (e) => this.handleDragRelease(e));
      this.update();
    }
    get step() {
      return this._step;
    }
    set step(value) {
      this._step = value;
      this.update();
    }
    get minimum() {
      return this._minimum;
    }
    set minimum(value) {
      this._minimum = value;
      this.update();
    }
    get maximum() {
      return this._maximum;
    }
    set maximum(value) {
      this._maximum = value;
      this.update();
    }
    get rangeStart() {
      return this._rangeStart;
    }
    set rangeStart(value) {
      this._rangeStart = value;
      this.update();
    }
    get rangeEnd() {
      return this._rangeEnd;
    }
    set rangeEnd(value) {
      this._rangeEnd = value;
      this.update();
    }
    update() {
      if (this._minimum > this._maximum) {
        const temp = this._minimum;
        this._minimum = this._maximum;
        this._maximum = temp;
      }
      this._step = Math.min(Math.max(0, this._step), this._maximum - this._minimum);
      this._rangeStart = Math.max(this._rangeStart, this._minimum);
      this._rangeEnd = Math.max(this._rangeEnd, this._minimum);
      this._rangeStart = Math.min(this._rangeStart, this._maximum);
      this._rangeEnd = Math.min(this._rangeEnd, this._maximum);
      if (this._rangeStart > this._rangeEnd) {
        const temp = this._rangeStart;
        this._rangeStart = this._rangeEnd;
        this._rangeEnd = temp;
      }
      if (this._step > 0) {
        this._rangeStart = Math.round(this._rangeStart / this._step) * this._step;
        this._rangeEnd = Math.round(this._rangeEnd / this._step) * this._step;
      }
      const size = this._maximum - this._minimum;
      const rangeStartPercent = (this._rangeStart - this._minimum) / size;
      const rangeEndPercent = (this._rangeEnd - this._minimum) / size;
      this.leftHandle.css("left", `${rangeStartPercent * 100}%`);
      this.rightHandle.css("left", `${rangeEndPercent * 100}%`);
      this.rangeIndicator.css("margin-left", `${rangeStartPercent * 100}%`);
      this.rangeIndicator.css("width", `${(rangeEndPercent - rangeStartPercent) * 100}%`);
    }
    conformPointerEvent(e) {
      if (isNaN(parseInt(e.pageX)) && e.originalEvent && e.originalEvent.changedTouches && e.originalEvent.changedTouches.length > 0) {
        e.pageX = e.originalEvent.changedTouches[0].pageX;
        e.pageY = e.originalEvent.changedTouches[0].pageY;
      }
      return e;
    }
    handleDragStart(e) {
      e = this.conformPointerEvent(e);
      this.startX = e.pageX;
      this.dragging = true;
      this.dragElement = $(e.target);
      if (this.dragElement.is("span")) {
        this.dragElement = this.dragElement.parent();
      }
      this.initialLeft = this.dragElement.position().left;
      this.maxLeft = this.element.width();
    }
    handleDragMove(e) {
      e = this.conformPointerEvent(e);
      if (!this.dragging) {
        return;
      }
      const delta = e.pageX - this.startX;
      let newLeft = this.initialLeft + delta;
      let percent = newLeft / this.maxLeft;
      let leftPercent;
      let rightPercent;
      if (percent < 0) {
        percent = 0;
      }
      if (percent > 1) {
        percent = 1;
      }
      if (this.dragElement.hasClass("left")) {
        leftPercent = percent;
        rightPercent = this.rightHandle.position().left / this.maxLeft;
        if (leftPercent > rightPercent) {
          leftPercent = rightPercent;
        }
      } else {
        rightPercent = percent;
        leftPercent = this.leftHandle.position().left / this.maxLeft;
        if (rightPercent < leftPercent) {
          rightPercent = leftPercent;
        }
      }
      const oldRangeStart = this._rangeStart;
      const oldRangeEnd = this._rangeEnd;
      this._rangeStart = this._minimum + leftPercent * (this._maximum - this._minimum);
      this._rangeEnd = this._minimum + rightPercent * (this._maximum - this._minimum);
      this.update();
      if (oldRangeStart !== this._rangeStart || oldRangeEnd !== this._rangeEnd) {
        this.rangeChangingHandlers.forEach((handler) => handler());
      }
    }
    handleDragRelease(e) {
      if (this.dragging) {
        this.dragging = false;
        this.update();
        this.rangeChangedHandlers.forEach((handler) => handler());
      }
    }
    onRangeChanged(handler) {
      this.rangeChangedHandlers.push(handler);
    }
    onRangeChanging(handler) {
      this.rangeChangingHandlers.push(handler);
    }
  };

  // palette-designer/views/pal-view.js
  var PalSettings = [
    {
      title: T("Primary color"),
      fieldName: "primaryColor",
      minValue: 0,
      maxValue: 360,
      step: 1,
      valueNames: [
        T("Red"),
        T("Orange"),
        T("Yellow"),
        T("Light Green"),
        T("Green"),
        T("Aquamarine"),
        T("Blue"),
        T("Dark Blue"),
        T("Purple"),
        T("Pink"),
        T("Red")
      ],
      className: "color-picker",
      nullValueName: T("Automatic"),
      allowNull: true
    },
    {
      title: T("Primary color influence"),
      fieldName: "primaryColorInfluence",
      minValue: 0,
      maxValue: 1,
      step: 0.1,
      valueNames: ["0%", "10%", "20%", "30%", "40%", "50%", "60%", "70%", "80%", "90%", "100%"],
      childToPrevious: true
    },
    {
      title: T("Secondary color"),
      fieldName: "secondaryColor",
      minValue: 0,
      maxValue: 360,
      step: 1,
      valueNames: [
        T("Red"),
        T("Orange"),
        T("Yellow"),
        T("Light Green"),
        T("Green"),
        T("Aquamarine"),
        T("Blue"),
        T("Dark Blue"),
        T("Purple"),
        T("Pink"),
        T("Red")
      ],
      className: "color-picker",
      nullValueName: T("Automatic"),
      allowNull: true
    },
    {
      title: T("Secondary color influence"),
      fieldName: "secondaryColorInfluence",
      minValue: 0,
      maxValue: 1,
      step: 0.1,
      valueNames: ["0%", "10%", "20%", "30%", "40%", "50%", "60%", "70%", "80%", "90%", "100%"],
      childToPrevious: true
    },
    {
      title: T("Brightness range"),
      rangeStartFieldName: "minLightness",
      rangeEndFieldName: "maxLightness",
      minValue: 0,
      maxValue: 1,
      step: 0.1,
      valueNames: ["0%", "10%", "20%", "30%", "40%", "50%", "60%", "70%", "80%", "90%", "100%"]
    },
    {
      title: T("Metallic shades"),
      fieldName: "metallicsPercent",
      minValue: 0,
      maxValue: 1,
      step: 0.25,
      valueNames: [
        T("Few"),
        T("Some"),
        T("Balanced"),
        T("More"),
        T("Many")
      ]
    },
    {
      title: T("Variation"),
      fieldName: "variation",
      minValue: 0,
      maxValue: 4,
      step: 1,
      valueNames: ["#1", "#2", "#3", "#4", "#5"]
    }
  ];
  var PalView = class extends View {
    constructor(element, viewModel) {
      super(viewModel);
      this._element = element;
      this._intialize(element.find("> .pane"));
    }
    handlePropertyChanged(property) {
      if (property === "variation") {
        const sliderElement = this._element.find(".setting").filter((index, element) => $(element).data("setting").fieldName === "variation").first();
        sliderElement.data("slider").value = this.viewModel.variation;
      } else if (property === "visible") {
        this._element.toggleClass("visible", this.viewModel.visible);
        $(".palette-designer-body main").toggleClass("pal-mode", this.viewModel.visible);
        if (this.viewModel.visible) {
          this._element.find(".collapse-button").text(T("More options"));
        }
      }
    }
    _intialize(element) {
      let previous;
      let previousDefaultValue = null;
      for (let setting of PalSettings) {
        const html = $(`
            <div class="setting space-below" data-setting="${setting.fieldName}">
                <h4>${setting.title} <span class="value"></span><span class="nullify"><span>Auto</span> <button><span></span></button></span></h4>
                <div class="${setting.rangeStartFieldName ? "range-" : ""}slider ${setting.className ?? ""}">
                </div>
                <div class="range">
                    <span>${setting.valueNames[0]}</span>
                    <span>${setting.valueNames[setting.valueNames.length - 1]}</span>
                </div>
            </div>`);
        element.find(".settings > div").append(html);
        html.data("setting", setting);
        let slider;
        let isRangeSlider = false;
        let defaultValue = null;
        if (setting.rangeStartFieldName) {
          slider = new RangeSlider(html.find(".range-slider"));
          slider.step = setting.step;
          slider.maximum = setting.maxValue;
          slider.minimum = setting.minValue;
          slider.rangeStart = this.viewModel[setting.rangeStartFieldName];
          slider.rangeEnd = this.viewModel[setting.rangeEndFieldName];
          isRangeSlider = true;
        } else {
          defaultValue = this.viewModel[setting.fieldName];
          slider = new Slider(html.find(".slider"));
          slider.step = setting.step;
          slider.maximum = setting.maxValue;
          slider.minimum = setting.minValue;
          slider.value = defaultValue === null ? setting.minValue : defaultValue;
        }
        if (setting.allowNull) {
          html.addClass("nullable");
          if (defaultValue !== null) {
            html.addClass("active");
            html.find(".nullify > span:first-child").text(T("Manual"));
          }
        }
        if (setting.className === "color-picker") {
          html.find(".range").css("display", "none");
        }
        if (setting.childToPrevious) {
          html.find("h4").remove();
          html.addClass("child-to-previous");
          html.prev().removeClass("space-below");
          if (previous && previous.allowNull) {
            html.addClass("nullable");
            if (previousDefaultValue !== null) {
              html.addClass("active");
            }
          }
        }
        html.data("slider", slider);
        html.find("h4 button").on("click", () => {
          if (html.hasClass("active")) {
            slider.value = slider.minimum;
            html.removeClass("active");
            if (html.next().hasClass("child-to-previous")) {
              html.next().removeClass("active");
            }
            this._handleSettingChanged(setting, null);
          } else {
            html.addClass("active");
            if (html.next().hasClass("child-to-previous")) {
              html.next().addClass("active");
            }
          }
          html.find(".nullify > span:first-child").text(
            html.hasClass("active") ? T("Manual") : "Auto"
          );
          updateValueText();
        });
        const updateValueText = () => {
          if (isRangeSlider) {
            const startIndex = Math.trunc((slider.rangeStart - slider.minimum) / (slider.maximum - slider.minimum) * (setting.valueNames.length - 1));
            const endIndex = Math.trunc((slider.rangeEnd - slider.minimum) / (slider.maximum - slider.minimum) * (setting.valueNames.length - 1));
            html.find("h4 span.value").text(setting.valueNames[startIndex] + " - " + setting.valueNames[endIndex]);
          } else {
            if (setting.allowNull && !html.hasClass("active")) {
              html.find("h4 span.value").text(setting.nullValueName);
            } else {
              const index = Math.trunc((slider.value - slider.minimum) / (slider.maximum - slider.minimum) * (setting.valueNames.length - 1));
              html.find("h4 span.value").text(setting.valueNames[index]);
            }
          }
        };
        const changingCallback = () => {
          updateValueText();
          if (setting.allowNull) {
            html.addClass("active");
            html.find(".nullify > span:first-child").text(T("Manual"));
          }
          if (isRangeSlider) {
            this._handleSettingChanged(setting, slider.rangeStart, slider.rangeEnd);
          } else {
            this._handleSettingChanged(setting, slider.value);
          }
        };
        const handleChangeStart = () => {
          html.addClass("manipulated");
          this._element.addClass("ghost-mode");
        };
        const handleChangeEnd = () => {
          this._element.removeClass("ghost-mode");
        };
        if (!isRangeSlider) {
          slider.onChanging(changingCallback);
          slider.onChanged(changingCallback);
          slider.onChanging(handleChangeStart);
          slider.onChanged(handleChangeEnd);
        } else {
          slider.onRangeChanging(changingCallback);
          slider.onRangeChanged(changingCallback);
          slider.onRangeChanging(handleChangeStart);
          slider.onRangeChanged(handleChangeEnd);
        }
        updateValueText();
        previous = setting;
        previousDefaultValue = defaultValue;
      }
      element.find(".actions > button:not(.hollow)").on("click", () => {
        this.viewModel.accept();
      });
      element.find(".actions > button.hollow").on("click", () => {
        this.viewModel.hide();
      });
      element.find(".actions .refresh-button").on("click", () => {
        this.viewModel.refresh();
      });
    }
    _handleSettingChanged(setting, value, secondary = null) {
      if (setting.fieldName) {
        this.viewModel[setting.fieldName] = value;
      } else {
        this.viewModel[setting.rangeStartFieldName] = value;
        this.viewModel[setting.rangeEndFieldName] = secondary;
      }
    }
  };

  // palette-designer/palette-designer.js
  var PaletteDesigner = class {
    constructor() {
      const queryString = this._parseQueryString();
      const serviceModel = new ServiceModel();
      const productsModel = new ProductsModel(
        window.inlineData.PaletteDesigner.products,
        window.inlineData.PaletteDesigner.categories
      );
      const userModel = new UserModel(serviceModel);
      const paletteModel = new CustomPaletteModel(
        productsModel.defaultPalette,
        productsModel,
        serviceModel,
        userModel
      );
      const palModel = new PalModel(paletteModel, productsModel);
      if (queryString.hasOwnProperty("pd")) {
        paletteModel.unserialize(parsePaletteString(queryString.pd));
        if (window.inlineData.PaletteDesigner.recoverId) {
          paletteModel.id = window.inlineData.PaletteDesigner.recoverId;
        }
      } else if (queryString.hasOwnProperty("p")) {
        paletteModel.unserialize(parseLegacyPaletteString(queryString.p, productsModel));
      } else if (userModel.lastSavedPalette) {
        paletteModel.loadSavedPalette(userModel.lastSavedPalette);
      }
      // Farb-Rangfolge fuer die "Nach Farbe"-Sortierung einmalig berechnen
      // (siehe nbFarbRaengeBerechnen am Dateiende). Muss VOR dem ersten
      // Katalog-Aufbau stehen, weil "Nach Farbe" jetzt Standard ist.
      try { nbFarbRaengeBerechnen(productsModel); } catch (e) { /* dann sortiert der Rueckfall (1e9) stabil ans Ende */ }
      // Fuer nbRelaunchInit (Ende der Datei): die Models lagen bisher nur als
      // lokale const vor und waren von aussen unerreichbar. Rein additiv.
      this.productsModel = productsModel;
      this.paletteModel = paletteModel;
      this.userModel = userModel;
      this.paletteViewModel = new PaletteViewModel(paletteModel);
      this.productsViewModel = new ProductsViewModel(productsModel, paletteModel);
      this.userViewModel = new UserViewModel(userModel, paletteModel);
      this.palViewModel = new PalViewModel(palModel, paletteModel);
      this.newPaletteViewModel = new NewPaletteViewModel(
        paletteModel,
        productsModel,
        this.productsViewModel,
        this.palViewModel
      );
      this.userView = new UserView($(".user-overlay"), this.userViewModel);
      this.paletteView = new PaletteView($(".preview"), this.paletteViewModel);
      this.productsView = new ProductsView($(".menu"), this.productsViewModel);
      this.designerView = new DesignerView(
        $("#palette-designer-nh"),
        this.paletteViewModel,
        this.paletteView,
        this.userViewModel,
        this.newPaletteViewModel
      );
      this.priceView = new PriceAndCartView($(".price-and-cart"), this.paletteViewModel);
      this.saveView = new SaveView($(".save"), this.paletteViewModel, this.userViewModel);
      this.infoView = new InfoView($(".info-overlay"), new InfoViewModel());
      this.palView = new PalView($(".pal-overlay"), this.palViewModel);
      // Der fruehere ?intro=-Block stand hier und war tot: er rief ModalWindow
      // (ohne 2) und t() auf -- beide existieren im Bundle nicht, jeder Aufruf
      // endete als ReferenceError im setTimeout. Ersetzt durch den echten
      // Erststart in nbRelaunchInit (Ende der Datei).
    }
    _parseQueryString() {
      let queryString = window.location.search;
      if (queryString.startsWith("?")) {
        queryString = queryString.substr(1);
      }
      const queryParts = queryString.split(/&/g);
      const parsed = {};
      for (const part of queryParts) {
        const keyValue = part.split("=");
        parsed[keyValue[0]] = keyValue[1] || null;
      }
      return parsed;
    }
  };
  // ===========================================================================
  // Konfigurator-Relaunch (nbRelaunch)
  // ===========================================================================
  // Vier Massnahmen aus dem Check-in vom 06.08.2026, research-geprueft:
  //   1. Groessenleiste ueber der Palette (die Groesse war eine Katalog-Kategorie
  //      hinter einer 36-px-Lasche) inkl. Verlust-Rueckfrage beim Verkleinern.
  //   2. Gestalteter Erststart: Groessenwahl als erste, dominante Entscheidung
  //      fuer echte Erstbesucher -- KEIN Tutorial-Overlay (NN/g: Push-Touren
  //      verbessern die Task-Performance nicht). ?onboarding=1 erzwingt die
  //      Anzeige fuer Demo und Test.
  //   3. "?"-Hilfe: die Touch-Gesten (Tippen/Ziehen/Halten) waren nirgends
  //      entdeckbar, seit das Freshworks-Widget auf dieser Seite aus ist.
  //   4. Tap-Feedback: Toast (nur die ersten zwei Adds) + Kachel-Puls +
  //      Coach-Mark im Katalog, der beim ersten erfolgreichen Add verschwindet.
  // Alle Texte laufen ueber txt()/staticText (T() uebersetzt NICHT).

  // Messereignisse fuer Hotjar-Filter und (spaeter) ein GA4-Tag im Tag
  // Manager. Funktions-Deklaration (gehoisted) wie nbConfirmPaletteSwitch,
  // weil Klassen weiter oben in der Datei (CustomPaletteModel,
  // ProductsViewModel, Cart) sie schon brauchen, bevor dieser Abschnitt
  // ueberhaupt laeuft, ihre Methoden werden erst durch Kundeninteraktion
  // aufgerufen, also lange nachdem die Datei einmal komplett ausgewertet
  // wurde. Jeder der drei Wege einzeln in try/catch und nur, wenn das
  // jeweilige Objekt existiert: ein kaputtes oder fehlendes Analytics-Skript
  // darf den Konfigurator nie bremsen oder den Kaufweg stoppen. Nur Zahlen
  // und feste Kennungen in "daten", nie Farbnamen oder andere
  // personenbezogene Daten.
  function nbMessen(name, daten) {
    try {
      if (typeof window.hj === "function") {
        window.hj("event", name);
      }
    } catch (e) { /* Hotjar darf das Messen nie blockieren */ }
    try {
      if (!Array.isArray(window.dataLayer)) {
        window.dataLayer = [];
      }
      window.dataLayer.push(Object.assign({ event: name }, daten || {}));
    } catch (e) { /* dataLayer darf das Messen nie blockieren */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish(name, daten || {});
      }
    } catch (e) { /* Shopify-Analytics darf das Messen nie blockieren */ }
  }

  // Die Zahl, die auf der Groessenpille steht (siehe nbNapfzahl weiter unten
  // in nbRelaunchInit, gleiche Formel). Eigenstaendig hoisted, weil
  // Messstellen ausserhalb dieses Closures liegen (Cart, ProductsViewModel).
  function nbMessGroesse(palette) {
    try {
      return palette && palette.hasSlots
        ? palette.rows * palette.columns
        : Math.round(palette.eyeshadowEquivalentCapacity);
    } catch (e) {
      return 0;
    }
  }

  // Nur einmal je Seitenaufruf: das erste erfolgreiche Setzen einer Farbe
  // durch den Kunden selbst (nicht das Laden einer gespeicherten oder
  // geteilten Palette, siehe CustomPaletteModel.add).
  let nbErsteFarbeGefeuert = false;

  // Rueckfrage vor einem Groessenwechsel, der Farben verwerfen wuerde.
  // Funktions-Deklaration (gehoisted), weil der Setter selectedPalette weiter
  // oben in der Datei sie referenziert.
  async function nbConfirmPaletteSwitch(viewModel, zielPalette, verlust) {
    // Nur EIN Verlust-Dialog gleichzeitig: der Modal-Overlay blockt zwar Taps,
    // aber der angeklickte Chip behaelt den Tastatur-Fokus -- Enter wuerde
    // sonst einen zweiten Dialog oeffnen und den Wechsel doppelt anstossen.
    if (viewModel._nbSwitchDialogOffen) {
      return;
    }
    viewModel._nbSwitchDialogOffen = true;
    try { nbMessen("byop_groessenwechsel_rueckfrage", { verlust }); } catch (e) { /* messen darf nie blockieren */ }
    let bestaetigt = true;
    try {
      const modal = new ModalWindow2("36em", "auto", {
        headline: txt("relaunchSwitchLossHeadline", "Switch size?"),
        closeButton: true,
        buttons: [
          { caption: txt("cancelButton", "Cancel"), hollow: true, data: false },
          { caption: txt("relaunchSwitchLossConfirm", "Switch size"), data: true }
        ]
      });
      // Seit dem Zwischenspeicher gehen die Farben nicht mehr verloren, der
      // Text beruhigt statt zu warnen (Geschaeftsfuehrung, 04.09.2026). Eigene
      // Einzahl-Fassung, weil "1 deiner Farben passen nicht" falsch waere.
      modal.append(T(
        verlust === 1
          ? txt("relaunchSwitchLossMessageOne", "One of your shades doesn't fit into {palette}. We keep it for you: switch back to a larger palette and it returns.")
          : txt("relaunchSwitchLossMessage", "{count} of your shades don't fit into {palette}. We keep them for you: switch back to a larger palette and they return."),
        { count: verlust, palette: zielPalette.name }
      ));
      bestaetigt = (await modal.show()) === true;
      modal.remove();
    } catch (e) {
      // Dialog kaputt -> altes Verhalten (wechseln ohne Rueckfrage), der
      // Undo-Eintrag aus _switchPalette bleibt als Netz.
      bestaetigt = true;
    } finally {
      viewModel._nbSwitchDialogOffen = false;
    }
    try { nbMessen(bestaetigt ? "byop_groessenwechsel_bestaetigt" : "byop_groessenwechsel_abgebrochen", {}); } catch (e) { /* messen darf nie blockieren */ }
    if (bestaetigt) {
      viewModel._nbApplySelectedPalette(zielPalette);
      // Kam der Wechsel aus dem Katalog, blieb der Drawer wegen der Rueckfrage
      // bewusst offen -- nach Bestaetigung wie beim direkten Wechsel zuklappen.
      try {
        nbApp.productsView.collapseDrawer();
      } catch (e) { /* Sidebar-Modus kennt kein Zuklappen */ }
    }
  }

  function nbRelaunchInit(app) {
    // ---- Datenbasis: die Groessen aus der gepflegten "Palettes"-Kategorie ----
    // Bewusst ueber den Kategorie-Filter aus byop-products.liquid (schliesst
    // Colossal aus) und NICHT ueber die ViewModel-Suche (die wuerde die Leiste
    // leeren, sobald jemand ins Suchfeld tippt). Sortierung wie im Katalog:
    // Kapazitaet aufsteigend.
    // Die Zahl, die der Kunde als "Naepfe" versteht. NICHT ueberall
    // rows * columns: hasSlots ist gridWidth === slotWidth && gridHeight ===
    // slotHeight -- nur dann beschreibt rows * columns wirklich Naepfe. Bei
    // Raster-Paletten wie Lethal-24 beschreibt es das RASTER, dort ist
    // eyeshadowEquivalentCapacity die gemeinte Zahl. Pauschal rows * columns
    // ergaebe auf der Lethal-24-Pille eine falsche Zahl.
    function nbNapfzahl(p) {
      try {
        return p.hasSlots ? p.rows * p.columns : Math.round(p.eyeshadowEquivalentCapacity);
      } catch (e) {
        return 0;
      }
    }
    // Die Pille am Handy zeigt fuer JEDE Groesse die Zahl plus Einheit, auch
    // fuer die 24er (deren Zahl kommt dann aus der Kapazitaet). Die Karte im
    // Erststart-Fenster und die Pille am Laptop zeigten dagegen den
    // Produktnamen, sobald kein Platzraster hinterlegt ist. In derselben Reihe
    // stand dadurch "3 Pfaennchen, 4 Pfaennchen, 6, 9, 12" und dann
    // "Lethal-24". Beides benutzt jetzt dieselbe Zahl; der Produktname bleibt
    // nur als Notnagel, falls sich gar keine Zahl ermitteln laesst.
    function nbGroessenTitel(p) {
      const anzahl = nbNapfzahl(p);
      return anzahl > 0
        ? T(txt("relaunchSizePans", "{count} pans"), { count: anzahl })
        : p.name;
    }
    function nbGroessen() {
      try {
        const kategorie = app.productsModel.categories && app.productsModel.categories[0];
        if (!kategorie || typeof kategorie.filter !== "function") {
          return [];
        }
        return app.productsModel.productsForCategory(kategorie)
          .filter((p) => p instanceof PaletteModel)
          // Sortiert nach der ZAHL, die auf der Pille steht. Nach
          // eyeshadowEquivalentCapacity allein stand eine Palette mit drei
          // GROSSEN Naepfen hinter der mit neun kleinen (sie fasst mehr).
          // Solange "3 Naepfe" danebenstand, fiel das kaum auf; sobald die
          // Zahl allein steht, liest sich "4 6 9 3 12 24" wie ein Fehler.
          // Kapazitaet bleibt Zweitschluessel.
          .sort((a, b) => (nbNapfzahl(a) - nbNapfzahl(b))
            || (a.eyeshadowEquivalentCapacity - b.eyeshadowEquivalentCapacity));
      } catch (e) {
        return [];
      }
    }

    // Rabattstufe je Groesse -- gleiche Staffel wie maxDiscountEligibility
    // (<=6 small, <=9 medium, <=12 large, sonst extraLarge). Formulierung
    // immer "bis −X %": das ist der Rabatt der VOLLEN Palette. Kleinere Stufen
    // gelten schon vorher (Artikelzahl, siehe discountPercentage), die nennt
    // die Fortschrittszeile in der Preisleiste.
    function nbStufeFuer(palette) {
      try {
        const stufen = window.inlineData.PaletteDesigner.discounts || {};
        const kap = palette.eyeshadowEquivalentCapacity;
        let anteil;
        if (kap <= 6) anteil = stufen.small;
        else if (kap <= 9) anteil = stufen.medium;
        else if (kap <= 12) anteil = stufen.large;
        else anteil = stufen.extraLarge;
        return Math.round((anteil || 0) * 100);
      } catch (e) {
        return 0;
      }
    }

    // ---- 1. Groessenleiste ---------------------------------------------------
    function nbChipsRendern() {
      const leiste = $(".page-palette-designer .nb-size-bar > ul");
      if (!leiste.length) {
        return;
      }
      leiste.empty();
      const aktiv = app.paletteModel.palette;
      for (const p of nbGroessen()) {
        const anzahl = nbNapfzahl(p);
        const ausverkauft = p.availability === "out_of_stock";
        const stufe = nbStufeFuer(p);
        // Zwei Zeilen statt einer: Zahl gross, Einheit klein darunter. Weil
        // alle sechs Pillen dieselbe Einheit tragen, sind sie erstmals gleich
        // breit. Der Produktname "Lethal-24" und das inline stehende
        // Rabattschild waren zusammen der Grund, warum die Leiste 558px Inhalt
        // bei 364px Platz hatte und links wie rechts anschnitt.
        const einheit = ausverkauft
          ? txt("relaunchSizeSoldout", "Sold out")
          : txt("relaunchSizeUnit", "pans");
        const istAktiv = p === aktiv || (aktiv && p.id === aktiv.id);
        // Der Rabatt steht nicht mehr auf der Pille: er hat auf JEDER Groesse
        // einen Wert und unterscheidet sie deshalb nicht. Die Preisleiste sagt
        // ihn ohnehin. Fuer Screenreader bleibt er im Label, zusammen mit dem
        // vollen Produktnamen, den die Pille nicht mehr zeigt.
        const label = p.name
          + " · " + T(txt("relaunchSizePans", "{count} pans"), { count: anzahl })
          + (ausverkauft
            ? " · " + txt("relaunchSizeSoldout", "Sold out")
            : (stufe > 0
              ? " · " + T(txt("relaunchSizeUpto", "up to −{percent}%"), { percent: stufe })
              : ""));
        // BEIDE Beschriftungen ins Markup, CSS zeigt je Bildschirmgroesse eine.
        // Die kompakte Fassung (Zahl plus Einheit) ist eine reine
        // Handy-Entscheidung, damit die sechs Pillen ohne Anschnitt passen.
        // Auf Laptop und Desktop ist Platz, dort bleibt es beim vollen Namen
        // und der Rabattzeile, also genau beim Zustand von vorher.
        const titel = nbGroessenTitel(p);
        const rabattText = ausverkauft
          ? txt("relaunchSizeSoldout", "Sold out")
          : T(txt("relaunchSizeUpto", "up to −{percent}%"), { percent: stufe });
        const knopf = $('<button type="button" class="nb-size-chip no-drag"></button>')
          .attr("aria-label", label)
          .attr("aria-pressed", istAktiv ? "true" : "false")
          .toggleClass("nb-active", istAktiv)
          .append($('<b class="nb-chip-zahl"></b>').text(anzahl))
          .append($('<small class="nb-chip-einheit"></small>').text(einheit))
          .append($('<b class="nb-chip-name"></b>').text(titel))
          .append($('<small class="nb-chip-rabatt"></small>').text(rabattText));
        if (ausverkauft) {
          knopf.attr("disabled", "disabled");
        } else {
          knopf.on("click", () => {
            app.productsViewModel._nbGroesseQuelle = "leiste";
            app.productsViewModel.selectedPalette = p;
          });
          // Absichts-Prefetch: schon beim Hinzeigen/Beruehren die Bilder der
          // Groesse dekodieren -- der eigentliche Tap trifft dann auf einen
          // warmen Cache (Netz fuer den Fall, dass der Leerlauf-Prefetch
          // noch nicht durch ist oder Datensparmodus ihn uebersprungen hat).
          knopf.on("pointerenter pointerdown touchstart", () => nbBilderVorladen(p));
        }
        leiste.append($("<li></li>").append(knopf));
      }
      // Den aktiven Chip in Sicht schieben -- auf dem Handy passen nicht alle
      // Chips in die Reihe, und ausgerechnet die gewaehlte Groesse (Standard
      // Lethal 12, weit rechts) stand sonst halb im Scroll-Verlauf. Nur die
      // Leiste selbst scrollen, nie die Seite (kein scrollIntoView).
      try {
        const aktivKnopf = leiste.find("button.nb-active")[0];
        const ul = leiste[0];
        if (aktivKnopf && ul && ul.scrollWidth > ul.clientWidth) {
          const li = aktivKnopf.parentElement;
          // Nicht exakt zentrieren, sondern auf eine Pillenkante stellen.
          // Zentriert landete die Leiste am rechten Anschlag mitten in einer
          // Pille, links stand dann ein angeschnittenes Wortfragment
          // ("aepfe" statt "4 Naepfe") -- das liest sich wie ein Fehler.
          // Regel: die am weitesten gescrollte Kante nehmen, bei der die
          // aktive Pille noch vollstaendig sichtbar ist. Links steht damit
          // immer eine ganze Pille, angeschnitten wird hoechstens rechts --
          // und dort erwartet man ohnehin, dass es weitergeht.
          const maxScroll = ul.scrollWidth - ul.clientWidth;
          const start = li.offsetLeft;
          const ende = start + li.offsetWidth;
          const passend = Array.prototype.map.call(ul.children, (k) => k.offsetLeft)
            .filter((k) => k <= maxScroll && k <= start && ende <= k + ul.clientWidth);
          ul.scrollLeft = passend.length
            ? Math.max.apply(null, passend)
            : Math.max(0, Math.min(start, maxScroll));
        }
      } catch (e) { /* reine Komfort-Politur */ }
    }

    // ---- 4. Tap-Feedback: zuletzt angetippte Kachel merken -------------------
    let nbLetzteKachel = null;
    // Zuletzt gezeigte "hinzugefuegt"-Bestaetigung, damit immer nur eine steht.
    let nbLetzteMeldung = null;
    let nbLetzteKachelZeit = 0;
    $(document).on("click", ".page-palette-designer .menu .catalogue li", function () {
      nbLetzteKachel = $(this);
      nbLetzteKachelZeit = Date.now();
    });

    // ---- Rueckmeldung im Katalog ---------------------------------------------
    // Im offenen Drawer ist die Palette verdeckt: ohne diese Anzeigen sieht der
    // Kunde ueberhaupt nicht, dass seine Farbe gelandet ist. Deshalb ein
    // Zaehler, der dauerhaft im Kopf des Katalogs mitlaeuft, und ein Haekchen
    // auf jeder Farbe, die schon in der Palette liegt.
    function nbZaehlerAktualisieren() {
      try {
        const menue = $("#palette-designer-nh .menu");
        if (!menue.length) {
          return;
        }
        // Beschrifteter Rueckweg im Kopf des Katalogs. Auf dem Handy nimmt der
        // Katalog die volle Breite ein; ein WORT ist das Einzige, was ein
        // Erstbesucher ohne Symbolwissen als Ausgang liest. Das kleine X in der
        // Fortschrittskapsel war als Ausgang nicht erkennbar (Justin, 01.09.:
        // "niemand wird das checken"). CSS blendet das X unter 700px aus,
        // darueber bleibt alles wie es war (dort ist der Katalog schmal und hat
        // eine sichtbare Lasche). Bewusst KEIN position:sticky: Scroll-Container
        // ist .catalogue, der Kopf ist dessen Geschwister und steht dadurch
        // ohnehin dauerhaft ueber der Liste.
        let kopf = menue.find(".nb-drawer-kopf");
        if (!kopf.length) {
          kopf = $('<div class="nb-drawer-kopf"></div>');
          const zurueck = $('<button type="button" class="nb-drawer-zurueck">' +
            '<span class="nb-zurueck-pfeil" aria-hidden="true">‹</span>' +
            '<span class="nb-zurueck-text"></span></button>');
          const beschriftung = txt("relaunchDrawerBack", "Back to palette");
          zurueck.find(".nb-zurueck-text").text(beschriftung);
          zurueck.attr("aria-label", beschriftung);
          zurueck.on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            try {
              app.productsView.collapseDrawer();
              Broadcast.send("drawerCollapsed", {});
              nbCtaAktualisieren();
            } catch (err) { /* Zuklappen darf nie haengen bleiben */ }
          });
          kopf.append(zurueck);
          menue.prepend(kopf);
        }
        let zeile = menue.find(".nb-drawer-zaehler");
        if (!zeile.length) {
          zeile = $('<div class="nb-drawer-zaehler" role="status" aria-live="polite"><span class="nb-text"></span><span class="nb-balken"><i></i></span></div>');
          const anker = menue.find(".active-filters");
          if (anker.length) {
            anker.after(zeile);
          } else {
            menue.find(".catalogue").before(zeile);
          }
          // Schliessen-Knopf. Auf dem Handy nimmt der Katalog die volle Breite
          // ein, dadurch liegt die Lasche zum Zuklappen ausserhalb des Bildes
          // (nachgemessen bei -36px). Ohne diesen Knopf kommt man nicht mehr
          // zur Palette zurueck -- Justin am 01.09.: "die kann man nicht
          // wieder schliessen, das ist sehr problematisch".
          const zu = $('<button type="button" class="nb-drawer-zu" aria-label="' +
            txt("close", "Close") + '"><span aria-hidden="true">✕</span></button>');
          zu.on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            try {
              app.productsView.collapseDrawer();
              Broadcast.send("drawerCollapsed", {});
              nbCtaAktualisieren();
            } catch (err) { /* Zuklappen darf nie haengen bleiben */ }
          });
          zeile.append(zu);
        }
        const modell = app.paletteModel;
        const basis = modell.palette;
        const anzahl = modell.pans.length;
        let text;
        let anteil;
        if (basis && basis.hasSlots) {
          const gesamt = basis.rows * basis.columns;
          text = T(txt("relaunchDrawerProgress", "{filled} of {total} filled"), { filled: Math.min(anzahl, gesamt), total: gesamt });
          anteil = gesamt ? Math.min(1, anzahl / gesamt) : 0;
        } else {
          text = T(txt("relaunchDrawerProgressFree", "{filled} shades chosen"), { filled: anzahl });
          anteil = modell.isComplete ? 1 : 0.5;
        }
        zeile.find(".nb-text").text(text);
        zeile.find(".nb-balken i").css("width", Math.round(anteil * 100) + "%");
        zeile.toggleClass("nb-voll", !!modell.isComplete);
      } catch (e) { /* Anzeige-Detail */ }
    }
    function nbHaekchenAktualisieren() {
      try {
        const drin = new Set(app.paletteModel.pans.map((p) => p.pan && p.pan.id).filter((x) => x != null));
        $("#palette-designer-nh .menu .catalogue li").each(function () {
          const el = $(this);
          const produkt = el.data("product");
          el.toggleClass("nb-drin", !!(produkt && produkt.type !== "empty_palette" && drin.has(produkt.id)));
        });
        nbStatusTexte();
      } catch (e) { /* Anzeige-Detail */ }
    }
    // Ausverkauft-Kacheln trugen zwei <span> in der figcaption, die sich
    // abwechselten -- im Katalog stand deshalb bei jeder zweiten Kachel
    // "Out of sto...", also weder Produktname noch verstaendlicher Status.
    // Und der Rohtext ist englisch, auch auf der deutschen Seite.
    // Der uebersetzte Status wandert hier in ein data-Attribut; CSS macht
    // daraus auf dem Handy ein Schildchen auf dem Bild und laesst den Namen
    // vollstaendig stehen. Bewusst ueber ein Attribut statt ueber Liquid im
    // CSS: ein .css.liquid-Asset wird von Shopify NICHT pro Sprache gerendert,
    // dort wuerde immer dieselbe Sprache herauskommen.
    function nbStatusTexte() {
      try {
        const text = txt("availabilityListSoldOut", "Sold out");
        // Ein echtes Element statt eines ::after. Grund: Kacheln, die bereits
        // in der Palette liegen (.nb-drin), belegen an ihrem figure schon
        // BEIDE Pseudo-Elemente fuer den gruenen Haken. Ist eine Kachel
        // gleichzeitig ausverkauft und ausgewaehlt, mischten sich die Regeln
        // und das Schildchen rutschte nach oben in den Haken hinein.
        $("#palette-designer-nh .menu .catalogue li.out-of-stock > figure").each(function () {
          let schild = this.querySelector(":scope > .nb-status");
          if (!schild) {
            schild = document.createElement("span");
            schild.className = "nb-status";
            this.appendChild(schild);
          }
          if (schild.textContent !== text) {
            schild.textContent = text;
          }
        });
      } catch (e) { /* Anzeige-Detail */ }
    }

    // ---- 2./4. Coach-Mark ----------------------------------------------------
    let nbCoach = null;
    function nbCoachZeigen() {
      if (nbCoach) {
        return;
      }
      const menue = $(".page-palette-designer .menu");
      if (!menue.length) {
        return;
      }
      nbCoach = $('<div class="nb-coach" role="status"></div>')
        .text(txt("relaunchCoachFirstShade", "Tap a shade to add it to your palette"));
      const anker = menue.find(".active-filters");
      if (anker.length) {
        anker.after(nbCoach);
      } else {
        menue.prepend(nbCoach);
      }
    }
    function nbCoachWeg() {
      if (nbCoach) {
        nbCoach.remove();
        nbCoach = null;
      }
    }
    // Verschwindet erst bei der Zielaktion (erstes erfolgreiches Add, siehe
    // Pans-Listener unten) oder wenn der Kunde den Katalog aktiv schliesst --
    // NICHT beim ersten Scrollen oder Kategorie-Klick.
    Broadcast.receive("drawerCollapsed", nbCoachWeg);

    // ---- Pans-Beobachter: Chips-Sync, Coach-Dismiss, Puls, Toast -------------
    let nbLetzteAnzahl = app.paletteModel.pans.length;
    app.paletteViewModel.onPropertyChanged((eigenschaft) => {
      if (eigenschaft === "palette.palette") {
        // Feuert bei ALLEN Wechsel-Pfaden (Leiste, Katalog, Upgrade-Dialog,
        // Undo/Redo, geteilte Links) -- anders als "selectedPalette", das nur
        // der ViewModel-Setter meldet. Sonst zeigte die Leiste nach einem
        // Upgrade oder Undo die falsche Groesse als aktiv.
        app.paletteModel._nbZielSlot = null;
        nbChipsRendern();
        nbCtaAktualisieren();
        nbZaehlerAktualisieren();
        nbHaekchenAktualisieren();
        return;
      }
      if (eigenschaft === "palette.pans") {
        // Massen-Neuaufbau (Undo/Redo, gespeicherte Palette laden, Reset):
        // laeuft ueber unserialize() und ist KEIN Katalog-Tap -- Zaehler nur
        // still nachziehen, kein Coach-Dismiss, kein Puls, kein Toast.
        nbLetzteAnzahl = app.paletteModel.pans.length;
        nbCtaAktualisieren();
        nbZielMarkerAktualisieren();
        nbZaehlerAktualisieren();
        nbHaekchenAktualisieren();
        return;
      }
      if (eigenschaft !== "palette.pans[]") {
        return;
      }
      nbCtaAktualisieren();
      nbZielMarkerAktualisieren();
      nbZaehlerAktualisieren();
      nbHaekchenAktualisieren();
      const anzahl = app.paletteModel.pans.length;
      const zuwachs = anzahl > nbLetzteAnzahl;
      nbLetzteAnzahl = anzahl;
      if (!zuwachs) {
        return;
      }
      nbCoachWeg();
      if (nbLetzteKachel && Date.now() - nbLetzteKachelZeit < 1500) {
        const kachel = nbLetzteKachel;
        kachel.removeClass("nb-added");
        if (kachel[0]) {
          void kachel[0].offsetWidth; // Animation bei Serien-Taps neu starten
        }
        kachel.addClass("nb-added");
        window.setTimeout(() => kachel.removeClass("nb-added"), 600);
      }
      // Bestaetigung bei JEDEM Hinzufuegen. Frueher nur zweimal je Seitenaufruf
      // -- eine Fehlentscheidung: im offenen Drawer ist die Palette verdeckt,
      // die Meldung ist dort die einzige Rueckmeldung ueberhaupt und keine
      // einmalige Lernhilfe (Justin, 01.09.).
      try {
        const letzter = app.paletteModel.pans[anzahl - 1];
        const name = letzter && letzter.pan && letzter.pan.name;
        if (name) {
          // Immer nur die JUENGSTE Bestaetigung stehen lassen. Wer schnell
          // mehrere Farben antippt, hatte sonst drei bis vier gestapelte
          // Kaesten ueber Knopfreihe und "Farben waehlen" liegen -- die
          // Bestaetigung verdeckte genau das, was man als Naechstes braucht.
          // Bewusst nur die eigene Vorgaengermeldung entfernen, damit
          // Warnungen (ausverkauft, Fehler) stehen bleiben.
          if (nbLetzteMeldung && nbLetzteMeldung.parentNode) {
            nbLetzteMeldung.parentNode.removeChild(nbLetzteMeldung);
          }
          nbLetzteMeldung = null;
          Notification.show(T(txt("relaunchAddedToast", "{name} added"), { name }));
          nbLetzteMeldung = document.querySelector("#notification-container > *");
        }
      } catch (e) { /* Anzeige-Detail */ }
    });

    // ---- 3. "?"-Hilfe --------------------------------------------------------
    $(".page-palette-designer .buttons button.help").on("click", async () => {
      try { nbMessen("byop_hilfe_geoeffnet", {}); } catch (e) { /* messen darf nie blockieren */ }
      try {
        const modal = new ModalWindow2("36em", "auto", {
          headline: txt("relaunchHelpTitle", "How it works"),
          closeButton: true,
          buttons: [{ caption: txt("relaunchHelpGotIt", "Got it"), data: true }]
        });
        const inhalt = $("<div></div>");
        const liste = $('<ul class="nb-help-list"></ul>');
        [
          ["relaunchHelpTap", "Tap a shade in the catalogue to add it to your palette."],
          ["relaunchHelpDrag", "Drag pans inside the palette to rearrange them."],
          ["relaunchHelpHold", "Press and hold a shade to see its details."],
          ["relaunchHelpDiscount", "Full palettes save automatically - the bigger, the more (up to -20%)."]
        ].forEach(([schluessel, rueckfall]) => {
          liste.append($("<li></li>").text(txt(schluessel, rueckfall)));
        });
        inhalt.append(liste);
        inhalt.append($('<p class="nb-help-note"></p>')
          .text(txt("relaunchHelpAutosave", "Your palette is saved automatically on this device. Log in to keep it everywhere.")));
        modal.append(inhalt);
        await modal.show();
        modal.remove();
      } catch (e) { /* Hilfe darf den Designer nie brechen */ }
    });

    // ---- 2. Erststart --------------------------------------------------------
    function nbIntroFertig(palette) {
      $(document).off("keydown.nbIntro");
      try {
        localStorage.setItem("lc_byop_intro_v1", "1");
      } catch (e) { /* Privatmodus */ }
      $(".page-palette-designer .nb-intro").prop("hidden", true);
      // Waehrend des Intros koennen resize-Events mit verdeckter Flaeche
      // gelaufen sein -- einmal sauber nachmessen lassen.
      window.dispatchEvent(new Event("resize"));
      // "Farben waehlen" blendet nur ein, solange das Intro NICHT offen ist.
      // Ohne diesen Aufruf blieb der Knopf nach dem Schliessen des Intros
      // versteckt -- auf dem Handy stand die Buehne dann ganz ohne sichtbare
      // Hauptaktion da (beim Nachmessen am 01.09. aufgefallen).
      nbCtaAktualisieren();
      if (!palette) {
        try { nbMessen("byop_erststart_uebersprungen", {}); } catch (e) { /* messen darf nie blockieren */ }
        return;
      }
      app.productsViewModel._nbGroesseQuelle = "erststart";
      app.productsViewModel.selectedPalette = palette;
      try {
        const farben = app.productsViewModel.categories && app.productsViewModel.categories[1];
        if (farben && !farben.isExpanded) {
          farben.isExpanded = true;
        }
      } catch (e) { /* Kategorie-Aufklappen ist nur Komfort */ }
      // BEWUSST KEIN automatisches Oeffnen des Katalogs mehr (Justins Kritik
      // 30.08., gestuetzt von Apple-Watch-/Function-of-Beauty-Flow und Apple
      // HIG "Bewegung nur als Reaktion auf Nutzeraktion"): Der Kunde sieht
      // erst SEINE Palette aufklappen -- der Gaensehaut-Moment --, der erste
      // freie Napf pulsiert, und der grosse "Farben waehlen"-Knopf ist der
      // explizite naechste Schritt. Der Katalog-Coach erscheint beim ersten
      // tatsaechlichen Oeffnen.
      nbCoachAusstehend = true;
      nbCtaAktualisieren();
      nbZielMarkerAktualisieren();
    }

    // Liegt ein FREMDER Vollflaechen-Dialog ueber dem Erststart-Fenster? Am
    // 10.09. gemessen: das Klaviyo-Fenster (position fixed, z-index 90000)
    // deckt den ganzen Bildschirm ab, und ein Escape schloss beides, weil
    // unser Handler am document haengt. Der Besucher wollte nur das Fenster
    // wegdruecken und verlor dabei die Groessenwahl.
    // Absichtlich herstellerunabhaengig: geprueft werden Dialogrollen und
    // Klaviyos Wurzelklasse, nicht ein einzelner Selektor. Randleisten
    // (Zustimmung, Gratis-Pinsel-Teaser) zaehlen NICHT, sie verschlucken kein
    // Escape; deshalb die Flaechenschwelle.
    function nbFremdesOverlayOffen() {
      try {
        const intro = document.querySelector(".page-palette-designer .nb-intro");
        const grenze = intro ? (parseInt(window.getComputedStyle(intro).zIndex, 10) || 0) : 6000;
        const viewport = window.innerWidth * window.innerHeight;
        if (!viewport) {
          return false;
        }
        const kandidaten = document.querySelectorAll(
          'body [role="dialog"], body [aria-modal="true"], body [class*="kl-private-reset"]'
        );
        for (let i = 0; i < kandidaten.length; i++) {
          const el = kandidaten[i];
          if (intro && (el === intro || intro.contains(el))) {
            continue;
          }
          const stil = window.getComputedStyle(el);
          if (stil.position !== "fixed" || stil.display === "none" || stil.visibility === "hidden") {
            continue;
          }
          if (parseFloat(stil.opacity) === 0) {
            continue;
          }
          if ((parseInt(stil.zIndex, 10) || 0) <= grenze) {
            continue;
          }
          const r = el.getBoundingClientRect();
          if (r.width * r.height >= viewport * 0.6) {
            return true;
          }
        }
      } catch (e) { /* im Zweifel wie bisher verhalten */ }
      return false;
    }

    function nbIntroStart() {
      const overlay = $(".page-palette-designer .nb-intro");
      if (!overlay.length) {
        return;
      }
      const qs = new URLSearchParams(window.location.search);
      const erzwungen = qs.get("onboarding") === "1";
      let gesehen = false;
      try {
        gesehen = !!localStorage.getItem("lc_byop_intro_v1");
      } catch (e) { /* Privatmodus: lieber kein Intro als bei jedem Besuch */ gesehen = true; }
      const hatKontext = qs.has("pd") || qs.has("p");
      let hatGespeicherte = false;
      try {
        hatGespeicherte = !!(app.userModel && app.userModel.lastSavedPalette);
      } catch (e) { /* dann gilt: Erstbesucher */ }
      // Nur echte Erstbesucher: wer mit geteiltem Link kommt oder schon eine
      // Palette hat, will weiterbauen, nicht begruesst werden.
      if (!erzwungen && (gesehen || hatKontext || hatGespeicherte)) {
        return;
      }
      const liste = overlay.find(".nb-intro-sizes");
      liste.empty();
      for (const p of nbGroessen()) {
        const ausverkauft = p.availability === "out_of_stock";
        const titel = nbGroessenTitel(p);
        let klein;
        if (ausverkauft) {
          klein = txt("relaunchSizeSoldout", "Sold out");
        } else {
          klein = formatPrice(p.price) + " · " + T(txt("relaunchSizeUpto", "up to −{percent}%"), { percent: nbStufeFuer(p) });
        }
        const karte = $('<button type="button" class="nb-size-card"></button>')
          .attr("aria-label", p.name)
          .append($('<span class="nb-size-img" aria-hidden="true"></span>').css("background-image", "url(" + p.image + ")"))
          .append($("<b></b>").text(titel))
          .append($("<small></small>").text(klein));
        if (ausverkauft) {
          karte.attr("disabled", "disabled");
        } else {
          karte.on("click", () => nbIntroFertig(p));
        }
        liste.append($("<li></li>").append(karte));
      }
      overlay.find(".nb-intro-skip").off("click").on("click", () => nbIntroFertig(null));
      overlay.prop("hidden", false);
      try { nbMessen("byop_erststart_gezeigt", {}); } catch (e) { /* messen darf nie blockieren */ }
      // role=dialog haelt, was es verspricht: Fokus in den Dialog setzen und
      // Escape wie "Ohne Auswahl starten" behandeln.
      const ersteKarte = overlay.find("button.nb-size-card:not([disabled])").first();
      (ersteKarte.length ? ersteKarte : overlay.find(".nb-intro-skip")).trigger("focus");
      $(document).on("keydown.nbIntro", (e) => {
        if (e.key !== "Escape") {
          return;
        }
        // Dieses Escape gehoert dem fremden Dialog, nicht der Groessenwahl.
        if (nbFremdesOverlayOffen()) {
          return;
        }
        nbIntroFertig(null);
      });
    }

    // ---- Ziel-Napf: Tap auf leeren Napf setzt das Ziel ---------------------
    // Der Marker zeigt IMMER den naechsten Platz (explizites Ziel oder erster
    // freier Napf) -- pulsiert kurz nach jeder Aenderung (2 Zyklen, dann
    // statisch; Dauerpuls ermuedet).
    function nbZielMarkerAktualisieren() {
      try {
        // WICHTIG: .preview > .base (direktes Kind). Der Spiegel im Deckel
        // KLONT die komplette Basis samt Slots und data-Attributen -- und
        // .top-lid steht im DOM VOR .base: ein unscharfer Selektor traefe
        // zuerst die toten Spiegel-Klone und markierte das Spiegelbild.
        const slots = $(".preview > .base > .slots > .slot");
        slots.removeClass("nb-ziel");
        const basis = app.paletteModel.palette;
        if (!basis || !basis.hasSlots) {
          return;
        }
        const belegt = new Set(app.paletteModel.pans.map((p) => p.slotIndex));
        let ziel = app.paletteModel._nbZielSlot;
        if (ziel == null || belegt.has(ziel)) {
          ziel = null;
          for (let i = 0; i < basis.rows * basis.columns; i++) {
            if (!belegt.has(i)) { ziel = i; break; }
          }
          app.paletteModel._nbZielSlot = null;
        }
        if (ziel != null) {
          const el = slots.eq(ziel);
          el.addClass("nb-ziel");
          if (el[0]) {
            void el[0].offsetWidth; // Puls-Animation neu anstossen
          }
        }
      } catch (e) { /* Marker ist Komfort */ }
    }
    Broadcast.receive("nbSlotsNeu", () => nbZielMarkerAktualisieren());
    Broadcast.receive("nbSlotTap", (daten) => {
      try {
        const basis = app.paletteModel.palette;
        if (!basis || !basis.hasSlots) {
          return;
        }
        const belegt = app.paletteModel.pans.some((p) => p.slotIndex === daten.index);
        if (belegt) {
          return; // befuellte Naepfe behalten ihr bisheriges Verhalten (Drag, Doppel-Tap)
        }
        app.paletteModel._nbZielSlot = daten.index;
        nbZielMarkerAktualisieren();
        // Im Drawer-Modus oeffnet der Napf-Tap direkt den Katalog -- die
        // naechste angetippte Farbe landet genau in diesem Napf.
        if (app.productsView && app.productsView._viewStyle === "drawer") {
          app.productsView.expandDrawer();
          Broadcast.send("drawerExpanded", {});
        }
      } catch (e) { /* Napf-Tap ist Komfort */ }
    });

    // ---- "Farben waehlen"-Knopf (mobil): der explizite naechste Schritt ----
    function nbCtaAktualisieren() {
      try {
        const cta = $(".page-palette-designer .nb-farben-cta");
        if (!cta.length) {
          return;
        }
        const istDrawer = app.productsView && app.productsView._viewStyle === "drawer";
        const offen = $("#palette-designer-nh .menu").hasClass("expanded");
        const introOffen = !$(".page-palette-designer .nb-intro").prop("hidden");
        const modell = app.paletteModel;
        const basis = modell.palette;
        const fertig = modell.isComplete;
        const zeigen = istDrawer && !offen && !introOffen && !fertig;
        cta.prop("hidden", !zeigen);
        if (zeigen && basis && basis.hasSlots) {
          const gesamt = basis.rows * basis.columns;
          cta.find("span").text(txt("relaunchCta", "Choose shades") + " · " + Math.min(modell.pans.length, gesamt) + "/" + gesamt);
        } else if (zeigen) {
          cta.find("span").text(txt("relaunchCta", "Choose shades"));
        }
      } catch (e) { /* CTA ist Komfort */ }
    }
    $(".page-palette-designer .nb-farben-cta").on("click", () => {
      try {
        app.productsView.expandDrawer();
        Broadcast.send("drawerExpanded", {});
        nbCtaAktualisieren();
      } catch (e) { /* Lasche bleibt als Weg */ }
    });
    // Relaunch (03.09.): Vor einem bestaetigten Palettenwechsel ("Palette
    // vergroessern", Gesichtspuder-Hinweis) klappt der Katalog am Handy zu,
    // damit die Wechsel-Animation auf der Buehne zu sehen ist.
    Broadcast.receive("nbPassungPruefen", (data) => {
      try {
        const vm = app.productsView && app.productsView.viewModel;
        if (vm && typeof vm.nbPruefePassung === "function" && data && data.pan) vm.nbPruefePassung(data.pan);
      } catch (e) { /* Hinweis ist Komfort */ }
    });
    Broadcast.receive("nbKatalogZuklappen", () => {
      try {
        app.productsView.collapseDrawer();
        Broadcast.send("drawerCollapsed", {});
        nbCtaAktualisieren();
      } catch (e) { /* Zuklappen darf nie haengen bleiben */ }
    });
    let nbCoachAusstehend = false;
    // Drawer-Zustand beobachten (Zuklappen beim Drag-Start laeuft ohne
    // Broadcast -- deshalb am Klassenattribut, nicht an Events).
    try {
      const menue = document.querySelector("#palette-designer-nh .menu");
      // Schleier neben dem Katalog: zweiter Rueckweg und sichtbarer Hinweis,
      // dass die Palette dahinter weiterliegt. Antippen schliesst.
      try {
        const wurzel = document.querySelector(".page-palette-designer");
        if (wurzel && !wurzel.querySelector(".nb-drawer-schleier")) {
          const schleier = document.createElement("div");
          schleier.className = "nb-drawer-schleier";
          schleier.setAttribute("aria-hidden", "true");
          schleier.addEventListener("click", () => {
            try {
              app.productsView.collapseDrawer();
              Broadcast.send("drawerCollapsed", {});
              nbCtaAktualisieren();
            } catch (e) { /* Zuklappen darf nie haengen bleiben */ }
          });
          wurzel.appendChild(schleier);
        }
      } catch (e) { /* Schleier ist Komfort */ }
      new MutationObserver(() => {
        nbCtaAktualisieren();
        // Zustandsklasse an der Wurzel, damit der Schleier (ein Geschwister
        // ausserhalb von .menu) auf den Katalogzustand reagieren kann.
        try {
          document.querySelector(".page-palette-designer")
            .classList.toggle("nb-katalog-offen", menue.classList.contains("expanded"));
        } catch (e) { /* reine Optik */ }
        if (menue.classList.contains("expanded")) {
          // Der Katalog baut seine Kacheln erst beim Oeffnen -- die Status-
          // Schildchen muessen deshalb hier nachgezogen werden, nicht nur
          // beim Aendern der Palette.
          nbStatusTexte();
          if (nbCoachAusstehend) {
            nbCoachAusstehend = false;
            nbCoachZeigen();
          }
        }
      }).observe(menue, { attributes: true, attributeFilter: ["class"] });
      // Und wenn der Katalog seine Liste neu aufbaut (Suche, Filter, Sortierung).
      // Entprellt, weil dieser Beobachter bei jeder einzelnen eingefuegten
      // Kachel feuert -- ungebremst waere das pro Filterwechsel ein paar
      // hundert Durchlaeufe ueber die ganze Liste.
      let statusTimer = null;
      new MutationObserver(() => {
        if (statusTimer) {
          return;
        }
        statusTimer = setTimeout(() => {
          statusTimer = null;
          nbStatusTexte();
        }, 120);
      }).observe(menue, { childList: true, subtree: true });
    } catch (e) { /* Beobachter ist Komfort */ }

    // ---- Prefetch: Groessenwechsel ohne Netz- und Decode-Wartezeit ---------
    const nbVorgeladen = new Set();
    function nbBilderVorladen(palette) {
      try {
        if (!palette || !app.paletteView || nbVorgeladen.has(palette.id)) {
          return;
        }
        nbVorgeladen.add(palette.id);
        const { liste } = app.paletteView._nbBildlisteFuer(palette);
        for (const url of liste) {
          const bild = new Image();
          bild.src = url;
          if (typeof bild.decode === "function") {
            bild.decode().catch(() => {});
          }
        }
      } catch (e) { /* Prefetch ist Komfort */ }
    }
    function nbSparsameVerbindung() {
      try {
        const v = navigator.connection;
        return !!(v && (v.saveData || /(^|-)2g$/.test(v.effectiveType || "")));
      } catch (e) {
        return false;
      }
    }
    // Nach dem ersten Aufbau alle Groessen im Leerlauf dekodieren -- dann ist
    // jeder Chip-Tap sofort scharf. Bei Datensparmodus/2G unterbleibt das;
    // dort greift der Pointer-Prefetch direkt am Chip als Netz.
    window.setTimeout(() => {
      if (nbSparsameVerbindung()) {
        return;
      }
      const leerlauf = window.requestIdleCallback || ((f) => window.setTimeout(f, 800));
      leerlauf(() => {
        const groessen = nbGroessen();
        let i = 0;
        const naechste = () => {
          if (i >= groessen.length) return;
          nbBilderVorladen(groessen[i++]);
          window.setTimeout(naechste, 350);
        };
        naechste();
      });
    }, 4000);

    // ---- Ladeflaeche: erst freigeben, wenn der Designer WIRKLICH steht ----
    // Vorher lief der Aufbau offen sichtbar ab (Text des Surprise-me-Panels
    // blitzte durch, leere Buehne mit 0,00 EUR, leere weisse Katalogspalte,
    // dann kam Stueck fuer Stueck der Rest). Jetzt zeigt die Seite bis dahin
    // eine ruhige Ladeflaeche in Buehnenfarbe.
    (function nbFreigabe() {
      const wurzel = document.getElementById("palette-designer-nh");
      if (!wurzel) {
        return;
      }
      const flaeche = wurzel.querySelector(".nb-ladeflaeche");
      let fertig = false;
      const freigeben = () => {
        if (fertig) {
          return;
        }
        fertig = true;
        wurzel.classList.add("nb-bereit");
        if (flaeche) {
          flaeche.classList.add("nb-weg");
          window.setTimeout(() => flaeche.setAttribute("hidden", "hidden"), 300);
        }
        // Die Flaeche stand ueber der Buehne: einmal sauber nachmessen lassen.
        window.dispatchEvent(new Event("resize"));
      };
      const bereit = () => {
        // Palette eingeblendet UND Naepfe/Katalog aufgebaut.
        const preview = document.querySelector(".preview");
        const slots = document.querySelectorAll(".preview > .base > .slots > .slot").length;
        const katalog = document.querySelectorAll(".menu .catalogue li.category").length;
        return !!preview && preview.classList.contains("visible") && slots > 0 && katalog > 0;
      };
      const start = Date.now();
      const pruefen = () => {
        if (bereit()) {
          // Ein Bildaufbau Puffer, damit wirklich alles gezeichnet ist.
          window.requestAnimationFrame(() => window.requestAnimationFrame(freigeben));
          return;
        }
        // Eigenes Netz (das harte in byop.liquid greift erst bei 8 s).
        if (Date.now() - start > 6000) {
          freigeben();
          return;
        }
        window.setTimeout(pruefen, 60);
      };
      pruefen();
    })();

    nbChipsRendern();
    nbIntroStart();
    nbCtaAktualisieren();
    nbZielMarkerAktualisieren();
    nbZaehlerAktualisieren();
    nbHaekchenAktualisieren();
    // Der Katalog baut seine Kacheln beim Aufklappen neu -- Haekchen nachziehen.
    Broadcast.receive("drawerExpanded", () => window.setTimeout(nbHaekchenAktualisieren, 60));
    // "drawerExpanded" feuert nur, wenn die Schublade tatsaechlich aufklappt:
    // die Lasche (.expand-button) ist nur im Drawer-Modus (Handy/Tablet)
    // sichtbar, am Desktop steht der Katalog als feste Spalte und dieser
    // Pfad wird nie ausgeloest.
    Broadcast.receive("drawerExpanded", () => { try { nbMessen("byop_katalog_geoeffnet", {}); } catch (e) { /* messen darf nie blockieren */ } });
  }

  // Vorberechnete Rangfolge fuer die "Nach Farbe"-Sortierung. Wie eine gute
  // Farbkarte: erst Farbbloecke in fester Reihenfolge (pink -> rot -> orange
  // -> gelb -> gruen -> teal -> blau -> lila), dann Braun/Nude als eigener
  // Block (ohne diese Regel zoege deltaE das halbe gedeckte Sortiment zu
  // "rot"/"orange", weil die Anker vollgesaettigt sind), zum Schluss die
  // Neutralen (grau -> weiss -> schwarz). Innerhalb jedes Blocks
  // Nachbarschafts-Kette ueber die wahrgenommene Distanz (deltaE auf Lab),
  // gestartet beim hellsten Ton -- so entstehen weiche Verlaeufe statt des
  // frueheren Hue-Zickzacks. Einmalig beim Aufbau, O(n^2) bei ~135 Farben.
  function nbFarbRaengeBerechnen(productsModel) {
    const bloecke = ["pink", "red", "orange", "yellow", "green", "teal", "blue", "purple", "brown", "grey", "white", "black"];
    const gruppen = new Map(bloecke.map((b) => [b, []]));
    for (const p of productsModel.asArray()) {
      if (!p || p instanceof PaletteModel || !p.color || !p.color.lab || !p.color.hsl) {
        continue;
      }
      const hsl = p.color.hsl;
      const lab = p.color.lab;
      const hue = hsl[0] * 360;
      let block = p.color.canonical;
      if (hsl[1] < 0.15 || lab[0] < 12 || lab[0] > 92) {
        block = lab[0] > 92 ? "white" : lab[0] < 12 ? "black" : "grey";
      } else if (hue >= 5 && hue <= 50 && hsl[1] < 0.55 && hsl[2] < 0.55) {
        block = "brown";
      }
      if (!gruppen.has(block)) {
        block = "grey";
      }
      gruppen.get(block).push(p);
    }
    let rang = 0;
    for (const b of bloecke) {
      const rest = gruppen.get(b).slice()
        .sort((x, y) => y.color.lab[0] - x.color.lab[0] || x.name.localeCompare(y.name));
      let aktuell = rest.shift();
      while (aktuell) {
        aktuell.__nbFarbRang = rang++;
        let besterIndex = -1;
        let besteDistanz = Infinity;
        for (let i = 0; i < rest.length; i++) {
          const d = deltaE(aktuell.color.lab, rest[i].color.lab);
          if (d < besteDistanz) {
            besteDistanz = d;
            besterIndex = i;
          }
        }
        aktuell = besterIndex >= 0 ? rest.splice(besterIndex, 1)[0] : null;
      }
    }
  }

  var nbApp = new PaletteDesigner();
  try { window.lcPaletteDesigner = { app: nbApp, meldung: function (k, t) { Notification.show(k, t); }, messen: nbMessen }; } catch (e) { /* Zugang fuer lc-konfigurator-zugabe.js */ } /* LC Nr. 17 */
  try {
    nbRelaunchInit(nbApp);
  } catch (e) {
    // Der Relaunch ist Zusatzkomfort: scheitert er, laeuft der Designer wie vor
    // dem Umbau weiter.
    console.error("nbRelaunch konnte nicht starten", e);
    // Damit dieser Satz auch stimmt: die Ladeflaeche haengt an der Klasse
    // nb-bereit, und die setzt erst nbFreigabe ganz am Ende des Aufbaus.
    // Wirft irgendetwas davor, bliebe die ganze Seite verdeckt, bis das harte
    // Netz in byop.liquid nach 8 Sekunden greift. Genau der Fall (Skriptfehler,
    // Werbeblocker, abgebrochener Download) ist der teuerste. Deshalb hier
    // sofort freigeben: der Kunde sieht dann den Designer im Zustand von vor
    // dem Umbau statt acht Sekunden lang eine dunkle Flaeche.
    try {
      const wurzel = document.getElementById("palette-designer-nh");
      if (wurzel) {
        wurzel.classList.add("nb-bereit");
        const flaeche = wurzel.querySelector(".nb-ladeflaeche");
        if (flaeche) {
          flaeche.setAttribute("hidden", "hidden");
        }
      }
    } catch (e2) { /* mehr als versuchen geht hier nicht */ }
  }
})();